import { ERC20Token, ChainId, WFIRE, WETH9, WBNB, WMATIC, WCRO, WAVAX, WFTM, WCELO, WBONE, WPLS, WXN, WONE, WCET, WDOGE, WGRAM, WETC, WFSN, WHT, WKCS, WKLAY, WOKT, WTFUEL, WULX, WGLMR, WMOVR, WDEV, WXDAI, WMETIS, WTLOS, WSYS, WIOTX, WSDN, WASTR, WSBY, WFUSE, WVLX, WREI, WKEK, WTOMO, WTT, WWAN, WRBTC, WELA, WCFX, WBRISE, WMUU, WCANTO, WROSE, WVS, WFITFI, WMTR, WPCKB, WCLO, WEVMOS, WEWT, WKAVA, WCLV, WDFI, WBRO, WFIL, WFLR, WTARA, WBOBA, WBTT, WCMP, WCORE, WCUBE, WCRAB, WPRING, WDIODE, WGO, WISLM, WKAI, WMETA, WKAL, WPALM, WPOLIS, WSHIB, WBCH, WSGB, WTCH, WUBQ, WVET, WXDC, WXRP, WZETA, WZYX } from '@donaswap/sdk';

// src/common.ts
var USDT_FIRECHAIN = new ERC20Token(
  ChainId.FIRECHAIN,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_FIRECHAIN = new ERC20Token(
  ChainId.FIRECHAIN,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_FIRECHAIN = new ERC20Token(
  ChainId.FIRECHAIN,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_FIRECHAIN = new ERC20Token(
  ChainId.FIRECHAIN,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_RINIA = new ERC20Token(
  ChainId.RINIA,
  "0x56aF0455da18e5F45F013c7853b3669f0560d181",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_RINIA = new ERC20Token(
  ChainId.RINIA,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_RINIA = new ERC20Token(
  ChainId.RINIA,
  "0x5dfCf2674af93B7155b65c7084dce9353d704915",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_RINIA = new ERC20Token(
  ChainId.RINIA,
  "0xe46C36A43200b94bD0aC3a52d5C76172Ad1a217d",
  18,
  "FLAME",
  "Flame Token",
  "https://donaswap.io/"
);
var USDT_FIRECHAIN_ZKEVM = new ERC20Token(
  ChainId.FIRECHAIN_ZKEVM,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_FIRECHAIN_ZKEVM = new ERC20Token(
  ChainId.FIRECHAIN_ZKEVM,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_FIRECHAIN_ZKEVM = new ERC20Token(
  ChainId.FIRECHAIN_ZKEVM,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_FIRECHAIN_ZKEVM = new ERC20Token(
  ChainId.FIRECHAIN_ZKEVM,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_FIRECHAIN_ZKEVM_GHOSTRIDER = new ERC20Token(
  ChainId.FIRECHAIN_ZKEVM_GHOSTRIDER,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_FIRECHAIN_ZKEVM_GHOSTRIDER = new ERC20Token(
  ChainId.FIRECHAIN_ZKEVM_GHOSTRIDER,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_FIRECHAIN_ZKEVM_GHOSTRIDER = new ERC20Token(
  ChainId.FIRECHAIN_ZKEVM_GHOSTRIDER,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_FIRECHAIN_ZKEVM_GHOSTRIDER = new ERC20Token(
  ChainId.FIRECHAIN_ZKEVM_GHOSTRIDER,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var FLAME_MAINNET = new ERC20Token(
  ChainId.BSC,
  "0x229C32460c6BeaC113e720ac4a7495b57F53F7Cf",
  9,
  "FLAME (Coming Soon)",
  "Flame Token",
  "https://app.donaswap.io/"
);
var DONA_BSC = new ERC20Token(
  ChainId.BSC,
  "0x229C32460c6BeaC113e720ac4a7495b57F53F7Cf",
  9,
  "DONA",
  "Donaswap Token",
  "https://app.donaswap.io/"
);
var USDC_BSC = new ERC20Token(
  ChainId.BSC,
  "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d",
  18,
  "USDC",
  "Binance-Peg USD Coin",
  "https://www.centre.io/usdc"
);
var USDT_BSC = new ERC20Token(
  ChainId.BSC,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_BSC = new ERC20Token(
  ChainId.BSC,
  "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_TESTNET = new ERC20Token(
  ChainId.BSC,
  "0x6D6F6Bb5b939cb889Af411B01682fB52DCF8A4b0",
  9,
  "DONA",
  "Donaswap Token",
  "https://app.donaswap.io/"
);
var FLAME_TESTNET = new ERC20Token(
  ChainId.BSC_TESTNET,
  "0xe46C36A43200b94bD0aC3a52d5C76172Ad1a217d",
  18,
  "FLAME",
  "Flame Token",
  "https://donaswap.io/"
);
var USDC_TESTNET = new ERC20Token(
  ChainId.BSC_TESTNET,
  "0x64544969ed7EBf5f083679233325356EbE738930",
  18,
  "USDC",
  "Binance-Peg USD Coin",
  "https://www.centre.io/usdc"
);
var BUSD_TESTNET = new ERC20Token(
  ChainId.BSC_TESTNET,
  "0xaB1a4d4f1D656d2450692D237fdD6C7f9146e814",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var FLAME_ETH = new ERC20Token(
  ChainId.ETHEREUM,
  "0x152649eA73beAb28c5b49B26eb48f7EAD6d4c898",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var DONA_ETH = new ERC20Token(
  ChainId.ETHEREUM,
  "0x229C32460c6BeaC113e720ac4a7495b57F53F7Cf",
  9,
  "DONA",
  "Donaswap Token",
  "https://app.donaswap.io/"
);
var USDC_ETH = new ERC20Token(
  ChainId.ETHEREUM,
  "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
  6,
  "USDC",
  "USD Coin"
);
var USDT_ETH = new ERC20Token(
  ChainId.ETHEREUM,
  "0xdAC17F958D2ee523a2206206994597C13D831ec7",
  6,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_ETH = new ERC20Token(
  ChainId.ETHEREUM,
  "0x4Fabb145d64652a948d72533023f6E7A623C7C53",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var FLAME_GOERLI = new ERC20Token(
  ChainId.GOERLI,
  "0xc2C3eAbE0368a2Ea97f485b03D1098cdD7d0c081",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var DONA_GOERLI = new ERC20Token(
  ChainId.GOERLI,
  "0x229C32460c6BeaC113e720ac4a7495b57F53F7Cf",
  9,
  "DONA",
  "Donaswap Token",
  "https://app.donaswap.io/"
);
var USDC_GOERLI = new ERC20Token(
  ChainId.GOERLI,
  "0x07865c6E87B9F70255377e024ace6630C1Eaa37F",
  6,
  "tUSDC",
  "test USD Coin"
);
var BUSD_GOERLI = new ERC20Token(
  ChainId.GOERLI,
  "0xb809b9B2dc5e93CB863176Ea2D565425B03c0540",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var USDT_SEPOLIA = new ERC20Token(
  ChainId.SEPOLIA,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_SEPOLIA = new ERC20Token(
  ChainId.SEPOLIA,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_SEPOLIA = new ERC20Token(
  ChainId.SEPOLIA,
  "0x1295d167b07Bb0b8D5AcF5D89eC3623C9FF3B011",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_SEPOLIA = new ERC20Token(
  ChainId.SEPOLIA,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_HOLESKY = new ERC20Token(
  ChainId.HOLESKY,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_HOLESKY = new ERC20Token(
  ChainId.HOLESKY,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_HOLESKY = new ERC20Token(
  ChainId.HOLESKY,
  "0x1295d167b07Bb0b8D5AcF5D89eC3623C9FF3B011",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_HOLESKY = new ERC20Token(
  ChainId.HOLESKY,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_POLYGON = new ERC20Token(
  ChainId.POLYGON,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_POLYGON = new ERC20Token(
  ChainId.POLYGON,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_POLYGON = new ERC20Token(
  ChainId.POLYGON,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_POLYGON = new ERC20Token(
  ChainId.POLYGON,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_AMOY = new ERC20Token(
  ChainId.POLYGON_AMOY,
  "0x8C838A8cA0972e9D51f5B9fD3ADF59D85be21688",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_AMOY = new ERC20Token(
  ChainId.POLYGON_AMOY,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_AMOY = new ERC20Token(
  ChainId.POLYGON_AMOY,
  "0xD3461635A9BEC370F71fd9c3eF6b4b79185AfDfD",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_AMOY = new ERC20Token(
  ChainId.POLYGON_AMOY,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_POLYGON_ZKEVM = new ERC20Token(
  ChainId.POLYGON_ZKEVM,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_POLYGON_ZKEVM = new ERC20Token(
  ChainId.POLYGON_ZKEVM,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_POLYGON_ZKEVM = new ERC20Token(
  ChainId.POLYGON_ZKEVM,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_POLYGON_ZKEVM = new ERC20Token(
  ChainId.POLYGON_ZKEVM,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_POLYGON_ZKEVM_TESTNET = new ERC20Token(
  ChainId.POLYGON_ZKEVM_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_POLYGON_ZKEVM_TESTNET = new ERC20Token(
  ChainId.POLYGON_ZKEVM_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_POLYGON_ZKEVM_TESTNET = new ERC20Token(
  ChainId.POLYGON_ZKEVM_TESTNET,
  "0xD3461635A9BEC370F71fd9c3eF6b4b79185AfDfD",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_POLYGON_ZKEVM_TESTNET = new ERC20Token(
  ChainId.POLYGON_ZKEVM_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_CRO = new ERC20Token(
  ChainId.CRO,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_CRO = new ERC20Token(
  ChainId.CRO,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_CRO = new ERC20Token(
  ChainId.CRO,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_CRO = new ERC20Token(
  ChainId.CRO,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_CRO_TESTNET = new ERC20Token(
  ChainId.CRO_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_CRO_TESTNET = new ERC20Token(
  ChainId.CRO_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_CRO_TESTNET = new ERC20Token(
  ChainId.CRO_TESTNET,
  "0x9622b9DDce346D209246cAcB935C6C1CCad783e5",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_CRO_TESTNET = new ERC20Token(
  ChainId.CRO_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_AVALANCHE = new ERC20Token(
  ChainId.AVALANCHE,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_AVALANCHE = new ERC20Token(
  ChainId.AVALANCHE,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_AVALANCHE = new ERC20Token(
  ChainId.AVALANCHE,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_AVALANCHE = new ERC20Token(
  ChainId.AVALANCHE,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_FUJI = new ERC20Token(
  ChainId.AVALANCHE_FUJI,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_FUJI = new ERC20Token(
  ChainId.AVALANCHE_FUJI,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_FUJI = new ERC20Token(
  ChainId.AVALANCHE_FUJI,
  "0x9622b9DDce346D209246cAcB935C6C1CCad783e5",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_FUJI = new ERC20Token(
  ChainId.AVALANCHE_FUJI,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_FANTOM_OPERA = new ERC20Token(
  ChainId.FANTOM_OPERA,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_FANTOM_OPERA = new ERC20Token(
  ChainId.FANTOM_OPERA,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_FANTOM_OPERA = new ERC20Token(
  ChainId.FANTOM_OPERA,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_FANTOM_OPERA = new ERC20Token(
  ChainId.FANTOM_OPERA,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_FANTOM_TESTNET = new ERC20Token(
  ChainId.FANTOM_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_FANTOM_TESTNET = new ERC20Token(
  ChainId.FANTOM_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_FANTOM_TESTNET = new ERC20Token(
  ChainId.FANTOM_TESTNET,
  "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_FANTOM_TESTNET = new ERC20Token(
  ChainId.FANTOM_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_CELO = new ERC20Token(
  ChainId.CELO,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_CELO = new ERC20Token(
  ChainId.CELO,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_CELO = new ERC20Token(
  ChainId.CELO,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_CELO = new ERC20Token(
  ChainId.CELO,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_ALFAJORES = new ERC20Token(
  ChainId.CELO_ALFAJORES,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_ALFAJORES = new ERC20Token(
  ChainId.CELO_ALFAJORES,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_ALFAJORES = new ERC20Token(
  ChainId.CELO_ALFAJORES,
  "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_ALFAJORES = new ERC20Token(
  ChainId.CELO_ALFAJORES,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_OPTIMISM = new ERC20Token(
  ChainId.OPTIMISM,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_OPTIMISM = new ERC20Token(
  ChainId.OPTIMISM,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_OPTIMISM = new ERC20Token(
  ChainId.OPTIMISM,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_OPTIMISM = new ERC20Token(
  ChainId.OPTIMISM,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_OPTIMISM_GOERLI = new ERC20Token(
  ChainId.OPTIMISM_GOERLI,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_OPTIMISM_GOERLI = new ERC20Token(
  ChainId.OPTIMISM_GOERLI,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_OPTIMISM_GOERLI = new ERC20Token(
  ChainId.OPTIMISM_GOERLI,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_OPTIMISM_GOERLI = new ERC20Token(
  ChainId.OPTIMISM_GOERLI,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_ARBITRUM = new ERC20Token(
  ChainId.ARBITRUM_ONE,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_ARBITRUM = new ERC20Token(
  ChainId.ARBITRUM_ONE,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_ARBITRUM = new ERC20Token(
  ChainId.ARBITRUM_ONE,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_ARBITRUM = new ERC20Token(
  ChainId.ARBITRUM_ONE,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_ARBITRUM_GOERLI = new ERC20Token(
  ChainId.ARBITRUM_GOERLI,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_ARBITRUM_GOERLI = new ERC20Token(
  ChainId.ARBITRUM_GOERLI,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_ARBITRUM_GOERLI = new ERC20Token(
  ChainId.ARBITRUM_GOERLI,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_ARBITRUM_GOERLI = new ERC20Token(
  ChainId.ARBITRUM_GOERLI,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_SHIBARIUM = new ERC20Token(
  ChainId.SHIBARIUM,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_SHIBARIUM = new ERC20Token(
  ChainId.SHIBARIUM,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_SHIBARIUM = new ERC20Token(
  ChainId.SHIBARIUM,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_SHIBARIUM = new ERC20Token(
  ChainId.SHIBARIUM,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_SHIBARIUM_TESTNET = new ERC20Token(
  ChainId.SHIBARIUM_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_SHIBARIUM_TESTNET = new ERC20Token(
  ChainId.SHIBARIUM_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_SHIBARIUM_TESTNET = new ERC20Token(
  ChainId.SHIBARIUM_TESTNET,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_SHIBARIUM_TESTNET = new ERC20Token(
  ChainId.SHIBARIUM_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_PULSECHAIN = new ERC20Token(
  ChainId.PULSECHAIN,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_PULSECHAIN = new ERC20Token(
  ChainId.PULSECHAIN,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_PULSECHAIN = new ERC20Token(
  ChainId.PULSECHAIN,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_PULSECHAIN = new ERC20Token(
  ChainId.PULSECHAIN,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_PULSECHAIN_TESTNET = new ERC20Token(
  ChainId.PULSECHAIN_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_PULSECHAIN_TESTNET = new ERC20Token(
  ChainId.PULSECHAIN_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_PULSECHAIN_TESTNET = new ERC20Token(
  ChainId.PULSECHAIN_TESTNET,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_PULSECHAIN_TESTNET = new ERC20Token(
  ChainId.PULSECHAIN_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_XEN = new ERC20Token(
  ChainId.XEN,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_XEN = new ERC20Token(
  ChainId.XEN,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_XEN = new ERC20Token(
  ChainId.XEN,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_XEN = new ERC20Token(
  ChainId.XEN,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_XEN_DEVNET = new ERC20Token(
  ChainId.XEN_DEVNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_XEN_DEVNET = new ERC20Token(
  ChainId.XEN_DEVNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_XEN_DEVNET = new ERC20Token(
  ChainId.XEN_DEVNET,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_XEN_DEVNET = new ERC20Token(
  ChainId.XEN_DEVNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_HARMONY = new ERC20Token(
  ChainId.HARMONY,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_HARMONY = new ERC20Token(
  ChainId.HARMONY,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_HARMONY = new ERC20Token(
  ChainId.HARMONY,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_HARMONY = new ERC20Token(
  ChainId.HARMONY,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_HARMONY_TESTNET = new ERC20Token(
  ChainId.HARMONY_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_HARMONY_TESTNET = new ERC20Token(
  ChainId.HARMONY_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_HARMONY_TESTNET = new ERC20Token(
  ChainId.HARMONY_TESTNET,
  "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_HARMONY_TESTNET = new ERC20Token(
  ChainId.HARMONY_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_COINEX = new ERC20Token(
  ChainId.COINEX,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_COINEX = new ERC20Token(
  ChainId.COINEX,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_COINEX = new ERC20Token(
  ChainId.COINEX,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_COINEX = new ERC20Token(
  ChainId.COINEX,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_COINEX_TESTNET = new ERC20Token(
  ChainId.COINEX_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_COINEX_TESTNET = new ERC20Token(
  ChainId.COINEX_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_COINEX_TESTNET = new ERC20Token(
  ChainId.COINEX_TESTNET,
  "0xC751d479E574647f0F20B1A3A6f5D220b6Fd7De3",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_COINEX_TESTNET = new ERC20Token(
  ChainId.COINEX_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_DOGECHAIN = new ERC20Token(
  ChainId.DOGECHAIN,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_DOGECHAIN = new ERC20Token(
  ChainId.DOGECHAIN,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_DOGECHAIN = new ERC20Token(
  ChainId.DOGECHAIN,
  "0xC751d479E574647f0F20B1A3A6f5D220b6Fd7De3",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_DOGECHAIN = new ERC20Token(
  ChainId.DOGECHAIN,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_DOGECHAIN_TESTNET = new ERC20Token(
  ChainId.DOGECHAIN_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_DOGECHAIN_TESTNET = new ERC20Token(
  ChainId.DOGECHAIN_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_DOGECHAIN_TESTNET = new ERC20Token(
  ChainId.DOGECHAIN_TESTNET,
  "0xC751d479E574647f0F20B1A3A6f5D220b6Fd7De3",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_DOGECHAIN_TESTNET = new ERC20Token(
  ChainId.DOGECHAIN_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_ENGRAM_TESTNET = new ERC20Token(
  ChainId.ENGRAM_TESTNET,
  "0x9DD32D4F511996EFff334B6f4c1229757b963AA2",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_ENGRAM_TESTNET = new ERC20Token(
  ChainId.ENGRAM_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_ENGRAM_TESTNET = new ERC20Token(
  ChainId.ENGRAM_TESTNET,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_ENGRAM_TESTNET = new ERC20Token(
  ChainId.ENGRAM_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_ETHEREUM_CLASSIC = new ERC20Token(
  ChainId.ETHEREUM_CLASSIC,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_ETHEREUM_CLASSIC = new ERC20Token(
  ChainId.ETHEREUM_CLASSIC,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_ETHEREUM_CLASSIC = new ERC20Token(
  ChainId.ETHEREUM_CLASSIC,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_ETHEREUM_CLASSIC = new ERC20Token(
  ChainId.ETHEREUM_CLASSIC,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_ETHEREUM_CLASSIC_TESTNET = new ERC20Token(
  ChainId.ETHEREUM_CLASSIC_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_ETHEREUM_CLASSIC_TESTNET = new ERC20Token(
  ChainId.ETHEREUM_CLASSIC_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_ETHEREUM_CLASSIC_TESTNET = new ERC20Token(
  ChainId.ETHEREUM_CLASSIC_TESTNET,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_ETHEREUM_CLASSIC_TESTNET = new ERC20Token(
  ChainId.ETHEREUM_CLASSIC_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_FUSION = new ERC20Token(
  ChainId.FUSION,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_FUSION = new ERC20Token(
  ChainId.FUSION,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_FUSION = new ERC20Token(
  ChainId.FUSION,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_FUSION = new ERC20Token(
  ChainId.FUSION,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_FUSION_TESTNET = new ERC20Token(
  ChainId.FUSION_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_FUSION_TESTNET = new ERC20Token(
  ChainId.FUSION_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_FUSION_TESTNET = new ERC20Token(
  ChainId.FUSION_TESTNET,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_FUSION_TESTNET = new ERC20Token(
  ChainId.FUSION_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_HECO = new ERC20Token(
  ChainId.HECO,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_HECO = new ERC20Token(
  ChainId.HECO,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_HECO = new ERC20Token(
  ChainId.HECO,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_HECO = new ERC20Token(
  ChainId.HECO,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_HECO_TESTNET = new ERC20Token(
  ChainId.HECO_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_HECO_TESTNET = new ERC20Token(
  ChainId.HECO_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_HECO_TESTNET = new ERC20Token(
  ChainId.HECO_TESTNET,
  "0xC751d479E574647f0F20B1A3A6f5D220b6Fd7De3",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_HECO_TESTNET = new ERC20Token(
  ChainId.HECO_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_KCC = new ERC20Token(
  ChainId.KCC,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_KCC = new ERC20Token(
  ChainId.KCC,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_KCC = new ERC20Token(
  ChainId.KCC,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_KCC = new ERC20Token(
  ChainId.KCC,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_KCC_TESTNET = new ERC20Token(
  ChainId.KCC_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_KCC_TESTNET = new ERC20Token(
  ChainId.KCC_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_KCC_TESTNET = new ERC20Token(
  ChainId.KCC_TESTNET,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_KCC_TESTNET = new ERC20Token(
  ChainId.KCC_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_KLAYTN = new ERC20Token(
  ChainId.KLAYTN,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_KLAYTN = new ERC20Token(
  ChainId.KLAYTN,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_KLAYTN = new ERC20Token(
  ChainId.KLAYTN,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_KLAYTN = new ERC20Token(
  ChainId.KLAYTN,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_KLAYTN_BAOBAB = new ERC20Token(
  ChainId.KLAYTN_BAOBAB,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_KLAYTN_BAOBAB = new ERC20Token(
  ChainId.KLAYTN_BAOBAB,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_KLAYTN_BAOBAB = new ERC20Token(
  ChainId.KLAYTN_BAOBAB,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_KLAYTN_BAOBAB = new ERC20Token(
  ChainId.KLAYTN_BAOBAB,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_OKXCHAIN = new ERC20Token(
  ChainId.OKXCHAIN,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_OKXCHAIN = new ERC20Token(
  ChainId.OKXCHAIN,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_OKXCHAIN = new ERC20Token(
  ChainId.OKXCHAIN,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_OKXCHAIN = new ERC20Token(
  ChainId.OKXCHAIN,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_OKXCHAIN_TESTNET = new ERC20Token(
  ChainId.OKXCHAIN_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_OKXCHAIN_TESTNET = new ERC20Token(
  ChainId.OKXCHAIN_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_OKXCHAIN_TESTNET = new ERC20Token(
  ChainId.OKXCHAIN_TESTNET,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_OKXCHAIN_TESTNET = new ERC20Token(
  ChainId.OKXCHAIN_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_THETHA = new ERC20Token(
  ChainId.THETHA,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_THETHA = new ERC20Token(
  ChainId.THETHA,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_THETHA = new ERC20Token(
  ChainId.THETHA,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_THETHA = new ERC20Token(
  ChainId.THETHA,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_THETHA_TESTNET = new ERC20Token(
  ChainId.THETHA_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_THETHA_TESTNET = new ERC20Token(
  ChainId.THETHA_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_THETHA_TESTNET = new ERC20Token(
  ChainId.THETHA_TESTNET,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_THETHA_TESTNET = new ERC20Token(
  ChainId.THETHA_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_ULTRON = new ERC20Token(
  ChainId.ULTRON,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_ULTRON = new ERC20Token(
  ChainId.ULTRON,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_ULTRON = new ERC20Token(
  ChainId.ULTRON,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_ULTRON = new ERC20Token(
  ChainId.ULTRON,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_ULTRON_TESTNET = new ERC20Token(
  ChainId.ULTRON_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_ULTRON_TESTNET = new ERC20Token(
  ChainId.ULTRON_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_ULTRON_TESTNET = new ERC20Token(
  ChainId.ULTRON_TESTNET,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_ULTRON_TESTNET = new ERC20Token(
  ChainId.ULTRON_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_MOONBEAM = new ERC20Token(
  ChainId.MOONBEAM,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_MOONBEAM = new ERC20Token(
  ChainId.MOONBEAM,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_MOONBEAM = new ERC20Token(
  ChainId.MOONBEAM,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_MOONBEAM = new ERC20Token(
  ChainId.MOONBEAM,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_MOONRIVER = new ERC20Token(
  ChainId.MOONRIVER,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_MOONRIVER = new ERC20Token(
  ChainId.MOONRIVER,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_MOONRIVER = new ERC20Token(
  ChainId.MOONRIVER,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_MOONRIVER = new ERC20Token(
  ChainId.MOONRIVER,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_MOONBASE_ALPHA = new ERC20Token(
  ChainId.MOONBASE_ALPHA,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_MOONBASE_ALPHA = new ERC20Token(
  ChainId.MOONBASE_ALPHA,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_MOONBASE_ALPHA = new ERC20Token(
  ChainId.MOONBASE_ALPHA,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_MOONBASE_ALPHA = new ERC20Token(
  ChainId.MOONBASE_ALPHA,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_AURORA = new ERC20Token(
  ChainId.AURORA,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_AURORA = new ERC20Token(
  ChainId.AURORA,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_AURORA = new ERC20Token(
  ChainId.AURORA,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_AURORA = new ERC20Token(
  ChainId.AURORA,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_AURORA_TESTNET = new ERC20Token(
  ChainId.AURORA_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_AURORA_TESTNET = new ERC20Token(
  ChainId.AURORA_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_AURORA_TESTNET = new ERC20Token(
  ChainId.AURORA_TESTNET,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_AURORA_TESTNET = new ERC20Token(
  ChainId.AURORA_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_BOBA = new ERC20Token(
  ChainId.BOBA,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_BOBA = new ERC20Token(
  ChainId.BOBA,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_BOBA = new ERC20Token(
  ChainId.BOBA,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_BOBA = new ERC20Token(
  ChainId.BOBA,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_BOBA_GOERLI = new ERC20Token(
  ChainId.BOBA_GOERLI,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_BOBA_GOERLI = new ERC20Token(
  ChainId.BOBA_GOERLI,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_BOBA_GOERLI = new ERC20Token(
  ChainId.BOBA_GOERLI,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_BOBA_GOERLI = new ERC20Token(
  ChainId.BOBA_GOERLI,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_GNOSIS = new ERC20Token(
  ChainId.GNOSIS,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_GNOSIS = new ERC20Token(
  ChainId.GNOSIS,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_GNOSIS = new ERC20Token(
  ChainId.GNOSIS,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_GNOSIS = new ERC20Token(
  ChainId.GNOSIS,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_GNOSIS_CHIADO = new ERC20Token(
  ChainId.GNOSIS_CHIADO,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_GNOSIS_CHIADO = new ERC20Token(
  ChainId.GNOSIS_CHIADO,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_GNOSIS_CHIADO = new ERC20Token(
  ChainId.GNOSIS_CHIADO,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_GNOSIS_CHIADO = new ERC20Token(
  ChainId.GNOSIS_CHIADO,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_METIS = new ERC20Token(
  ChainId.METIS,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_METIS = new ERC20Token(
  ChainId.METIS,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_METIS = new ERC20Token(
  ChainId.METIS,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_METIS = new ERC20Token(
  ChainId.METIS,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_METIS_GOERLI = new ERC20Token(
  ChainId.METIS_GOERLI,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_METIS_GOERLI = new ERC20Token(
  ChainId.METIS_GOERLI,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_METIS_GOERLI = new ERC20Token(
  ChainId.METIS_GOERLI,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_METIS_GOERLI = new ERC20Token(
  ChainId.METIS_GOERLI,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_TELOS = new ERC20Token(
  ChainId.TELOS,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_TELOS = new ERC20Token(
  ChainId.TELOS,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_TELOS = new ERC20Token(
  ChainId.TELOS,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_TELOS = new ERC20Token(
  ChainId.TELOS,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_TELOS_TESTNET = new ERC20Token(
  ChainId.TELOS_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_TELOS_TESTNET = new ERC20Token(
  ChainId.TELOS_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_TELOS_TESTNET = new ERC20Token(
  ChainId.TELOS_TESTNET,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_TELOS_TESTNET = new ERC20Token(
  ChainId.TELOS_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_SYSCOIN = new ERC20Token(
  ChainId.SYSCOIN,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_SYSCOIN = new ERC20Token(
  ChainId.SYSCOIN,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_SYSCOIN = new ERC20Token(
  ChainId.SYSCOIN,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_SYSCOIN = new ERC20Token(
  ChainId.SYSCOIN,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_SYSCOIN_TANENBAUM = new ERC20Token(
  ChainId.SYSCOIN_TANENBAUM,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_SYSCOIN_TANENBAUM = new ERC20Token(
  ChainId.SYSCOIN_TANENBAUM,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_SYSCOIN_TANENBAUM = new ERC20Token(
  ChainId.SYSCOIN_TANENBAUM,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_SYSCOIN_TANENBAUM = new ERC20Token(
  ChainId.SYSCOIN_TANENBAUM,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_IOTEX = new ERC20Token(
  ChainId.IOTEX,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_IOTEX = new ERC20Token(
  ChainId.IOTEX,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_IOTEX = new ERC20Token(
  ChainId.IOTEX,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_IOTEX = new ERC20Token(
  ChainId.IOTEX,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_IOTEX_TESTNET = new ERC20Token(
  ChainId.IOTEX_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_IOTEX_TESTNET = new ERC20Token(
  ChainId.IOTEX_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_IOTEX_TESTNET = new ERC20Token(
  ChainId.IOTEX_TESTNET,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_IOTEX_TESTNET = new ERC20Token(
  ChainId.IOTEX_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_SHIDEN = new ERC20Token(
  ChainId.SHIDEN,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_SHIDEN = new ERC20Token(
  ChainId.SHIDEN,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_SHIDEN = new ERC20Token(
  ChainId.SHIDEN,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_SHIDEN = new ERC20Token(
  ChainId.SHIDEN,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_ASTAR = new ERC20Token(
  ChainId.ASTAR,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_ASTAR = new ERC20Token(
  ChainId.ASTAR,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_ASTAR = new ERC20Token(
  ChainId.ASTAR,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_ASTAR = new ERC20Token(
  ChainId.ASTAR,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_SHIBUNYA = new ERC20Token(
  ChainId.SHIBUNYA,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_SHIBUNYA = new ERC20Token(
  ChainId.SHIBUNYA,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_SHIBUNYA = new ERC20Token(
  ChainId.SHIBUNYA,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_SHIBUNYA = new ERC20Token(
  ChainId.SHIBUNYA,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_FUSE = new ERC20Token(
  ChainId.FUSE,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_FUSE = new ERC20Token(
  ChainId.FUSE,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_FUSE = new ERC20Token(
  ChainId.FUSE,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_FUSE = new ERC20Token(
  ChainId.FUSE,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_FUSE_SPARKNET = new ERC20Token(
  ChainId.FUSE_SPARKNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_FUSE_SPARKNET = new ERC20Token(
  ChainId.FUSE_SPARKNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_FUSE_SPARKNET = new ERC20Token(
  ChainId.FUSE_SPARKNET,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_FUSE_SPARKNET = new ERC20Token(
  ChainId.FUSE_SPARKNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_VELAS = new ERC20Token(
  ChainId.VELAS,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_VELAS = new ERC20Token(
  ChainId.VELAS,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_VELAS = new ERC20Token(
  ChainId.VELAS,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_VELAS = new ERC20Token(
  ChainId.VELAS,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_VELAS_TESTNET = new ERC20Token(
  ChainId.VELAS_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_VELAS_TESTNET = new ERC20Token(
  ChainId.VELAS_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_VELAS_TESTNET = new ERC20Token(
  ChainId.VELAS_TESTNET,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_VELAS_TESTNET = new ERC20Token(
  ChainId.VELAS_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_REI = new ERC20Token(
  ChainId.REI,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_REI = new ERC20Token(
  ChainId.REI,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_REI = new ERC20Token(
  ChainId.REI,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_REI = new ERC20Token(
  ChainId.REI,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_REI_TESTNET = new ERC20Token(
  ChainId.REI_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_REI_TESTNET = new ERC20Token(
  ChainId.REI_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_REI_TESTNET = new ERC20Token(
  ChainId.REI_TESTNET,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_REI_TESTNET = new ERC20Token(
  ChainId.REI_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_KEKCHAIN = new ERC20Token(
  ChainId.KEKCHAIN,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_KEKCHAIN = new ERC20Token(
  ChainId.KEKCHAIN,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_KEKCHAIN = new ERC20Token(
  ChainId.KEKCHAIN,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_KEKCHAIN = new ERC20Token(
  ChainId.KEKCHAIN,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_KEKCHAIN_TESTNET = new ERC20Token(
  ChainId.KEKCHAIN_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_KEKCHAIN_TESTNET = new ERC20Token(
  ChainId.KEKCHAIN_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_KEKCHAIN_TESTNET = new ERC20Token(
  ChainId.KEKCHAIN_TESTNET,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_KEKCHAIN_TESTNET = new ERC20Token(
  ChainId.KEKCHAIN_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_TOMOCHAIN = new ERC20Token(
  ChainId.TOMOCHAIN,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_TOMOCHAIN = new ERC20Token(
  ChainId.TOMOCHAIN,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_TOMOCHAIN = new ERC20Token(
  ChainId.TOMOCHAIN,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_TOMOCHAIN = new ERC20Token(
  ChainId.TOMOCHAIN,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_TOMOCHAIN_TESTNET = new ERC20Token(
  ChainId.TOMOCHAIN_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_TOMOCHAIN_TESTNET = new ERC20Token(
  ChainId.TOMOCHAIN_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_TOMOCHAIN_TESTNET = new ERC20Token(
  ChainId.TOMOCHAIN_TESTNET,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_TOMOCHAIN_TESTNET = new ERC20Token(
  ChainId.TOMOCHAIN_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_THUNDERCORE = new ERC20Token(
  ChainId.THUNDERCORE,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_THUNDERCORE = new ERC20Token(
  ChainId.THUNDERCORE,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_THUNDERCORE = new ERC20Token(
  ChainId.THUNDERCORE,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_THUNDERCORE = new ERC20Token(
  ChainId.THUNDERCORE,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_THUNDERCORE_TESTNET = new ERC20Token(
  ChainId.THUNDERCORE_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_THUNDERCORE_TESTNET = new ERC20Token(
  ChainId.THUNDERCORE_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_THUNDERCORE_TESTNET = new ERC20Token(
  ChainId.THUNDERCORE_TESTNET,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_THUNDERCORE_TESTNET = new ERC20Token(
  ChainId.THUNDERCORE_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_WANCHAIN = new ERC20Token(
  ChainId.WANCHAIN,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_WANCHAIN = new ERC20Token(
  ChainId.WANCHAIN,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_WANCHAIN = new ERC20Token(
  ChainId.WANCHAIN,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_WANCHAIN = new ERC20Token(
  ChainId.WANCHAIN,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_WANCHAIN_TESTNET = new ERC20Token(
  ChainId.WANCHAIN_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_WANCHAIN_TESTNET = new ERC20Token(
  ChainId.WANCHAIN_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_WANCHAIN_TESTNET = new ERC20Token(
  ChainId.WANCHAIN_TESTNET,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_WANCHAIN_TESTNET = new ERC20Token(
  ChainId.WANCHAIN_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_RSK = new ERC20Token(
  ChainId.RSK,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_RSK = new ERC20Token(
  ChainId.RSK,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_RSK = new ERC20Token(
  ChainId.RSK,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_RSK = new ERC20Token(
  ChainId.RSK,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_RSK_TESTNET = new ERC20Token(
  ChainId.RSK_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_RSK_TESTNET = new ERC20Token(
  ChainId.RSK_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_RSK_TESTNET = new ERC20Token(
  ChainId.RSK_TESTNET,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_RSK_TESTNET = new ERC20Token(
  ChainId.RSK_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_ELASTOS = new ERC20Token(
  ChainId.ELASTOS,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_ELASTOS = new ERC20Token(
  ChainId.ELASTOS,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_ELASTOS = new ERC20Token(
  ChainId.ELASTOS,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_ELASTOS = new ERC20Token(
  ChainId.ELASTOS,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_ELASTOS_TESTNET = new ERC20Token(
  ChainId.ELASTOS_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_ELASTOS_TESTNET = new ERC20Token(
  ChainId.ELASTOS_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_ELASTOS_TESTNET = new ERC20Token(
  ChainId.ELASTOS_TESTNET,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_ELASTOS_TESTNET = new ERC20Token(
  ChainId.ELASTOS_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_CONFLUX = new ERC20Token(
  ChainId.CONFLUX,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_CONFLUX = new ERC20Token(
  ChainId.CONFLUX,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_CONFLUX = new ERC20Token(
  ChainId.CONFLUX,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_CONFLUX = new ERC20Token(
  ChainId.CONFLUX,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_CONFLUX_TESTNET = new ERC20Token(
  ChainId.CONFLUX_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_CONFLUX_TESTNET = new ERC20Token(
  ChainId.CONFLUX_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_CONFLUX_TESTNET = new ERC20Token(
  ChainId.CONFLUX_TESTNET,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_CONFLUX_TESTNET = new ERC20Token(
  ChainId.CONFLUX_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_BRISECHAIN = new ERC20Token(
  ChainId.BRISECHAIN,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_BRISECHAIN = new ERC20Token(
  ChainId.BRISECHAIN,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_BRISECHAIN = new ERC20Token(
  ChainId.BRISECHAIN,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_BRISECHAIN = new ERC20Token(
  ChainId.BRISECHAIN,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_BRISECHAIN_TESTNET = new ERC20Token(
  ChainId.BRISECHAIN_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_BRISECHAIN_TESTNET = new ERC20Token(
  ChainId.BRISECHAIN_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_BRISECHAIN_TESTNET = new ERC20Token(
  ChainId.BRISECHAIN_TESTNET,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_BRISECHAIN_TESTNET = new ERC20Token(
  ChainId.BRISECHAIN_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_MUUCHAIN = new ERC20Token(
  ChainId.MUUCHAIN,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_MUUCHAIN = new ERC20Token(
  ChainId.MUUCHAIN,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_MUUCHAIN = new ERC20Token(
  ChainId.MUUCHAIN,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_MUUCHAIN = new ERC20Token(
  ChainId.MUUCHAIN,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_MUUCHAIN_TESTNET = new ERC20Token(
  ChainId.MUUCHAIN_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_MUUCHAIN_TESTNET = new ERC20Token(
  ChainId.MUUCHAIN_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_MUUCHAIN_TESTNET = new ERC20Token(
  ChainId.MUUCHAIN_TESTNET,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_MUUCHAIN_TESTNET = new ERC20Token(
  ChainId.MUUCHAIN_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_CANTO = new ERC20Token(
  ChainId.CANTO,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_CANTO = new ERC20Token(
  ChainId.CANTO,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_CANTO = new ERC20Token(
  ChainId.CANTO,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_CANTO = new ERC20Token(
  ChainId.CANTO,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_CANTO_TESTNET = new ERC20Token(
  ChainId.CANTO_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_CANTO_TESTNET = new ERC20Token(
  ChainId.CANTO_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_CANTO_TESTNET = new ERC20Token(
  ChainId.CANTO_TESTNET,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_CANTO_TESTNET = new ERC20Token(
  ChainId.CANTO_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_OASIS_EMERALD = new ERC20Token(
  ChainId.OASIS_EMERALD,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_OASIS_EMERALD = new ERC20Token(
  ChainId.OASIS_EMERALD,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_OASIS_EMERALD = new ERC20Token(
  ChainId.OASIS_EMERALD,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_OASIS_EMERALD = new ERC20Token(
  ChainId.OASIS_EMERALD,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_OASIS_TESTNET = new ERC20Token(
  ChainId.OASIS_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_OASIS_TESTNET = new ERC20Token(
  ChainId.OASIS_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_OASIS_TESTNET = new ERC20Token(
  ChainId.OASIS_TESTNET,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_OASIS_TESTNET = new ERC20Token(
  ChainId.OASIS_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_VISION = new ERC20Token(
  ChainId.VISION,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_VISION = new ERC20Token(
  ChainId.VISION,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_VISION = new ERC20Token(
  ChainId.VISION,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_VISION = new ERC20Token(
  ChainId.VISION,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_VISION_TESTNET = new ERC20Token(
  ChainId.VISION_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_VISION_TESTNET = new ERC20Token(
  ChainId.VISION_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_VISION_TESTNET = new ERC20Token(
  ChainId.VISION_TESTNET,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_VISION_TESTNET = new ERC20Token(
  ChainId.VISION_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_STEP = new ERC20Token(
  ChainId.STEP,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_STEP = new ERC20Token(
  ChainId.STEP,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_STEP = new ERC20Token(
  ChainId.STEP,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_STEP = new ERC20Token(
  ChainId.STEP,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_STEP_TESTNET = new ERC20Token(
  ChainId.STEP_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_STEP_TESTNET = new ERC20Token(
  ChainId.STEP_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_STEP_TESTNET = new ERC20Token(
  ChainId.STEP_TESTNET,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_STEP_TESTNET = new ERC20Token(
  ChainId.STEP_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_METER = new ERC20Token(
  ChainId.METER,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_METER = new ERC20Token(
  ChainId.METER,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_METER = new ERC20Token(
  ChainId.METER,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_METER = new ERC20Token(
  ChainId.METER,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_METER_TESTNET = new ERC20Token(
  ChainId.METER_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_METER_TESTNET = new ERC20Token(
  ChainId.METER_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_METER_TESTNET = new ERC20Token(
  ChainId.METER_TESTNET,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_METER_TESTNET = new ERC20Token(
  ChainId.METER_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_GODWOKEN = new ERC20Token(
  ChainId.GODWOKEN,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_GODWOKEN = new ERC20Token(
  ChainId.GODWOKEN,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_GODWOKEN = new ERC20Token(
  ChainId.GODWOKEN,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_GODWOKEN = new ERC20Token(
  ChainId.GODWOKEN,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_GODWOKEN_TESTNET = new ERC20Token(
  ChainId.GODWOKEN_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_GODWOKEN_TESTNET = new ERC20Token(
  ChainId.GODWOKEN_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_GODWOKEN_TESTNET = new ERC20Token(
  ChainId.GODWOKEN_TESTNET,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_GODWOKEN_TESTNET = new ERC20Token(
  ChainId.GODWOKEN_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_CALLISTO = new ERC20Token(
  ChainId.CALLISTO,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_CALLISTO = new ERC20Token(
  ChainId.CALLISTO,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_CALLISTO = new ERC20Token(
  ChainId.CALLISTO,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_CALLISTO = new ERC20Token(
  ChainId.CALLISTO,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_CALLISTO_TESTNET = new ERC20Token(
  ChainId.CALLISTO_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_CALLISTO_TESTNET = new ERC20Token(
  ChainId.CALLISTO_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_CALLISTO_TESTNET = new ERC20Token(
  ChainId.CALLISTO_TESTNET,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_CALLISTO_TESTNET = new ERC20Token(
  ChainId.CALLISTO_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_EVMOS = new ERC20Token(
  ChainId.EVMOS,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_EVMOS = new ERC20Token(
  ChainId.EVMOS,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_EVMOS = new ERC20Token(
  ChainId.EVMOS,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_EVMOS = new ERC20Token(
  ChainId.EVMOS,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_EVMOS_TESTNET = new ERC20Token(
  ChainId.EVMOS_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_EVMOS_TESTNET = new ERC20Token(
  ChainId.EVMOS_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_EVMOS_TESTNET = new ERC20Token(
  ChainId.EVMOS_TESTNET,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_EVMOS_TESTNET = new ERC20Token(
  ChainId.EVMOS_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_ENERGY_WEB_CHAIN = new ERC20Token(
  ChainId.ENERGY_WEB_CHAIN,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_ENERGY_WEB_CHAIN = new ERC20Token(
  ChainId.ENERGY_WEB_CHAIN,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_ENERGY_WEB_CHAIN = new ERC20Token(
  ChainId.ENERGY_WEB_CHAIN,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_ENERGY_WEB_CHAIN = new ERC20Token(
  ChainId.ENERGY_WEB_CHAIN,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_ENERGY_VOLTA = new ERC20Token(
  ChainId.ENERGY_VOLTA,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_ENERGY_VOLTA = new ERC20Token(
  ChainId.ENERGY_VOLTA,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_ENERGY_VOLTA = new ERC20Token(
  ChainId.ENERGY_VOLTA,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_ENERGY_VOLTA = new ERC20Token(
  ChainId.ENERGY_VOLTA,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_BASE = new ERC20Token(
  ChainId.BASE,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_BASE = new ERC20Token(
  ChainId.BASE,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_BASE = new ERC20Token(
  ChainId.BASE,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_BASE = new ERC20Token(
  ChainId.BASE,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_BASE_GOERLI = new ERC20Token(
  ChainId.BASE_GOERLI,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_BASE_GOERLI = new ERC20Token(
  ChainId.BASE_GOERLI,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_BASE_GOERLI = new ERC20Token(
  ChainId.BASE_GOERLI,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_BASE_GOERLI = new ERC20Token(
  ChainId.BASE_GOERLI,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_KAVA = new ERC20Token(
  ChainId.KAVA,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_KAVA = new ERC20Token(
  ChainId.KAVA,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_KAVA = new ERC20Token(
  ChainId.KAVA,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_KAVA = new ERC20Token(
  ChainId.KAVA,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_KAVA_TESTNET = new ERC20Token(
  ChainId.KAVA_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_KAVA_TESTNET = new ERC20Token(
  ChainId.KAVA_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_KAVA_TESTNET = new ERC20Token(
  ChainId.KAVA_TESTNET,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_KAVA_TESTNET = new ERC20Token(
  ChainId.KAVA_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_CLOVER = new ERC20Token(
  ChainId.CLOVER,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_CLOVER = new ERC20Token(
  ChainId.CLOVER,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_CLOVER = new ERC20Token(
  ChainId.CLOVER,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_CLOVER = new ERC20Token(
  ChainId.CLOVER,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_CLOVER_TESTNET = new ERC20Token(
  ChainId.CLOVER_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_CLOVER_TESTNET = new ERC20Token(
  ChainId.CLOVER_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_CLOVER_TESTNET = new ERC20Token(
  ChainId.CLOVER_TESTNET,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_CLOVER_TESTNET = new ERC20Token(
  ChainId.CLOVER_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_DEFICHAIN = new ERC20Token(
  ChainId.DEFICHAIN,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_DEFICHAIN = new ERC20Token(
  ChainId.DEFICHAIN,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_DEFICHAIN = new ERC20Token(
  ChainId.DEFICHAIN,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_DEFICHAIN = new ERC20Token(
  ChainId.DEFICHAIN,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_DEFICHAIN_TESTNET = new ERC20Token(
  ChainId.DEFICHAIN_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_DEFICHAIN_TESTNET = new ERC20Token(
  ChainId.DEFICHAIN_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_DEFICHAIN_TESTNET = new ERC20Token(
  ChainId.DEFICHAIN_TESTNET,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_DEFICHAIN_TESTNET = new ERC20Token(
  ChainId.DEFICHAIN_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_BRONOS = new ERC20Token(
  ChainId.BRONOS,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_BRONOS = new ERC20Token(
  ChainId.BRONOS,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_BRONOS = new ERC20Token(
  ChainId.BRONOS,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_BRONOS = new ERC20Token(
  ChainId.BRONOS,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_BRONOS_TESTNET = new ERC20Token(
  ChainId.BRONOS_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_BRONOS_TESTNET = new ERC20Token(
  ChainId.BRONOS_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_BRONOS_TESTNET = new ERC20Token(
  ChainId.BRONOS_TESTNET,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_BRONOS_TESTNET = new ERC20Token(
  ChainId.BRONOS_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_FILECOIN = new ERC20Token(
  ChainId.FILECOIN,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_FILECOIN = new ERC20Token(
  ChainId.FILECOIN,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_FILECOIN = new ERC20Token(
  ChainId.FILECOIN,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_FILECOIN = new ERC20Token(
  ChainId.FILECOIN,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_FILECOIN_CALIBRATION = new ERC20Token(
  ChainId.FILECOIN_CALIBRATION,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_FILECOIN_CALIBRATION = new ERC20Token(
  ChainId.FILECOIN_CALIBRATION,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_FILECOIN_CALIBRATION = new ERC20Token(
  ChainId.FILECOIN_CALIBRATION,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_FILECOIN_CALIBRATION = new ERC20Token(
  ChainId.FILECOIN_CALIBRATION,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_FLARE = new ERC20Token(
  ChainId.FLARE,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_FLARE = new ERC20Token(
  ChainId.FLARE,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_FLARE = new ERC20Token(
  ChainId.FLARE,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_FLARE = new ERC20Token(
  ChainId.FLARE,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_FLARE_TESTNET = new ERC20Token(
  ChainId.FLARE_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_FLARE_TESTNET = new ERC20Token(
  ChainId.FLARE_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_FLARE_TESTNET = new ERC20Token(
  ChainId.FLARE_TESTNET,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_FLARE_TESTNET = new ERC20Token(
  ChainId.FLARE_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_TARAXA = new ERC20Token(
  ChainId.TARAXA,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_TARAXA = new ERC20Token(
  ChainId.TARAXA,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_TARAXA = new ERC20Token(
  ChainId.TARAXA,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_TARAXA = new ERC20Token(
  ChainId.TARAXA,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_TARAXA_TESTNET = new ERC20Token(
  ChainId.TARAXA_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_TARAXA_TESTNET = new ERC20Token(
  ChainId.TARAXA_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_TARAXA_TESTNET = new ERC20Token(
  ChainId.TARAXA_TESTNET,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_TARAXA_TESTNET = new ERC20Token(
  ChainId.TARAXA_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_ZKSYNC = new ERC20Token(
  ChainId.ZKSYNC,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_ZKSYNC = new ERC20Token(
  ChainId.ZKSYNC,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_ZKSYNC = new ERC20Token(
  ChainId.ZKSYNC,
  "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_ZKSYNC = new ERC20Token(
  ChainId.ZKSYNC,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_ZKSYNC_TESTNET = new ERC20Token(
  ChainId.ZKSYNC_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_ZKSYNC_TESTNET = new ERC20Token(
  ChainId.ZKSYNC_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_ZKSYNC_TESTNET = new ERC20Token(
  ChainId.ZKSYNC_TESTNET,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_ZKSYNC_TESTNET = new ERC20Token(
  ChainId.ZKSYNC_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_LINEA = new ERC20Token(
  ChainId.LINEA,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_LINEA = new ERC20Token(
  ChainId.LINEA,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_LINEA = new ERC20Token(
  ChainId.LINEA,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_LINEA = new ERC20Token(
  ChainId.LINEA,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_LINEA_TESTNET = new ERC20Token(
  ChainId.LINEA_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_LINEA_TESTNET = new ERC20Token(
  ChainId.LINEA_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_LINEA_TESTNET = new ERC20Token(
  ChainId.LINEA_TESTNET,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_LINEA_TESTNET = new ERC20Token(
  ChainId.LINEA_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_BTTCHAIN = new ERC20Token(
  ChainId.BTTCHAIN,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_BTTCHAIN = new ERC20Token(
  ChainId.BTTCHAIN,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_BTTCHAIN = new ERC20Token(
  ChainId.BTTCHAIN,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_BTTCHAIN = new ERC20Token(
  ChainId.BTTCHAIN,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_BTTCHAIN_TESTNET = new ERC20Token(
  ChainId.BTTCHAIN_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_BTTCHAIN_TESTNET = new ERC20Token(
  ChainId.BTTCHAIN_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_BTTCHAIN_TESTNET = new ERC20Token(
  ChainId.BTTCHAIN_TESTNET,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_BTTCHAIN_TESTNET = new ERC20Token(
  ChainId.BTTCHAIN_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_BOBA_AVAX = new ERC20Token(
  ChainId.BOBA_AVAX,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_BOBA_AVAX = new ERC20Token(
  ChainId.BOBA_AVAX,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_BOBA_AVAX = new ERC20Token(
  ChainId.BOBA_AVAX,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_BOBA_AVAX = new ERC20Token(
  ChainId.BOBA_AVAX,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_BOBA_BNB = new ERC20Token(
  ChainId.BOBA_BNB,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_BOBA_BNB = new ERC20Token(
  ChainId.BOBA_BNB,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_BOBA_BNB = new ERC20Token(
  ChainId.BOBA_BNB,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_BOBA_BNB = new ERC20Token(
  ChainId.BOBA_BNB,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_CMP = new ERC20Token(
  ChainId.CMP,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_CMP = new ERC20Token(
  ChainId.CMP,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_CMP = new ERC20Token(
  ChainId.CMP,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_CMP = new ERC20Token(
  ChainId.CMP,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_CMP_TESTNET = new ERC20Token(
  ChainId.CMP_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_CMP_TESTNET = new ERC20Token(
  ChainId.CMP_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_CMP_TESTNET = new ERC20Token(
  ChainId.CMP_TESTNET,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_CMP_TESTNET = new ERC20Token(
  ChainId.CMP_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_CORE = new ERC20Token(
  ChainId.CORE,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_CORE = new ERC20Token(
  ChainId.CORE,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_CORE = new ERC20Token(
  ChainId.CORE,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_CORE = new ERC20Token(
  ChainId.CORE,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_CORE_TESTNET = new ERC20Token(
  ChainId.CORE_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_CORE_TESTNET = new ERC20Token(
  ChainId.CORE_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_CORE_TESTNET = new ERC20Token(
  ChainId.CORE_TESTNET,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_CORE_TESTNET = new ERC20Token(
  ChainId.CORE_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_CUBECHAIN = new ERC20Token(
  ChainId.CUBECHAIN,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_CUBECHAIN = new ERC20Token(
  ChainId.CUBECHAIN,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_CUBECHAIN = new ERC20Token(
  ChainId.CUBECHAIN,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_CUBECHAIN = new ERC20Token(
  ChainId.CUBECHAIN,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_CUBECHAIN_TESTNET = new ERC20Token(
  ChainId.CUBECHAIN_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_CUBECHAIN_TESTNET = new ERC20Token(
  ChainId.CUBECHAIN_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_CUBECHAIN_TESTNET = new ERC20Token(
  ChainId.CUBECHAIN_TESTNET,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_CUBECHAIN_TESTNET = new ERC20Token(
  ChainId.CUBECHAIN_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_DARWINIA_CRAB = new ERC20Token(
  ChainId.DARWINIA_CRAB,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_DARWINIA_CRAB = new ERC20Token(
  ChainId.DARWINIA_CRAB,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_DARWINIA_CRAB = new ERC20Token(
  ChainId.DARWINIA_CRAB,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_DARWINIA_CRAB = new ERC20Token(
  ChainId.DARWINIA_CRAB,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_DARWINIA_PANGOLIN = new ERC20Token(
  ChainId.DARWINIA_PANGOLIN,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_DARWINIA_PANGOLIN = new ERC20Token(
  ChainId.DARWINIA_PANGOLIN,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_DARWINIA_PANGOLIN = new ERC20Token(
  ChainId.DARWINIA_PANGOLIN,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_DARWINIA_PANGOLIN = new ERC20Token(
  ChainId.DARWINIA_PANGOLIN,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_DIODE_PRETNET = new ERC20Token(
  ChainId.DIODE_PRETNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_DIODE_PRETNET = new ERC20Token(
  ChainId.DIODE_PRETNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_DIODE_PRETNET = new ERC20Token(
  ChainId.DIODE_PRETNET,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_DIODE_PRETNET = new ERC20Token(
  ChainId.DIODE_PRETNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_DIODE_TESTNET = new ERC20Token(
  ChainId.DIODE_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_DIODE_TESTNET = new ERC20Token(
  ChainId.DIODE_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_DIODE_TESTNET = new ERC20Token(
  ChainId.DIODE_TESTNET,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_DIODE_TESTNET = new ERC20Token(
  ChainId.DIODE_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_GOCHAIN = new ERC20Token(
  ChainId.GOCHAIN,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_GOCHAIN = new ERC20Token(
  ChainId.GOCHAIN,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_GOCHAIN = new ERC20Token(
  ChainId.GOCHAIN,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_GOCHAIN = new ERC20Token(
  ChainId.GOCHAIN,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_GOCHAIN_TESTNET = new ERC20Token(
  ChainId.GOCHAIN_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_GOCHAIN_TESTNET = new ERC20Token(
  ChainId.GOCHAIN_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_GOCHAIN_TESTNET = new ERC20Token(
  ChainId.GOCHAIN_TESTNET,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_GOCHAIN_TESTNET = new ERC20Token(
  ChainId.GOCHAIN_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_HAQQ = new ERC20Token(
  ChainId.HAQQ,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_HAQQ = new ERC20Token(
  ChainId.HAQQ,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_HAQQ = new ERC20Token(
  ChainId.HAQQ,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_HAQQ = new ERC20Token(
  ChainId.HAQQ,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_HAQQ_TESTEDGE2 = new ERC20Token(
  ChainId.HAQQ_TESTEDGE2,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_HAQQ_TESTEDGE2 = new ERC20Token(
  ChainId.HAQQ_TESTEDGE2,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_HAQQ_TESTEDGE2 = new ERC20Token(
  ChainId.HAQQ_TESTEDGE2,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_HAQQ_TESTEDGE2 = new ERC20Token(
  ChainId.HAQQ_TESTEDGE2,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_KARDIACHAIN = new ERC20Token(
  ChainId.KARDIACHAIN,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_KARDIACHAIN = new ERC20Token(
  ChainId.KARDIACHAIN,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_KARDIACHAIN = new ERC20Token(
  ChainId.KARDIACHAIN,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_KARDIACHAIN = new ERC20Token(
  ChainId.KARDIACHAIN,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_KARDIACHAIN_TESTNET = new ERC20Token(
  ChainId.KARDIACHAIN_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_KARDIACHAIN_TESTNET = new ERC20Token(
  ChainId.KARDIACHAIN_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_KARDIACHAIN_TESTNET = new ERC20Token(
  ChainId.KARDIACHAIN_TESTNET,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_KARDIACHAIN_TESTNET = new ERC20Token(
  ChainId.KARDIACHAIN_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_METADIUM = new ERC20Token(
  ChainId.METADIUM,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_METADIUM = new ERC20Token(
  ChainId.METADIUM,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_METADIUM = new ERC20Token(
  ChainId.METADIUM,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_METADIUM = new ERC20Token(
  ChainId.METADIUM,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_METADIUM_TESTNET = new ERC20Token(
  ChainId.METADIUM_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_METADIUM_TESTNET = new ERC20Token(
  ChainId.METADIUM_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_METADIUM_TESTNET = new ERC20Token(
  ChainId.METADIUM_TESTNET,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_METADIUM_TESTNET = new ERC20Token(
  ChainId.METADIUM_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_OP_BNB = new ERC20Token(
  ChainId.OP_BNB,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_OP_BNB = new ERC20Token(
  ChainId.OP_BNB,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_OP_BNB = new ERC20Token(
  ChainId.OP_BNB,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_OP_BNB = new ERC20Token(
  ChainId.OP_BNB,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_OP_BNB_TESTNET = new ERC20Token(
  ChainId.OP_BNB_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_OP_BNB_TESTNET = new ERC20Token(
  ChainId.OP_BNB_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_OP_BNB_TESTNET = new ERC20Token(
  ChainId.OP_BNB_TESTNET,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_OP_BNB_TESTNET = new ERC20Token(
  ChainId.OP_BNB_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_PALM = new ERC20Token(
  ChainId.PALM,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_PALM = new ERC20Token(
  ChainId.PALM,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_PALM = new ERC20Token(
  ChainId.PALM,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_PALM = new ERC20Token(
  ChainId.PALM,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_PALM_TESTNET = new ERC20Token(
  ChainId.PALM_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_PALM_TESTNET = new ERC20Token(
  ChainId.PALM_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_PALM_TESTNET = new ERC20Token(
  ChainId.PALM_TESTNET,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_PALM_TESTNET = new ERC20Token(
  ChainId.PALM_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_POLIS = new ERC20Token(
  ChainId.POLIS,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_POLIS = new ERC20Token(
  ChainId.POLIS,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_POLIS = new ERC20Token(
  ChainId.POLIS,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_POLIS = new ERC20Token(
  ChainId.POLIS,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_POLIS_TESTNET = new ERC20Token(
  ChainId.POLIS_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_POLIS_TESTNET = new ERC20Token(
  ChainId.POLIS_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_POLIS_TESTNET = new ERC20Token(
  ChainId.POLIS_TESTNET,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_POLIS_TESTNET = new ERC20Token(
  ChainId.POLIS_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_SHIBACHAIN = new ERC20Token(
  ChainId.SHIBACHAIN,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_SHIBACHAIN = new ERC20Token(
  ChainId.SHIBACHAIN,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_SHIBACHAIN = new ERC20Token(
  ChainId.SHIBACHAIN,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_SHIBACHAIN = new ERC20Token(
  ChainId.SHIBACHAIN,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_SMART_BCH = new ERC20Token(
  ChainId.SMART_BCH,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_SMART_BCH = new ERC20Token(
  ChainId.SMART_BCH,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_SMART_BCH = new ERC20Token(
  ChainId.SMART_BCH,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_SMART_BCH = new ERC20Token(
  ChainId.SMART_BCH,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_SMART_BCH_TESTNET = new ERC20Token(
  ChainId.SMART_BCH_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_SMART_BCH_TESTNET = new ERC20Token(
  ChainId.SMART_BCH_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_SMART_BCH_TESTNET = new ERC20Token(
  ChainId.SMART_BCH_TESTNET,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_SMART_BCH_TESTNET = new ERC20Token(
  ChainId.SMART_BCH_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_SONGBIRD_CANARY = new ERC20Token(
  ChainId.SONGBIRD_CANARY,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_SONGBIRD_CANARY = new ERC20Token(
  ChainId.SONGBIRD_CANARY,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_SONGBIRD_CANARY = new ERC20Token(
  ChainId.SONGBIRD_CANARY,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_SONGBIRD_CANARY = new ERC20Token(
  ChainId.SONGBIRD_CANARY,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_THAICHAIN = new ERC20Token(
  ChainId.THAICHAIN,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_THAICHAIN = new ERC20Token(
  ChainId.THAICHAIN,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_THAICHAIN = new ERC20Token(
  ChainId.THAICHAIN,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_THAICHAIN = new ERC20Token(
  ChainId.THAICHAIN,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_UBIQ = new ERC20Token(
  ChainId.UBIQ,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_UBIQ = new ERC20Token(
  ChainId.UBIQ,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_UBIQ = new ERC20Token(
  ChainId.UBIQ,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_UBIQ = new ERC20Token(
  ChainId.UBIQ,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_UBIQ_TESTNET = new ERC20Token(
  ChainId.UBIQ_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_UBIQ_TESTNET = new ERC20Token(
  ChainId.UBIQ_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_UBIQ_TESTNET = new ERC20Token(
  ChainId.UBIQ_TESTNET,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_UBIQ_TESTNET = new ERC20Token(
  ChainId.UBIQ_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_VECHAIN = new ERC20Token(
  ChainId.VECHAIN,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_VECHAIN = new ERC20Token(
  ChainId.VECHAIN,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_VECHAIN = new ERC20Token(
  ChainId.VECHAIN,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_VECHAIN = new ERC20Token(
  ChainId.VECHAIN,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_VECHAIN_TESTNET = new ERC20Token(
  ChainId.VECHAIN_TESTNET,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_VECHAIN_TESTNET = new ERC20Token(
  ChainId.VECHAIN_TESTNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_VECHAIN_TESTNET = new ERC20Token(
  ChainId.VECHAIN_TESTNET,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_VECHAIN_TESTNET = new ERC20Token(
  ChainId.VECHAIN_TESTNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_XINFIN = new ERC20Token(
  ChainId.XINFIN,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_XINFIN = new ERC20Token(
  ChainId.XINFIN,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_XINFIN = new ERC20Token(
  ChainId.XINFIN,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_XINFIN = new ERC20Token(
  ChainId.XINFIN,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_XINFIN_APOTHEM = new ERC20Token(
  ChainId.XINFIN_APOTHEM,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_XINFIN_APOTHEM = new ERC20Token(
  ChainId.XINFIN_APOTHEM,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_XINFIN_APOTHEM = new ERC20Token(
  ChainId.XINFIN_APOTHEM,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_XINFIN_APOTHEM = new ERC20Token(
  ChainId.XINFIN_APOTHEM,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_SCROLL = new ERC20Token(
  ChainId.SCROLL,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_SCROLL = new ERC20Token(
  ChainId.SCROLL,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_SCROLL = new ERC20Token(
  ChainId.SCROLL,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_SCROLL = new ERC20Token(
  ChainId.SCROLL,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_SCROLL_SEPOLIA = new ERC20Token(
  ChainId.SCROLL_SEPOLIA,
  "0x35060f7803eF7763b77E4EF0082bc0bCf2654154",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_SCROLL_SEPOLIA = new ERC20Token(
  ChainId.SCROLL_SEPOLIA,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_SCROLL_SEPOLIA = new ERC20Token(
  ChainId.SCROLL_SEPOLIA,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_SCROLL_SEPOLIA = new ERC20Token(
  ChainId.SCROLL_SEPOLIA,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_XRPL_DEVNET = new ERC20Token(
  ChainId.XRPL_DEVNET,
  "0x35060f7803eF7763b77E4EF0082bc0bCf2654154",
  6,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_XRPL_DEVNET = new ERC20Token(
  ChainId.XRPL_DEVNET,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_XRPL_DEVNET = new ERC20Token(
  ChainId.XRPL_DEVNET,
  "0x0216a640C4d53F2a6603042d4E14A2B890efcD45",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_XRPL_DEVNET = new ERC20Token(
  ChainId.XRPL_DEVNET,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_ZETACHAIN = new ERC20Token(
  ChainId.ZETACHAIN,
  "0x35060f7803eF7763b77E4EF0082bc0bCf2654154",
  6,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_ZETACHAIN = new ERC20Token(
  ChainId.ZETACHAIN,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_ZETACHAIN = new ERC20Token(
  ChainId.ZETACHAIN,
  "0x0216a640C4d53F2a6603042d4E14A2B890efcD45",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_ZETACHAIN = new ERC20Token(
  ChainId.ZETACHAIN,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_ZETACHAIN_ATHENS = new ERC20Token(
  ChainId.ZETACHAIN_ATHENS,
  "0x35060f7803eF7763b77E4EF0082bc0bCf2654154",
  6,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_ZETACHAIN_ATHENS = new ERC20Token(
  ChainId.ZETACHAIN_ATHENS,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_ZETACHAIN_ATHENS = new ERC20Token(
  ChainId.ZETACHAIN_ATHENS,
  "0x8147852f0e66f5DB5EeeF0A068d7F191a3e11c9c",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_ZETACHAIN_ATHENS = new ERC20Token(
  ChainId.ZETACHAIN_ATHENS,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var USDT_ZYX = new ERC20Token(
  ChainId.ZYX,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  "https://tether.to/"
);
var BUSD_ZYX = new ERC20Token(
  ChainId.ZYX,
  "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
  18,
  "BUSD",
  "Binance USD",
  "https://www.paxos.com/busd/"
);
var DONA_ZYX = new ERC20Token(
  ChainId.ZYX,
  "0x9DEfe12557a08fbb44cc3E4146e4988bB6953872",
  9,
  "DONA",
  "DONASWAP",
  "https://donaswap.io"
);
var FLAME_ZYX = new ERC20Token(
  ChainId.ZYX,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "FLAME",
  "Flame Token",
  "https://app.donaswap.io/"
);
var BUSD = {
  [ChainId.FIRECHAIN]: BUSD_FIRECHAIN,
  [ChainId.RINIA]: BUSD_RINIA,
  [ChainId.FIRECHAIN_ZKEVM]: BUSD_FIRECHAIN_ZKEVM,
  [ChainId.FIRECHAIN_ZKEVM_GHOSTRIDER]: BUSD_FIRECHAIN_ZKEVM_GHOSTRIDER,
  [ChainId.BSC]: BUSD_BSC,
  [ChainId.BSC_TESTNET]: BUSD_TESTNET,
  [ChainId.ETHEREUM]: BUSD_ETH,
  [ChainId.GOERLI]: BUSD_GOERLI,
  [ChainId.SEPOLIA]: BUSD_SEPOLIA,
  [ChainId.HOLESKY]: BUSD_HOLESKY,
  [ChainId.POLYGON]: BUSD_POLYGON,
  [ChainId.POLYGON_AMOY]: BUSD_AMOY,
  [ChainId.POLYGON_ZKEVM]: BUSD_POLYGON_ZKEVM,
  [ChainId.POLYGON_ZKEVM_TESTNET]: BUSD_POLYGON_ZKEVM_TESTNET,
  [ChainId.CRO]: BUSD_CRO,
  [ChainId.CRO_TESTNET]: BUSD_CRO_TESTNET,
  [ChainId.AVALANCHE]: BUSD_AVALANCHE,
  [ChainId.AVALANCHE_FUJI]: BUSD_FUJI,
  [ChainId.FANTOM_OPERA]: BUSD_FANTOM_OPERA,
  [ChainId.FANTOM_TESTNET]: BUSD_FANTOM_TESTNET,
  [ChainId.CELO]: BUSD_CELO,
  [ChainId.CELO_ALFAJORES]: BUSD_ALFAJORES,
  [ChainId.OPTIMISM]: BUSD_OPTIMISM,
  [ChainId.OPTIMISM_GOERLI]: BUSD_OPTIMISM_GOERLI,
  [ChainId.ARBITRUM_ONE]: BUSD_ARBITRUM,
  [ChainId.ARBITRUM_GOERLI]: BUSD_ARBITRUM_GOERLI,
  [ChainId.SHIBARIUM]: BUSD_SHIBARIUM,
  [ChainId.SHIBARIUM_TESTNET]: BUSD_SHIBARIUM_TESTNET,
  [ChainId.PULSECHAIN]: BUSD_PULSECHAIN,
  [ChainId.PULSECHAIN_TESTNET]: BUSD_PULSECHAIN_TESTNET,
  [ChainId.XEN]: BUSD_XEN,
  [ChainId.XEN_DEVNET]: BUSD_XEN_DEVNET,
  [ChainId.HARMONY]: BUSD_HARMONY,
  [ChainId.HARMONY_TESTNET]: BUSD_HARMONY_TESTNET,
  [ChainId.COINEX]: BUSD_COINEX,
  [ChainId.COINEX_TESTNET]: BUSD_COINEX_TESTNET,
  [ChainId.DOGECHAIN]: BUSD_DOGECHAIN,
  [ChainId.DOGECHAIN_TESTNET]: BUSD_DOGECHAIN_TESTNET,
  [ChainId.ENGRAM_TESTNET]: BUSD_ENGRAM_TESTNET,
  [ChainId.ETHEREUM_CLASSIC]: BUSD_ETHEREUM_CLASSIC,
  [ChainId.ETHEREUM_CLASSIC_TESTNET]: BUSD_ETHEREUM_CLASSIC_TESTNET,
  [ChainId.FUSION]: BUSD_FUSION,
  [ChainId.FUSION_TESTNET]: BUSD_FUSION_TESTNET,
  [ChainId.HECO]: BUSD_HECO,
  [ChainId.HECO_TESTNET]: BUSD_HECO_TESTNET,
  [ChainId.KCC]: BUSD_KCC,
  [ChainId.KCC_TESTNET]: BUSD_KCC_TESTNET,
  [ChainId.KLAYTN]: BUSD_KLAYTN,
  [ChainId.KLAYTN_BAOBAB]: BUSD_KLAYTN_BAOBAB,
  [ChainId.OKXCHAIN]: BUSD_OKXCHAIN,
  [ChainId.OKXCHAIN_TESTNET]: BUSD_OKXCHAIN_TESTNET,
  [ChainId.THETHA]: BUSD_THETHA,
  [ChainId.THETHA_TESTNET]: BUSD_THETHA_TESTNET,
  [ChainId.ULTRON]: BUSD_ULTRON,
  [ChainId.ULTRON_TESTNET]: BUSD_ULTRON_TESTNET,
  [ChainId.MOONBEAM]: BUSD_MOONBEAM,
  [ChainId.MOONRIVER]: BUSD_MOONRIVER,
  [ChainId.MOONBASE_ALPHA]: BUSD_MOONBASE_ALPHA,
  [ChainId.AURORA]: BUSD_AURORA,
  [ChainId.AURORA_TESTNET]: BUSD_AURORA_TESTNET,
  [ChainId.BOBA]: BUSD_BOBA,
  [ChainId.BOBA_GOERLI]: BUSD_BOBA_GOERLI,
  [ChainId.GNOSIS]: BUSD_GNOSIS,
  [ChainId.GNOSIS_CHIADO]: BUSD_GNOSIS_CHIADO,
  [ChainId.METIS]: BUSD_METIS,
  [ChainId.METIS_GOERLI]: BUSD_METIS_GOERLI,
  [ChainId.TELOS]: BUSD_TELOS,
  [ChainId.TELOS_TESTNET]: BUSD_TELOS_TESTNET,
  [ChainId.SYSCOIN]: BUSD_SYSCOIN,
  [ChainId.SYSCOIN_TANENBAUM]: BUSD_SYSCOIN_TANENBAUM,
  [ChainId.IOTEX]: BUSD_IOTEX,
  [ChainId.IOTEX_TESTNET]: BUSD_IOTEX_TESTNET,
  [ChainId.SHIDEN]: BUSD_SHIDEN,
  [ChainId.ASTAR]: BUSD_ASTAR,
  [ChainId.SHIBUNYA]: BUSD_SHIBUNYA,
  [ChainId.FUSE]: BUSD_FUSE,
  [ChainId.FUSE_SPARKNET]: BUSD_FUSE_SPARKNET,
  [ChainId.VELAS]: BUSD_VELAS,
  [ChainId.VELAS_TESTNET]: BUSD_VELAS_TESTNET,
  [ChainId.REI]: BUSD_REI,
  [ChainId.REI_TESTNET]: BUSD_REI_TESTNET,
  [ChainId.KEKCHAIN]: BUSD_KEKCHAIN,
  [ChainId.KEKCHAIN_TESTNET]: BUSD_KEKCHAIN_TESTNET,
  [ChainId.TOMOCHAIN]: BUSD_TOMOCHAIN,
  [ChainId.TOMOCHAIN_TESTNET]: BUSD_TOMOCHAIN_TESTNET,
  [ChainId.THUNDERCORE]: BUSD_THUNDERCORE,
  [ChainId.THUNDERCORE_TESTNET]: BUSD_THUNDERCORE_TESTNET,
  [ChainId.WANCHAIN]: BUSD_WANCHAIN,
  [ChainId.WANCHAIN_TESTNET]: BUSD_WANCHAIN_TESTNET,
  [ChainId.RSK]: BUSD_RSK,
  [ChainId.RSK_TESTNET]: BUSD_RSK_TESTNET,
  [ChainId.ELASTOS]: BUSD_ELASTOS,
  [ChainId.ELASTOS_TESTNET]: BUSD_ELASTOS_TESTNET,
  [ChainId.CONFLUX]: BUSD_CONFLUX,
  [ChainId.CONFLUX_TESTNET]: BUSD_CONFLUX_TESTNET,
  [ChainId.BRISECHAIN]: BUSD_BRISECHAIN,
  [ChainId.BRISECHAIN_TESTNET]: BUSD_BRISECHAIN_TESTNET,
  [ChainId.MUUCHAIN]: BUSD_MUUCHAIN,
  [ChainId.MUUCHAIN_TESTNET]: BUSD_MUUCHAIN_TESTNET,
  [ChainId.CANTO]: BUSD_CANTO,
  [ChainId.CANTO_TESTNET]: BUSD_CANTO_TESTNET,
  [ChainId.OASIS_EMERALD]: BUSD_OASIS_EMERALD,
  [ChainId.OASIS_TESTNET]: BUSD_OASIS_TESTNET,
  [ChainId.VISION]: BUSD_VISION,
  [ChainId.VISION_TESTNET]: BUSD_VISION_TESTNET,
  [ChainId.STEP]: BUSD_STEP,
  [ChainId.STEP_TESTNET]: BUSD_STEP_TESTNET,
  [ChainId.METER]: BUSD_METER,
  [ChainId.METER_TESTNET]: BUSD_METER_TESTNET,
  [ChainId.GODWOKEN]: BUSD_GODWOKEN,
  [ChainId.GODWOKEN_TESTNET]: BUSD_GODWOKEN_TESTNET,
  [ChainId.CALLISTO]: BUSD_CALLISTO,
  [ChainId.CALLISTO_TESTNET]: BUSD_CALLISTO_TESTNET,
  [ChainId.EVMOS]: BUSD_EVMOS,
  [ChainId.EVMOS_TESTNET]: BUSD_EVMOS_TESTNET,
  [ChainId.ENERGY_WEB_CHAIN]: BUSD_ENERGY_WEB_CHAIN,
  [ChainId.ENERGY_VOLTA]: BUSD_ENERGY_VOLTA,
  [ChainId.BASE]: BUSD_BASE,
  [ChainId.BASE_GOERLI]: BUSD_BASE_GOERLI,
  [ChainId.KAVA]: BUSD_KAVA,
  [ChainId.KAVA_TESTNET]: BUSD_KAVA_TESTNET,
  [ChainId.CLOVER]: BUSD_CLOVER,
  [ChainId.CLOVER_TESTNET]: BUSD_CLOVER_TESTNET,
  [ChainId.DEFICHAIN]: BUSD_DEFICHAIN,
  [ChainId.DEFICHAIN_TESTNET]: BUSD_DEFICHAIN_TESTNET,
  [ChainId.BRONOS]: BUSD_BRONOS,
  [ChainId.BRONOS_TESTNET]: BUSD_BRONOS_TESTNET,
  [ChainId.FILECOIN]: BUSD_FILECOIN,
  [ChainId.FILECOIN_CALIBRATION]: BUSD_FILECOIN_CALIBRATION,
  [ChainId.FLARE]: BUSD_FLARE,
  [ChainId.FLARE_TESTNET]: BUSD_FLARE_TESTNET,
  [ChainId.TARAXA]: BUSD_TARAXA,
  [ChainId.TARAXA_TESTNET]: BUSD_TARAXA_TESTNET,
  [ChainId.ZKSYNC_TESTNET]: BUSD_ZKSYNC_TESTNET,
  [ChainId.ZKSYNC]: new ERC20Token(
    ChainId.ZKSYNC,
    "0x2039bb4116B4EFc145Ec4f0e2eA75012D6C0f181",
    18,
    "BUSD",
    "Binance USD"
  ),
  [ChainId.LINEA]: BUSD_LINEA,
  [ChainId.LINEA_TESTNET]: BUSD_LINEA_TESTNET,
  [ChainId.BTTCHAIN]: BUSD_BTTCHAIN,
  [ChainId.BTTCHAIN_TESTNET]: BUSD_BTTCHAIN_TESTNET,
  [ChainId.BOBA_AVAX]: BUSD_BOBA_AVAX,
  [ChainId.BOBA_BNB]: BUSD_BOBA_BNB,
  [ChainId.CMP]: BUSD_CMP,
  [ChainId.CMP_TESTNET]: BUSD_CMP_TESTNET,
  [ChainId.CORE]: BUSD_CORE,
  [ChainId.CORE_TESTNET]: BUSD_CORE_TESTNET,
  [ChainId.CUBECHAIN]: BUSD_CUBECHAIN,
  [ChainId.CUBECHAIN_TESTNET]: BUSD_CUBECHAIN,
  [ChainId.DARWINIA_CRAB]: BUSD_DARWINIA_CRAB,
  [ChainId.DARWINIA_PANGOLIN]: BUSD_DARWINIA_PANGOLIN,
  [ChainId.DIODE_PRETNET]: BUSD_DIODE_PRETNET,
  [ChainId.DIODE_TESTNET]: BUSD_DIODE_TESTNET,
  [ChainId.GOCHAIN]: BUSD_GOCHAIN,
  [ChainId.GOCHAIN_TESTNET]: BUSD_GOCHAIN_TESTNET,
  [ChainId.HAQQ]: BUSD_HAQQ,
  [ChainId.HAQQ_TESTEDGE2]: BUSD_HAQQ_TESTEDGE2,
  [ChainId.KARDIACHAIN]: BUSD_KARDIACHAIN,
  [ChainId.KARDIACHAIN_TESTNET]: BUSD_KARDIACHAIN_TESTNET,
  [ChainId.METADIUM]: BUSD_METADIUM,
  [ChainId.METADIUM_TESTNET]: BUSD_METADIUM_TESTNET,
  [ChainId.OP_BNB]: BUSD_OP_BNB,
  [ChainId.OP_BNB_TESTNET]: BUSD_OP_BNB_TESTNET,
  [ChainId.PALM]: BUSD_PALM,
  [ChainId.PALM_TESTNET]: BUSD_PALM_TESTNET,
  [ChainId.POLIS]: BUSD_POLIS,
  [ChainId.POLIS_TESTNET]: BUSD_POLIS_TESTNET,
  [ChainId.SHIBACHAIN]: BUSD_SHIBACHAIN,
  [ChainId.SMART_BCH]: BUSD_SMART_BCH,
  [ChainId.SMART_BCH_TESTNET]: BUSD_SMART_BCH_TESTNET,
  [ChainId.SONGBIRD_CANARY]: BUSD_SONGBIRD_CANARY,
  [ChainId.THAICHAIN]: BUSD_THAICHAIN,
  [ChainId.UBIQ]: BUSD_UBIQ,
  [ChainId.UBIQ_TESTNET]: BUSD_UBIQ_TESTNET,
  [ChainId.VECHAIN]: BUSD_VECHAIN,
  [ChainId.VECHAIN_TESTNET]: BUSD_VECHAIN_TESTNET,
  [ChainId.XINFIN]: BUSD_XINFIN,
  [ChainId.XINFIN_APOTHEM]: BUSD_XINFIN_APOTHEM,
  [ChainId.SCROLL]: BUSD_SCROLL,
  [ChainId.SCROLL_SEPOLIA]: BUSD_SCROLL_SEPOLIA,
  [ChainId.XRPL_DEVNET]: BUSD_XRPL_DEVNET,
  [ChainId.ZETACHAIN]: BUSD_ZETACHAIN,
  [ChainId.ZETACHAIN_ATHENS]: BUSD_ZETACHAIN_ATHENS,
  [ChainId.ZYX]: BUSD_ZYX
};
var FLAME = {
  [ChainId.FIRECHAIN]: FLAME_FIRECHAIN,
  [ChainId.RINIA]: FLAME_RINIA,
  [ChainId.FIRECHAIN_ZKEVM]: FLAME_FIRECHAIN_ZKEVM,
  [ChainId.FIRECHAIN_ZKEVM_GHOSTRIDER]: FLAME_FIRECHAIN_ZKEVM_GHOSTRIDER,
  [ChainId.ETHEREUM]: FLAME_ETH,
  [ChainId.GOERLI]: FLAME_GOERLI,
  [ChainId.SEPOLIA]: FLAME_SEPOLIA,
  [ChainId.HOLESKY]: FLAME_HOLESKY,
  [ChainId.BSC]: FLAME_MAINNET,
  [ChainId.BSC_TESTNET]: FLAME_TESTNET,
  [ChainId.POLYGON]: FLAME_POLYGON,
  [ChainId.POLYGON_AMOY]: FLAME_AMOY,
  [ChainId.POLYGON_ZKEVM]: FLAME_POLYGON_ZKEVM,
  [ChainId.POLYGON_ZKEVM_TESTNET]: FLAME_POLYGON_ZKEVM_TESTNET,
  [ChainId.CRO]: FLAME_CRO,
  [ChainId.CRO_TESTNET]: FLAME_CRO_TESTNET,
  [ChainId.AVALANCHE]: FLAME_AVALANCHE,
  [ChainId.AVALANCHE_FUJI]: FLAME_FUJI,
  [ChainId.FANTOM_OPERA]: FLAME_FANTOM_OPERA,
  [ChainId.FANTOM_TESTNET]: FLAME_FANTOM_TESTNET,
  [ChainId.CELO]: FLAME_CELO,
  [ChainId.CELO_ALFAJORES]: FLAME_ALFAJORES,
  [ChainId.OPTIMISM]: FLAME_OPTIMISM,
  [ChainId.OPTIMISM_GOERLI]: FLAME_OPTIMISM_GOERLI,
  [ChainId.ARBITRUM_ONE]: FLAME_ARBITRUM,
  [ChainId.ARBITRUM_GOERLI]: FLAME_ARBITRUM_GOERLI,
  [ChainId.SHIBARIUM]: FLAME_SHIBARIUM,
  [ChainId.SHIBARIUM_TESTNET]: FLAME_SHIBARIUM_TESTNET,
  [ChainId.PULSECHAIN]: FLAME_PULSECHAIN,
  [ChainId.PULSECHAIN_TESTNET]: FLAME_PULSECHAIN_TESTNET,
  [ChainId.XEN]: FLAME_XEN,
  [ChainId.XEN_DEVNET]: FLAME_XEN_DEVNET,
  [ChainId.HARMONY]: FLAME_HARMONY,
  [ChainId.HARMONY_TESTNET]: FLAME_HARMONY_TESTNET,
  [ChainId.COINEX]: FLAME_COINEX,
  [ChainId.COINEX_TESTNET]: FLAME_COINEX_TESTNET,
  [ChainId.DOGECHAIN]: FLAME_DOGECHAIN,
  [ChainId.DOGECHAIN_TESTNET]: FLAME_DOGECHAIN_TESTNET,
  [ChainId.ENGRAM_TESTNET]: FLAME_ENGRAM_TESTNET,
  [ChainId.ETHEREUM_CLASSIC]: FLAME_ETHEREUM_CLASSIC,
  [ChainId.ETHEREUM_CLASSIC_TESTNET]: FLAME_ETHEREUM_CLASSIC_TESTNET,
  [ChainId.FUSION]: FLAME_FUSION,
  [ChainId.FUSION_TESTNET]: FLAME_FUSION_TESTNET,
  [ChainId.HECO]: FLAME_HECO,
  [ChainId.HECO_TESTNET]: FLAME_HECO_TESTNET,
  [ChainId.KCC]: FLAME_KCC,
  [ChainId.KCC_TESTNET]: FLAME_KCC_TESTNET,
  [ChainId.KLAYTN]: FLAME_KLAYTN,
  [ChainId.KLAYTN_BAOBAB]: FLAME_KLAYTN_BAOBAB,
  [ChainId.OKXCHAIN]: FLAME_OKXCHAIN,
  [ChainId.OKXCHAIN_TESTNET]: FLAME_OKXCHAIN_TESTNET,
  [ChainId.THETHA]: FLAME_THETHA,
  [ChainId.THETHA_TESTNET]: FLAME_THETHA_TESTNET,
  [ChainId.ULTRON]: FLAME_ULTRON,
  [ChainId.ULTRON_TESTNET]: FLAME_ULTRON_TESTNET,
  [ChainId.MOONBEAM]: FLAME_MOONBEAM,
  [ChainId.MOONRIVER]: FLAME_MOONRIVER,
  [ChainId.MOONBASE_ALPHA]: FLAME_MOONBASE_ALPHA,
  [ChainId.AURORA]: FLAME_AURORA,
  [ChainId.AURORA_TESTNET]: FLAME_AURORA_TESTNET,
  [ChainId.BOBA]: FLAME_BOBA,
  [ChainId.BOBA_GOERLI]: FLAME_BOBA_GOERLI,
  [ChainId.GNOSIS]: FLAME_GNOSIS,
  [ChainId.GNOSIS_CHIADO]: FLAME_GNOSIS_CHIADO,
  [ChainId.METIS]: FLAME_METIS,
  [ChainId.METIS_GOERLI]: FLAME_METIS_GOERLI,
  [ChainId.TELOS]: FLAME_TELOS,
  [ChainId.TELOS_TESTNET]: FLAME_TELOS_TESTNET,
  [ChainId.SYSCOIN]: FLAME_SYSCOIN,
  [ChainId.SYSCOIN_TANENBAUM]: FLAME_SYSCOIN_TANENBAUM,
  [ChainId.IOTEX]: FLAME_IOTEX,
  [ChainId.IOTEX_TESTNET]: FLAME_IOTEX_TESTNET,
  [ChainId.SHIDEN]: FLAME_SHIDEN,
  [ChainId.ASTAR]: FLAME_ASTAR,
  [ChainId.SHIBUNYA]: FLAME_SHIBUNYA,
  [ChainId.FUSE]: FLAME_FUSE,
  [ChainId.FUSE_SPARKNET]: FLAME_FUSE_SPARKNET,
  [ChainId.VELAS]: FLAME_VELAS,
  [ChainId.VELAS_TESTNET]: FLAME_VELAS_TESTNET,
  [ChainId.REI]: FLAME_REI,
  [ChainId.REI_TESTNET]: FLAME_REI_TESTNET,
  [ChainId.KEKCHAIN]: FLAME_KEKCHAIN,
  [ChainId.KEKCHAIN_TESTNET]: FLAME_KEKCHAIN_TESTNET,
  [ChainId.TOMOCHAIN]: FLAME_TOMOCHAIN,
  [ChainId.TOMOCHAIN_TESTNET]: FLAME_TOMOCHAIN_TESTNET,
  [ChainId.THUNDERCORE]: FLAME_THUNDERCORE,
  [ChainId.THUNDERCORE_TESTNET]: FLAME_THUNDERCORE_TESTNET,
  [ChainId.WANCHAIN]: FLAME_WANCHAIN,
  [ChainId.WANCHAIN_TESTNET]: FLAME_WANCHAIN_TESTNET,
  [ChainId.RSK]: FLAME_RSK,
  [ChainId.RSK_TESTNET]: FLAME_RSK_TESTNET,
  [ChainId.ELASTOS]: FLAME_ELASTOS,
  [ChainId.ELASTOS_TESTNET]: FLAME_ELASTOS_TESTNET,
  [ChainId.CONFLUX]: FLAME_CONFLUX,
  [ChainId.CONFLUX_TESTNET]: FLAME_CONFLUX_TESTNET,
  [ChainId.BRISECHAIN]: FLAME_BRISECHAIN,
  [ChainId.BRISECHAIN_TESTNET]: FLAME_BRISECHAIN_TESTNET,
  [ChainId.MUUCHAIN]: FLAME_MUUCHAIN,
  [ChainId.MUUCHAIN_TESTNET]: FLAME_MUUCHAIN_TESTNET,
  [ChainId.CANTO]: FLAME_CANTO,
  [ChainId.CANTO_TESTNET]: FLAME_CANTO_TESTNET,
  [ChainId.OASIS_EMERALD]: FLAME_OASIS_EMERALD,
  [ChainId.OASIS_TESTNET]: FLAME_OASIS_TESTNET,
  [ChainId.VISION]: FLAME_VISION,
  [ChainId.VISION_TESTNET]: FLAME_VISION_TESTNET,
  [ChainId.STEP]: FLAME_STEP,
  [ChainId.STEP_TESTNET]: FLAME_STEP_TESTNET,
  [ChainId.METER]: FLAME_METER,
  [ChainId.METER_TESTNET]: FLAME_METER_TESTNET,
  [ChainId.GODWOKEN]: FLAME_GODWOKEN,
  [ChainId.GODWOKEN_TESTNET]: FLAME_GODWOKEN_TESTNET,
  [ChainId.CALLISTO]: FLAME_CALLISTO,
  [ChainId.CALLISTO_TESTNET]: FLAME_CALLISTO_TESTNET,
  [ChainId.EVMOS]: FLAME_EVMOS,
  [ChainId.EVMOS_TESTNET]: FLAME_EVMOS_TESTNET,
  [ChainId.ENERGY_WEB_CHAIN]: FLAME_ENERGY_WEB_CHAIN,
  [ChainId.ENERGY_VOLTA]: FLAME_ENERGY_VOLTA,
  [ChainId.BASE]: FLAME_BASE,
  [ChainId.BASE_GOERLI]: FLAME_BASE_GOERLI,
  [ChainId.KAVA]: FLAME_KAVA,
  [ChainId.KAVA_TESTNET]: FLAME_KAVA_TESTNET,
  [ChainId.CLOVER]: FLAME_CLOVER,
  [ChainId.CLOVER_TESTNET]: FLAME_CLOVER_TESTNET,
  [ChainId.DEFICHAIN]: FLAME_DEFICHAIN,
  [ChainId.DEFICHAIN_TESTNET]: FLAME_DEFICHAIN_TESTNET,
  [ChainId.BRONOS]: FLAME_BRONOS,
  [ChainId.BRONOS_TESTNET]: FLAME_BRONOS_TESTNET,
  [ChainId.FILECOIN]: FLAME_FILECOIN,
  [ChainId.FILECOIN_CALIBRATION]: FLAME_FILECOIN_CALIBRATION,
  [ChainId.FLARE]: FLAME_FLARE,
  [ChainId.FLARE_TESTNET]: FLAME_FLARE_TESTNET,
  [ChainId.TARAXA]: FLAME_TARAXA,
  [ChainId.TARAXA_TESTNET]: FLAME_TARAXA_TESTNET,
  [ChainId.ZKSYNC]: FLAME_ZKSYNC,
  [ChainId.ZKSYNC_TESTNET]: FLAME_ZKSYNC_TESTNET,
  [ChainId.LINEA]: FLAME_LINEA,
  [ChainId.LINEA_TESTNET]: FLAME_LINEA_TESTNET,
  [ChainId.BTTCHAIN]: FLAME_BTTCHAIN,
  [ChainId.BTTCHAIN_TESTNET]: FLAME_BTTCHAIN_TESTNET,
  [ChainId.BOBA_AVAX]: FLAME_BOBA_AVAX,
  [ChainId.BOBA_BNB]: FLAME_BOBA_BNB,
  [ChainId.CMP]: FLAME_CMP,
  [ChainId.CMP_TESTNET]: FLAME_CMP_TESTNET,
  [ChainId.CORE]: FLAME_CORE,
  [ChainId.CORE_TESTNET]: FLAME_CORE_TESTNET,
  [ChainId.CUBECHAIN]: FLAME_CUBECHAIN,
  [ChainId.CUBECHAIN_TESTNET]: FLAME_CUBECHAIN,
  [ChainId.DARWINIA_CRAB]: FLAME_DARWINIA_CRAB,
  [ChainId.DARWINIA_PANGOLIN]: FLAME_DARWINIA_PANGOLIN,
  [ChainId.DIODE_PRETNET]: FLAME_DIODE_PRETNET,
  [ChainId.DIODE_TESTNET]: FLAME_DIODE_TESTNET,
  [ChainId.GOCHAIN]: FLAME_GOCHAIN,
  [ChainId.GOCHAIN_TESTNET]: FLAME_GOCHAIN_TESTNET,
  [ChainId.HAQQ]: FLAME_HAQQ,
  [ChainId.HAQQ_TESTEDGE2]: FLAME_HAQQ_TESTEDGE2,
  [ChainId.KARDIACHAIN]: FLAME_KARDIACHAIN,
  [ChainId.KARDIACHAIN_TESTNET]: FLAME_KARDIACHAIN_TESTNET,
  [ChainId.METADIUM]: FLAME_METADIUM,
  [ChainId.METADIUM_TESTNET]: FLAME_METADIUM_TESTNET,
  [ChainId.OP_BNB]: FLAME_OP_BNB,
  [ChainId.OP_BNB_TESTNET]: FLAME_OP_BNB_TESTNET,
  [ChainId.PALM]: FLAME_PALM,
  [ChainId.PALM_TESTNET]: FLAME_PALM_TESTNET,
  [ChainId.POLIS]: FLAME_POLIS,
  [ChainId.POLIS_TESTNET]: FLAME_POLIS_TESTNET,
  [ChainId.SHIBACHAIN]: FLAME_SHIBACHAIN,
  [ChainId.SMART_BCH]: FLAME_SMART_BCH,
  [ChainId.SMART_BCH_TESTNET]: FLAME_SMART_BCH_TESTNET,
  [ChainId.SONGBIRD_CANARY]: FLAME_SONGBIRD_CANARY,
  [ChainId.THAICHAIN]: FLAME_THAICHAIN,
  [ChainId.UBIQ]: FLAME_UBIQ,
  [ChainId.UBIQ_TESTNET]: FLAME_UBIQ_TESTNET,
  [ChainId.VECHAIN]: FLAME_VECHAIN,
  [ChainId.VECHAIN_TESTNET]: FLAME_VECHAIN_TESTNET,
  [ChainId.XINFIN]: FLAME_XINFIN,
  [ChainId.XINFIN_APOTHEM]: FLAME_XINFIN_APOTHEM,
  [ChainId.SCROLL]: FLAME_SCROLL,
  [ChainId.SCROLL_SEPOLIA]: FLAME_SCROLL_SEPOLIA,
  [ChainId.XRPL_DEVNET]: FLAME_XRPL_DEVNET,
  [ChainId.ZETACHAIN]: FLAME_ZETACHAIN,
  [ChainId.ZETACHAIN_ATHENS]: FLAME_ZETACHAIN_ATHENS,
  [ChainId.ZYX]: FLAME_ZYX
};
var USDC = {
  [ChainId.BSC]: USDC_BSC,
  [ChainId.BSC_TESTNET]: USDC_TESTNET,
  [ChainId.ETHEREUM]: USDC_ETH,
  [ChainId.GOERLI]: USDC_GOERLI,
  [ChainId.ZKSYNC]: new ERC20Token(
    ChainId.ZKSYNC,
    "0x3355df6D4c9C3035724Fd0e3914dE96A5a83aaf4",
    6,
    "USDC",
    "USD Coin"
  ),
  [ChainId.ZKSYNC_TESTNET]: new ERC20Token(
    ChainId.ZKSYNC_TESTNET,
    "0x0faF6df7054946141266420b43783387A78d82A9",
    6,
    "USDC",
    "USD Coin"
  ),
  [ChainId.ARBITRUM_ONE]: new ERC20Token(
    ChainId.ARBITRUM_ONE,
    "0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8",
    6,
    "USDC",
    "USD Coin"
  ),
  [ChainId.ARBITRUM_GOERLI]: new ERC20Token(
    ChainId.ARBITRUM_GOERLI,
    "0x179522635726710Dd7D2035a81d856de4Aa7836c",
    6,
    "USDC",
    "USD Coin"
  ),
  [ChainId.POLYGON_ZKEVM]: new ERC20Token(
    ChainId.POLYGON_ZKEVM,
    "0xA8CE8aee21bC2A48a5EF670afCc9274C7bbbC035",
    6,
    "USDC",
    "USD Coin"
  ),
  [ChainId.LINEA]: new ERC20Token(
    ChainId.LINEA,
    "0xf56dc6695cF1f5c364eDEbC7Dc7077ac9B586068",
    6,
    "USDC",
    "USD Coin"
  ),
  [ChainId.LINEA_TESTNET]: new ERC20Token(
    ChainId.LINEA_TESTNET,
    "0xf56dc6695cF1f5c364eDEbC7Dc7077ac9B586068",
    6,
    "USDC",
    "USD Coin"
  )
};
var USDT = {
  [ChainId.FIRECHAIN]: USDT_FIRECHAIN,
  [ChainId.RINIA]: USDT_RINIA,
  [ChainId.FIRECHAIN_ZKEVM]: USDT_FIRECHAIN_ZKEVM,
  [ChainId.FIRECHAIN_ZKEVM_GHOSTRIDER]: USDT_FIRECHAIN_ZKEVM_GHOSTRIDER,
  [ChainId.BSC]: USDT_BSC,
  [ChainId.ETHEREUM]: USDT_ETH,
  [ChainId.SEPOLIA]: USDT_SEPOLIA,
  [ChainId.HOLESKY]: USDT_HOLESKY,
  [ChainId.POLYGON]: USDT_POLYGON,
  [ChainId.POLYGON_AMOY]: USDT_AMOY,
  [ChainId.POLYGON_ZKEVM]: USDT_POLYGON_ZKEVM,
  [ChainId.POLYGON_ZKEVM_TESTNET]: USDT_POLYGON_ZKEVM_TESTNET,
  [ChainId.CRO]: USDT_CRO,
  [ChainId.CRO_TESTNET]: USDT_CRO_TESTNET,
  [ChainId.AVALANCHE]: USDT_AVALANCHE,
  [ChainId.AVALANCHE_FUJI]: USDT_FUJI,
  [ChainId.FANTOM_OPERA]: USDT_FANTOM_OPERA,
  [ChainId.FANTOM_TESTNET]: USDT_FANTOM_TESTNET,
  [ChainId.CELO]: USDT_CELO,
  [ChainId.CELO_ALFAJORES]: USDT_ALFAJORES,
  [ChainId.OPTIMISM]: USDT_OPTIMISM,
  [ChainId.OPTIMISM_GOERLI]: USDT_OPTIMISM_GOERLI,
  [ChainId.SHIBARIUM]: USDT_SHIBARIUM,
  [ChainId.SHIBARIUM_TESTNET]: USDT_SHIBARIUM_TESTNET,
  [ChainId.PULSECHAIN]: USDT_PULSECHAIN,
  [ChainId.PULSECHAIN_TESTNET]: USDT_PULSECHAIN_TESTNET,
  [ChainId.XEN]: USDT_XEN,
  [ChainId.XEN_DEVNET]: USDT_XEN_DEVNET,
  [ChainId.HARMONY]: USDT_HARMONY,
  [ChainId.HARMONY_TESTNET]: USDT_HARMONY_TESTNET,
  [ChainId.COINEX]: USDT_COINEX,
  [ChainId.COINEX_TESTNET]: USDT_COINEX_TESTNET,
  [ChainId.DOGECHAIN]: USDT_DOGECHAIN,
  [ChainId.DOGECHAIN_TESTNET]: USDT_DOGECHAIN_TESTNET,
  [ChainId.ENGRAM_TESTNET]: USDT_ENGRAM_TESTNET,
  [ChainId.ETHEREUM_CLASSIC]: USDT_ETHEREUM_CLASSIC,
  [ChainId.ETHEREUM_CLASSIC_TESTNET]: USDT_ETHEREUM_CLASSIC_TESTNET,
  [ChainId.FUSION]: USDT_FUSION,
  [ChainId.FUSION_TESTNET]: USDT_FUSION_TESTNET,
  [ChainId.HECO]: USDT_HECO,
  [ChainId.HECO_TESTNET]: USDT_HECO_TESTNET,
  [ChainId.KCC]: USDT_KCC,
  [ChainId.KCC_TESTNET]: USDT_KCC_TESTNET,
  [ChainId.KLAYTN]: USDT_KLAYTN,
  [ChainId.KLAYTN_BAOBAB]: USDT_KLAYTN_BAOBAB,
  [ChainId.OKXCHAIN]: USDT_OKXCHAIN,
  [ChainId.OKXCHAIN_TESTNET]: USDT_OKXCHAIN_TESTNET,
  [ChainId.THETHA]: USDT_THETHA,
  [ChainId.THETHA_TESTNET]: USDT_THETHA_TESTNET,
  [ChainId.ULTRON]: USDT_ULTRON,
  [ChainId.ULTRON_TESTNET]: USDT_ULTRON_TESTNET,
  [ChainId.MOONBEAM]: USDT_MOONBEAM,
  [ChainId.MOONRIVER]: USDT_MOONRIVER,
  [ChainId.MOONBASE_ALPHA]: USDT_MOONBASE_ALPHA,
  [ChainId.AURORA]: USDT_AURORA,
  [ChainId.AURORA_TESTNET]: USDT_AURORA_TESTNET,
  [ChainId.BOBA]: USDT_BOBA,
  [ChainId.BOBA_GOERLI]: USDT_BOBA_GOERLI,
  [ChainId.GNOSIS]: USDT_GNOSIS,
  [ChainId.GNOSIS_CHIADO]: USDT_GNOSIS_CHIADO,
  [ChainId.METIS]: USDT_METIS,
  [ChainId.METIS_GOERLI]: USDT_METIS_GOERLI,
  [ChainId.TELOS]: USDT_TELOS,
  [ChainId.TELOS_TESTNET]: USDT_TELOS_TESTNET,
  [ChainId.SYSCOIN]: USDT_SYSCOIN,
  [ChainId.SYSCOIN_TANENBAUM]: USDT_SYSCOIN_TANENBAUM,
  [ChainId.IOTEX]: USDT_IOTEX,
  [ChainId.IOTEX_TESTNET]: USDT_IOTEX_TESTNET,
  [ChainId.SHIDEN]: USDT_SHIDEN,
  [ChainId.ASTAR]: USDT_ASTAR,
  [ChainId.SHIBUNYA]: USDT_SHIBUNYA,
  [ChainId.FUSE]: USDT_FUSE,
  [ChainId.FUSE_SPARKNET]: USDT_FUSE_SPARKNET,
  [ChainId.VELAS]: USDT_VELAS,
  [ChainId.VELAS_TESTNET]: USDT_VELAS_TESTNET,
  [ChainId.REI]: USDT_REI,
  [ChainId.REI_TESTNET]: USDT_REI_TESTNET,
  [ChainId.KEKCHAIN]: USDT_KEKCHAIN,
  [ChainId.KEKCHAIN_TESTNET]: USDT_KEKCHAIN_TESTNET,
  [ChainId.TOMOCHAIN]: USDT_TOMOCHAIN,
  [ChainId.TOMOCHAIN_TESTNET]: USDT_TOMOCHAIN_TESTNET,
  [ChainId.THUNDERCORE]: USDT_THUNDERCORE,
  [ChainId.THUNDERCORE_TESTNET]: USDT_THUNDERCORE_TESTNET,
  [ChainId.WANCHAIN]: USDT_WANCHAIN,
  [ChainId.WANCHAIN_TESTNET]: USDT_WANCHAIN_TESTNET,
  [ChainId.RSK]: USDT_RSK,
  [ChainId.RSK_TESTNET]: USDT_RSK_TESTNET,
  [ChainId.ELASTOS]: USDT_ELASTOS,
  [ChainId.ELASTOS_TESTNET]: USDT_ELASTOS_TESTNET,
  [ChainId.CONFLUX]: USDT_CONFLUX,
  [ChainId.CONFLUX_TESTNET]: USDT_CONFLUX_TESTNET,
  [ChainId.BRISECHAIN]: USDT_BRISECHAIN,
  [ChainId.BRISECHAIN_TESTNET]: USDT_BRISECHAIN_TESTNET,
  [ChainId.MUUCHAIN]: USDT_MUUCHAIN,
  [ChainId.MUUCHAIN_TESTNET]: USDT_MUUCHAIN_TESTNET,
  [ChainId.CANTO]: USDT_CANTO,
  [ChainId.CANTO_TESTNET]: USDT_CANTO_TESTNET,
  [ChainId.OASIS_EMERALD]: USDT_OASIS_EMERALD,
  [ChainId.OASIS_TESTNET]: USDT_OASIS_TESTNET,
  [ChainId.VISION]: USDT_VISION,
  [ChainId.VISION_TESTNET]: USDT_VISION_TESTNET,
  [ChainId.STEP]: USDT_STEP,
  [ChainId.STEP_TESTNET]: USDT_STEP_TESTNET,
  [ChainId.METER]: USDT_METER,
  [ChainId.METER_TESTNET]: USDT_METER_TESTNET,
  [ChainId.GODWOKEN]: USDT_GODWOKEN,
  [ChainId.GODWOKEN_TESTNET]: USDT_GODWOKEN_TESTNET,
  [ChainId.CALLISTO]: USDT_CALLISTO,
  [ChainId.CALLISTO_TESTNET]: USDT_CALLISTO_TESTNET,
  [ChainId.EVMOS]: USDT_EVMOS,
  [ChainId.EVMOS_TESTNET]: USDT_EVMOS_TESTNET,
  [ChainId.ENERGY_WEB_CHAIN]: USDT_ENERGY_WEB_CHAIN,
  [ChainId.ENERGY_VOLTA]: USDT_ENERGY_VOLTA,
  [ChainId.BASE]: USDT_BASE,
  [ChainId.BASE_GOERLI]: USDT_BASE_GOERLI,
  [ChainId.KAVA]: USDT_KAVA,
  [ChainId.KAVA_TESTNET]: USDT_KAVA_TESTNET,
  [ChainId.CLOVER]: USDT_CLOVER,
  [ChainId.CLOVER_TESTNET]: USDT_CLOVER_TESTNET,
  [ChainId.DEFICHAIN]: USDT_DEFICHAIN,
  [ChainId.DEFICHAIN_TESTNET]: USDT_DEFICHAIN_TESTNET,
  [ChainId.BRONOS]: USDT_BRONOS,
  [ChainId.BRONOS_TESTNET]: USDT_BRONOS_TESTNET,
  [ChainId.FILECOIN]: USDT_FILECOIN,
  [ChainId.FILECOIN_CALIBRATION]: USDT_FILECOIN_CALIBRATION,
  [ChainId.FLARE]: USDT_FLARE,
  [ChainId.FLARE_TESTNET]: USDT_FLARE_TESTNET,
  [ChainId.TARAXA]: USDT_TARAXA,
  [ChainId.TARAXA_TESTNET]: USDT_TARAXA_TESTNET,
  [ChainId.ARBITRUM_ONE]: new ERC20Token(
    ChainId.ARBITRUM_ONE,
    "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
    6,
    "USDT",
    "Tether USD"
  ),
  [ChainId.LINEA]: USDT_LINEA,
  [ChainId.LINEA_TESTNET]: USDT_LINEA_TESTNET,
  [ChainId.BTTCHAIN]: USDT_BTTCHAIN,
  [ChainId.BTTCHAIN_TESTNET]: USDT_BTTCHAIN_TESTNET,
  [ChainId.BOBA_AVAX]: USDT_BOBA_AVAX,
  [ChainId.BOBA_BNB]: USDT_BOBA_BNB,
  [ChainId.CMP]: USDT_CMP,
  [ChainId.CMP_TESTNET]: USDT_CMP_TESTNET,
  [ChainId.CORE]: USDT_CORE,
  [ChainId.CORE_TESTNET]: USDT_CORE_TESTNET,
  [ChainId.CUBECHAIN]: USDT_CUBECHAIN,
  [ChainId.CUBECHAIN_TESTNET]: USDT_CUBECHAIN,
  [ChainId.DARWINIA_CRAB]: USDT_DARWINIA_CRAB,
  [ChainId.DARWINIA_PANGOLIN]: USDT_DARWINIA_PANGOLIN,
  [ChainId.DIODE_PRETNET]: USDT_DIODE_PRETNET,
  [ChainId.DIODE_TESTNET]: USDT_DIODE_TESTNET,
  [ChainId.GOCHAIN]: USDT_GOCHAIN,
  [ChainId.GOCHAIN_TESTNET]: USDT_GOCHAIN_TESTNET,
  [ChainId.HAQQ]: USDT_HAQQ,
  [ChainId.HAQQ_TESTEDGE2]: USDT_HAQQ_TESTEDGE2,
  [ChainId.KARDIACHAIN]: USDT_KARDIACHAIN,
  [ChainId.KARDIACHAIN_TESTNET]: USDT_KARDIACHAIN_TESTNET,
  [ChainId.METADIUM]: USDT_METADIUM,
  [ChainId.METADIUM_TESTNET]: USDT_METADIUM_TESTNET,
  [ChainId.OP_BNB]: USDT_OP_BNB,
  [ChainId.OP_BNB_TESTNET]: USDT_OP_BNB_TESTNET,
  [ChainId.PALM]: USDT_PALM,
  [ChainId.PALM_TESTNET]: USDT_PALM_TESTNET,
  [ChainId.POLIS]: USDT_POLIS,
  [ChainId.POLIS_TESTNET]: USDT_POLIS_TESTNET,
  [ChainId.SHIBACHAIN]: USDT_SHIBACHAIN,
  [ChainId.SMART_BCH]: USDT_SMART_BCH,
  [ChainId.SMART_BCH_TESTNET]: USDT_SMART_BCH_TESTNET,
  [ChainId.SONGBIRD_CANARY]: USDT_SONGBIRD_CANARY,
  [ChainId.THAICHAIN]: USDT_THAICHAIN,
  [ChainId.UBIQ]: USDT_UBIQ,
  [ChainId.UBIQ_TESTNET]: USDT_UBIQ_TESTNET,
  [ChainId.VECHAIN]: USDT_VECHAIN,
  [ChainId.VECHAIN_TESTNET]: USDT_VECHAIN_TESTNET,
  [ChainId.XINFIN]: USDT_XINFIN,
  [ChainId.XINFIN_APOTHEM]: USDT_XINFIN_APOTHEM,
  [ChainId.SCROLL]: USDT_SCROLL,
  [ChainId.SCROLL_SEPOLIA]: USDT_SCROLL_SEPOLIA,
  [ChainId.XRPL_DEVNET]: USDT_XRPL_DEVNET,
  [ChainId.ZETACHAIN]: USDT_ZETACHAIN,
  [ChainId.ZETACHAIN_ATHENS]: USDT_ZETACHAIN_ATHENS,
  [ChainId.ZYX]: USDT_ZYX
};
var DONA = {
  [ChainId.FIRECHAIN]: DONA_FIRECHAIN,
  [ChainId.RINIA]: DONA_RINIA,
  [ChainId.FIRECHAIN_ZKEVM]: DONA_FIRECHAIN_ZKEVM,
  [ChainId.FIRECHAIN_ZKEVM_GHOSTRIDER]: DONA_FIRECHAIN_ZKEVM_GHOSTRIDER,
  [ChainId.BSC]: DONA_BSC,
  [ChainId.BSC_TESTNET]: DONA_TESTNET,
  [ChainId.ETHEREUM]: DONA_ETH,
  [ChainId.GOERLI]: DONA_GOERLI,
  [ChainId.SEPOLIA]: DONA_SEPOLIA,
  [ChainId.HOLESKY]: DONA_HOLESKY,
  [ChainId.POLYGON]: DONA_POLYGON,
  [ChainId.POLYGON_AMOY]: DONA_AMOY,
  [ChainId.POLYGON_ZKEVM]: DONA_POLYGON_ZKEVM,
  [ChainId.POLYGON_ZKEVM_TESTNET]: DONA_POLYGON_ZKEVM_TESTNET,
  [ChainId.CRO]: DONA_CRO,
  [ChainId.CRO_TESTNET]: DONA_CRO_TESTNET,
  [ChainId.AVALANCHE]: DONA_AVALANCHE,
  [ChainId.AVALANCHE_FUJI]: DONA_FUJI,
  [ChainId.FANTOM_OPERA]: DONA_FANTOM_OPERA,
  [ChainId.FANTOM_TESTNET]: DONA_FANTOM_TESTNET,
  [ChainId.CELO]: DONA_CELO,
  [ChainId.CELO_ALFAJORES]: DONA_ALFAJORES,
  [ChainId.OPTIMISM]: DONA_OPTIMISM,
  [ChainId.OPTIMISM_GOERLI]: DONA_OPTIMISM_GOERLI,
  [ChainId.ARBITRUM_ONE]: DONA_ARBITRUM,
  [ChainId.ARBITRUM_GOERLI]: DONA_ARBITRUM_GOERLI,
  [ChainId.SHIBARIUM]: DONA_SHIBARIUM,
  [ChainId.SHIBARIUM_TESTNET]: DONA_SHIBARIUM_TESTNET,
  [ChainId.PULSECHAIN]: DONA_PULSECHAIN,
  [ChainId.PULSECHAIN_TESTNET]: DONA_PULSECHAIN_TESTNET,
  [ChainId.XEN]: DONA_XEN,
  [ChainId.XEN_DEVNET]: DONA_XEN_DEVNET,
  [ChainId.HARMONY]: DONA_HARMONY,
  [ChainId.HARMONY_TESTNET]: DONA_HARMONY_TESTNET,
  [ChainId.COINEX]: DONA_COINEX,
  [ChainId.COINEX_TESTNET]: DONA_COINEX_TESTNET,
  [ChainId.DOGECHAIN]: DONA_DOGECHAIN,
  [ChainId.DOGECHAIN_TESTNET]: DONA_DOGECHAIN_TESTNET,
  [ChainId.ENGRAM_TESTNET]: DONA_ENGRAM_TESTNET,
  [ChainId.ETHEREUM_CLASSIC]: DONA_ETHEREUM_CLASSIC,
  [ChainId.ETHEREUM_CLASSIC_TESTNET]: DONA_ETHEREUM_CLASSIC_TESTNET,
  [ChainId.FUSION]: DONA_FUSION,
  [ChainId.FUSION_TESTNET]: DONA_FUSION_TESTNET,
  [ChainId.HECO]: DONA_HECO,
  [ChainId.HECO_TESTNET]: DONA_HECO_TESTNET,
  [ChainId.KCC]: DONA_KCC,
  [ChainId.KCC_TESTNET]: DONA_KCC_TESTNET,
  [ChainId.KLAYTN]: DONA_KLAYTN,
  [ChainId.KLAYTN_BAOBAB]: DONA_KLAYTN_BAOBAB,
  [ChainId.OKXCHAIN]: DONA_OKXCHAIN,
  [ChainId.OKXCHAIN_TESTNET]: DONA_OKXCHAIN_TESTNET,
  [ChainId.THETHA]: DONA_THETHA,
  [ChainId.THETHA_TESTNET]: DONA_THETHA_TESTNET,
  [ChainId.ULTRON]: DONA_ULTRON,
  [ChainId.ULTRON_TESTNET]: DONA_ULTRON_TESTNET,
  [ChainId.MOONBEAM]: DONA_MOONBEAM,
  [ChainId.MOONRIVER]: DONA_MOONRIVER,
  [ChainId.MOONBASE_ALPHA]: DONA_MOONBASE_ALPHA,
  [ChainId.AURORA]: DONA_AURORA,
  [ChainId.AURORA_TESTNET]: DONA_AURORA_TESTNET,
  [ChainId.BOBA]: DONA_BOBA,
  [ChainId.BOBA_GOERLI]: DONA_BOBA_GOERLI,
  [ChainId.GNOSIS]: DONA_GNOSIS,
  [ChainId.GNOSIS_CHIADO]: DONA_GNOSIS_CHIADO,
  [ChainId.METIS]: DONA_METIS,
  [ChainId.METIS_GOERLI]: DONA_METIS_GOERLI,
  [ChainId.TELOS]: DONA_TELOS,
  [ChainId.TELOS_TESTNET]: DONA_TELOS_TESTNET,
  [ChainId.SYSCOIN]: DONA_SYSCOIN,
  [ChainId.SYSCOIN_TANENBAUM]: DONA_SYSCOIN_TANENBAUM,
  [ChainId.IOTEX]: DONA_IOTEX,
  [ChainId.IOTEX_TESTNET]: DONA_IOTEX_TESTNET,
  [ChainId.SHIDEN]: DONA_SHIDEN,
  [ChainId.ASTAR]: DONA_ASTAR,
  [ChainId.SHIBUNYA]: DONA_SHIBUNYA,
  [ChainId.FUSE]: DONA_FUSE,
  [ChainId.FUSE_SPARKNET]: DONA_FUSE_SPARKNET,
  [ChainId.VELAS]: DONA_VELAS,
  [ChainId.VELAS_TESTNET]: DONA_VELAS_TESTNET,
  [ChainId.REI]: DONA_REI,
  [ChainId.REI_TESTNET]: DONA_REI_TESTNET,
  [ChainId.KEKCHAIN]: DONA_KEKCHAIN,
  [ChainId.KEKCHAIN_TESTNET]: DONA_KEKCHAIN_TESTNET,
  [ChainId.TOMOCHAIN]: DONA_TOMOCHAIN,
  [ChainId.TOMOCHAIN_TESTNET]: DONA_TOMOCHAIN_TESTNET,
  [ChainId.THUNDERCORE]: DONA_THUNDERCORE,
  [ChainId.THUNDERCORE_TESTNET]: DONA_THUNDERCORE_TESTNET,
  [ChainId.WANCHAIN]: DONA_WANCHAIN,
  [ChainId.WANCHAIN_TESTNET]: DONA_WANCHAIN_TESTNET,
  [ChainId.RSK]: DONA_RSK,
  [ChainId.RSK_TESTNET]: DONA_RSK_TESTNET,
  [ChainId.ELASTOS]: DONA_ELASTOS,
  [ChainId.ELASTOS_TESTNET]: DONA_ELASTOS_TESTNET,
  [ChainId.CONFLUX]: DONA_CONFLUX,
  [ChainId.CONFLUX_TESTNET]: DONA_CONFLUX_TESTNET,
  [ChainId.BRISECHAIN]: DONA_BRISECHAIN,
  [ChainId.BRISECHAIN_TESTNET]: DONA_BRISECHAIN_TESTNET,
  [ChainId.MUUCHAIN]: DONA_MUUCHAIN,
  [ChainId.MUUCHAIN_TESTNET]: DONA_MUUCHAIN_TESTNET,
  [ChainId.CANTO]: DONA_CANTO,
  [ChainId.CANTO_TESTNET]: DONA_CANTO_TESTNET,
  [ChainId.OASIS_EMERALD]: DONA_OASIS_EMERALD,
  [ChainId.OASIS_TESTNET]: DONA_OASIS_TESTNET,
  [ChainId.VISION]: DONA_VISION,
  [ChainId.VISION_TESTNET]: DONA_VISION_TESTNET,
  [ChainId.STEP]: DONA_STEP,
  [ChainId.STEP_TESTNET]: DONA_STEP_TESTNET,
  [ChainId.METER]: DONA_METER,
  [ChainId.METER_TESTNET]: DONA_METER_TESTNET,
  [ChainId.GODWOKEN]: DONA_GODWOKEN,
  [ChainId.GODWOKEN_TESTNET]: DONA_GODWOKEN_TESTNET,
  [ChainId.CALLISTO]: DONA_CALLISTO,
  [ChainId.CALLISTO_TESTNET]: DONA_CALLISTO_TESTNET,
  [ChainId.EVMOS]: DONA_EVMOS,
  [ChainId.EVMOS_TESTNET]: DONA_EVMOS_TESTNET,
  [ChainId.ENERGY_WEB_CHAIN]: DONA_ENERGY_WEB_CHAIN,
  [ChainId.ENERGY_VOLTA]: DONA_ENERGY_VOLTA,
  [ChainId.BASE]: DONA_BASE,
  [ChainId.BASE_GOERLI]: DONA_BASE_GOERLI,
  [ChainId.KAVA]: DONA_KAVA,
  [ChainId.KAVA_TESTNET]: DONA_KAVA_TESTNET,
  [ChainId.CLOVER]: DONA_CLOVER,
  [ChainId.CLOVER_TESTNET]: DONA_CLOVER_TESTNET,
  [ChainId.DEFICHAIN]: DONA_DEFICHAIN,
  [ChainId.DEFICHAIN_TESTNET]: DONA_DEFICHAIN_TESTNET,
  [ChainId.BRONOS]: DONA_BRONOS,
  [ChainId.BRONOS_TESTNET]: DONA_BRONOS_TESTNET,
  [ChainId.FILECOIN]: DONA_FILECOIN,
  [ChainId.FILECOIN_CALIBRATION]: DONA_FILECOIN_CALIBRATION,
  [ChainId.FLARE]: DONA_FLARE,
  [ChainId.FLARE_TESTNET]: DONA_FLARE_TESTNET,
  [ChainId.TARAXA]: DONA_TARAXA,
  [ChainId.TARAXA_TESTNET]: DONA_TARAXA_TESTNET,
  [ChainId.ZKSYNC]: DONA_ZKSYNC,
  [ChainId.ZKSYNC_TESTNET]: DONA_ZKSYNC_TESTNET,
  [ChainId.LINEA]: DONA_LINEA,
  [ChainId.LINEA_TESTNET]: DONA_LINEA_TESTNET,
  [ChainId.BTTCHAIN]: DONA_BTTCHAIN,
  [ChainId.BTTCHAIN_TESTNET]: DONA_BTTCHAIN_TESTNET,
  [ChainId.BOBA_AVAX]: DONA_BOBA_AVAX,
  [ChainId.BOBA_BNB]: DONA_BOBA_BNB,
  [ChainId.CMP]: DONA_CMP,
  [ChainId.CMP_TESTNET]: DONA_CMP_TESTNET,
  [ChainId.CORE]: DONA_CORE,
  [ChainId.CORE_TESTNET]: DONA_CORE_TESTNET,
  [ChainId.CUBECHAIN]: DONA_CUBECHAIN,
  [ChainId.CUBECHAIN_TESTNET]: DONA_CUBECHAIN,
  [ChainId.DARWINIA_CRAB]: DONA_DARWINIA_CRAB,
  [ChainId.DARWINIA_PANGOLIN]: DONA_DARWINIA_PANGOLIN,
  [ChainId.DIODE_PRETNET]: DONA_DIODE_PRETNET,
  [ChainId.DIODE_TESTNET]: DONA_DIODE_TESTNET,
  [ChainId.GOCHAIN]: DONA_GOCHAIN,
  [ChainId.GOCHAIN_TESTNET]: DONA_GOCHAIN_TESTNET,
  [ChainId.HAQQ]: DONA_HAQQ,
  [ChainId.HAQQ_TESTEDGE2]: DONA_HAQQ_TESTEDGE2,
  [ChainId.KARDIACHAIN]: DONA_KARDIACHAIN,
  [ChainId.KARDIACHAIN_TESTNET]: DONA_KARDIACHAIN_TESTNET,
  [ChainId.METADIUM]: DONA_METADIUM,
  [ChainId.METADIUM_TESTNET]: DONA_METADIUM_TESTNET,
  [ChainId.OP_BNB]: DONA_OP_BNB,
  [ChainId.OP_BNB_TESTNET]: DONA_OP_BNB_TESTNET,
  [ChainId.PALM]: DONA_PALM,
  [ChainId.PALM_TESTNET]: DONA_PALM_TESTNET,
  [ChainId.POLIS]: DONA_POLIS,
  [ChainId.POLIS_TESTNET]: DONA_POLIS_TESTNET,
  [ChainId.SHIBACHAIN]: DONA_SHIBACHAIN,
  [ChainId.SMART_BCH]: DONA_SMART_BCH,
  [ChainId.SMART_BCH_TESTNET]: DONA_SMART_BCH_TESTNET,
  [ChainId.SONGBIRD_CANARY]: DONA_SONGBIRD_CANARY,
  [ChainId.THAICHAIN]: DONA_THAICHAIN,
  [ChainId.UBIQ]: DONA_UBIQ,
  [ChainId.UBIQ_TESTNET]: DONA_UBIQ_TESTNET,
  [ChainId.VECHAIN]: DONA_VECHAIN,
  [ChainId.VECHAIN_TESTNET]: DONA_VECHAIN_TESTNET,
  [ChainId.XINFIN]: DONA_XINFIN,
  [ChainId.XINFIN_APOTHEM]: DONA_XINFIN_APOTHEM,
  [ChainId.SCROLL]: DONA_SCROLL,
  [ChainId.SCROLL_SEPOLIA]: DONA_SCROLL_SEPOLIA,
  [ChainId.XRPL_DEVNET]: DONA_XRPL_DEVNET,
  [ChainId.ZETACHAIN]: DONA_ZETACHAIN,
  [ChainId.ZETACHAIN_ATHENS]: DONA_ZETACHAIN_ATHENS,
  [ChainId.ZYX]: DONA_ZYX
};
var WBTC_ETH = new ERC20Token(
  ChainId.ETHEREUM,
  "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
  8,
  "WBTC",
  "Wrapped BTC"
);
var STABLE_COIN = {
  [ChainId.FIRECHAIN]: USDT[ChainId.FIRECHAIN],
  [ChainId.RINIA]: USDT[ChainId.RINIA],
  [ChainId.FIRECHAIN_ZKEVM]: USDT[ChainId.FIRECHAIN_ZKEVM],
  [ChainId.FIRECHAIN_ZKEVM_GHOSTRIDER]: USDT[ChainId.FIRECHAIN_ZKEVM_GHOSTRIDER],
  [ChainId.ETHEREUM]: USDT[ChainId.ETHEREUM],
  [ChainId.GOERLI]: USDC[ChainId.GOERLI],
  [ChainId.SEPOLIA]: USDT[ChainId.SEPOLIA],
  [ChainId.HOLESKY]: USDT[ChainId.HOLESKY],
  [ChainId.BSC]: USDT[ChainId.BSC],
  [ChainId.BSC_TESTNET]: BUSD[ChainId.BSC_TESTNET],
  [ChainId.POLYGON]: USDT[ChainId.POLYGON],
  [ChainId.POLYGON_AMOY]: USDT[ChainId.POLYGON_AMOY],
  [ChainId.POLYGON_ZKEVM]: USDT[ChainId.POLYGON_ZKEVM],
  [ChainId.POLYGON_ZKEVM_TESTNET]: USDT[ChainId.POLYGON_ZKEVM_TESTNET],
  [ChainId.CRO]: USDT[ChainId.CRO],
  [ChainId.CRO_TESTNET]: USDT[ChainId.CRO_TESTNET],
  [ChainId.AVALANCHE]: USDT[ChainId.AVALANCHE],
  [ChainId.AVALANCHE_FUJI]: USDT[ChainId.AVALANCHE_FUJI],
  [ChainId.FANTOM_OPERA]: USDT[ChainId.FANTOM_OPERA],
  [ChainId.FANTOM_TESTNET]: USDT[ChainId.FANTOM_TESTNET],
  [ChainId.CELO]: USDT[ChainId.CELO],
  [ChainId.CELO_ALFAJORES]: USDT[ChainId.CELO_ALFAJORES],
  [ChainId.OPTIMISM]: USDT[ChainId.OPTIMISM],
  [ChainId.OPTIMISM_GOERLI]: USDT[ChainId.OPTIMISM_GOERLI],
  [ChainId.SHIBARIUM]: USDT[ChainId.SHIBARIUM],
  [ChainId.SHIBARIUM_TESTNET]: USDT[ChainId.SHIBARIUM_TESTNET],
  [ChainId.PULSECHAIN]: USDT[ChainId.PULSECHAIN],
  [ChainId.PULSECHAIN_TESTNET]: USDT[ChainId.PULSECHAIN_TESTNET],
  [ChainId.XEN]: USDT[ChainId.XEN],
  [ChainId.XEN_DEVNET]: USDT[ChainId.XEN_DEVNET],
  [ChainId.HARMONY]: USDT[ChainId.HARMONY],
  [ChainId.HARMONY_TESTNET]: USDT[ChainId.HARMONY_TESTNET],
  [ChainId.COINEX]: USDT[ChainId.COINEX],
  [ChainId.COINEX_TESTNET]: USDT[ChainId.COINEX_TESTNET],
  [ChainId.DOGECHAIN]: USDT[ChainId.DOGECHAIN],
  [ChainId.DOGECHAIN_TESTNET]: USDT[ChainId.DOGECHAIN_TESTNET],
  [ChainId.ENGRAM_TESTNET]: USDT[ChainId.ENGRAM_TESTNET],
  [ChainId.ETHEREUM_CLASSIC]: USDT[ChainId.ETHEREUM_CLASSIC],
  [ChainId.ETHEREUM_CLASSIC_TESTNET]: USDT[ChainId.ETHEREUM_CLASSIC_TESTNET],
  [ChainId.FUSION]: USDT[ChainId.FUSION],
  [ChainId.FUSION_TESTNET]: USDT[ChainId.FUSION_TESTNET],
  [ChainId.HECO]: USDT[ChainId.HECO],
  [ChainId.HECO_TESTNET]: USDT[ChainId.HECO_TESTNET],
  [ChainId.KCC]: USDT[ChainId.KCC],
  [ChainId.KCC_TESTNET]: USDT[ChainId.KCC_TESTNET],
  [ChainId.KLAYTN]: USDT[ChainId.KLAYTN],
  [ChainId.KLAYTN_BAOBAB]: USDT[ChainId.KLAYTN_BAOBAB],
  [ChainId.OKXCHAIN]: USDT[ChainId.OKXCHAIN],
  [ChainId.OKXCHAIN_TESTNET]: USDT[ChainId.OKXCHAIN_TESTNET],
  [ChainId.THETHA]: USDT[ChainId.THETHA],
  [ChainId.THETHA_TESTNET]: USDT[ChainId.THETHA_TESTNET],
  [ChainId.ULTRON]: USDT[ChainId.ULTRON],
  [ChainId.ULTRON_TESTNET]: USDT[ChainId.ULTRON_TESTNET],
  [ChainId.MOONBEAM]: USDT[ChainId.MOONBEAM],
  [ChainId.MOONRIVER]: USDT[ChainId.MOONRIVER],
  [ChainId.MOONBASE_ALPHA]: USDT[ChainId.MOONBASE_ALPHA],
  [ChainId.AURORA]: USDT[ChainId.AURORA],
  [ChainId.AURORA_TESTNET]: USDT[ChainId.AURORA_TESTNET],
  [ChainId.BOBA]: USDT[ChainId.BOBA],
  [ChainId.BOBA_GOERLI]: USDT[ChainId.BOBA_GOERLI],
  [ChainId.GNOSIS]: USDT[ChainId.GNOSIS],
  [ChainId.GNOSIS_CHIADO]: USDT[ChainId.GNOSIS_CHIADO],
  [ChainId.METIS]: USDT[ChainId.METIS],
  [ChainId.METIS_GOERLI]: USDT[ChainId.METIS_GOERLI],
  [ChainId.TELOS]: USDT[ChainId.TELOS],
  [ChainId.TELOS_TESTNET]: USDT[ChainId.TELOS_TESTNET],
  [ChainId.SYSCOIN]: USDT[ChainId.SYSCOIN],
  [ChainId.SYSCOIN_TANENBAUM]: USDT[ChainId.SYSCOIN_TANENBAUM],
  [ChainId.IOTEX]: USDT[ChainId.IOTEX],
  [ChainId.IOTEX_TESTNET]: USDT[ChainId.IOTEX_TESTNET],
  [ChainId.SHIDEN]: USDT[ChainId.SHIDEN],
  [ChainId.ASTAR]: USDT[ChainId.ASTAR],
  [ChainId.SHIBUNYA]: USDT[ChainId.SHIBUNYA],
  [ChainId.FUSE]: USDT[ChainId.FUSE],
  [ChainId.FUSE_SPARKNET]: USDT[ChainId.FUSE_SPARKNET],
  [ChainId.VELAS]: USDT[ChainId.VELAS],
  [ChainId.VELAS_TESTNET]: USDT[ChainId.VELAS_TESTNET],
  [ChainId.REI]: USDT[ChainId.REI],
  [ChainId.REI_TESTNET]: USDT[ChainId.REI_TESTNET],
  [ChainId.KEKCHAIN]: USDT[ChainId.KEKCHAIN],
  [ChainId.KEKCHAIN_TESTNET]: USDT[ChainId.KEKCHAIN_TESTNET],
  [ChainId.TOMOCHAIN]: USDT[ChainId.TOMOCHAIN],
  [ChainId.TOMOCHAIN_TESTNET]: USDT[ChainId.TOMOCHAIN_TESTNET],
  [ChainId.THUNDERCORE]: USDT[ChainId.THUNDERCORE],
  [ChainId.THUNDERCORE_TESTNET]: USDT[ChainId.THUNDERCORE_TESTNET],
  [ChainId.WANCHAIN]: USDT[ChainId.WANCHAIN],
  [ChainId.WANCHAIN_TESTNET]: USDT[ChainId.WANCHAIN_TESTNET],
  [ChainId.RSK]: USDT[ChainId.RSK],
  [ChainId.RSK_TESTNET]: USDT[ChainId.RSK_TESTNET],
  [ChainId.ELASTOS]: USDT[ChainId.ELASTOS],
  [ChainId.ELASTOS_TESTNET]: USDT[ChainId.ELASTOS_TESTNET],
  [ChainId.CONFLUX]: USDT[ChainId.CONFLUX],
  [ChainId.CONFLUX_TESTNET]: USDT[ChainId.CONFLUX_TESTNET],
  [ChainId.BRISECHAIN]: USDT[ChainId.BRISECHAIN],
  [ChainId.BRISECHAIN_TESTNET]: USDT[ChainId.BRISECHAIN_TESTNET],
  [ChainId.MUUCHAIN]: USDT[ChainId.MUUCHAIN],
  [ChainId.MUUCHAIN_TESTNET]: USDT[ChainId.MUUCHAIN_TESTNET],
  [ChainId.CANTO]: USDT[ChainId.CANTO],
  [ChainId.CANTO_TESTNET]: USDT[ChainId.CANTO_TESTNET],
  [ChainId.OASIS_EMERALD]: USDT[ChainId.OASIS_EMERALD],
  [ChainId.OASIS_TESTNET]: USDT[ChainId.OASIS_TESTNET],
  [ChainId.VISION]: USDT[ChainId.VISION],
  [ChainId.VISION_TESTNET]: USDT[ChainId.VISION_TESTNET],
  [ChainId.STEP]: USDT[ChainId.STEP],
  [ChainId.STEP_TESTNET]: USDT[ChainId.STEP_TESTNET],
  [ChainId.METER]: USDT[ChainId.METER],
  [ChainId.METER_TESTNET]: USDT[ChainId.METER_TESTNET],
  [ChainId.GODWOKEN]: USDT[ChainId.GODWOKEN],
  [ChainId.GODWOKEN_TESTNET]: USDT[ChainId.GODWOKEN_TESTNET],
  [ChainId.CALLISTO]: USDT[ChainId.CALLISTO],
  [ChainId.CALLISTO_TESTNET]: USDT[ChainId.CALLISTO_TESTNET],
  [ChainId.EVMOS]: USDT[ChainId.EVMOS],
  [ChainId.EVMOS_TESTNET]: USDT[ChainId.EVMOS_TESTNET],
  [ChainId.ENERGY_WEB_CHAIN]: USDT[ChainId.ENERGY_WEB_CHAIN],
  [ChainId.ENERGY_VOLTA]: USDT[ChainId.ENERGY_VOLTA],
  [ChainId.BASE]: USDT[ChainId.BASE],
  [ChainId.BASE_GOERLI]: USDT[ChainId.BASE_GOERLI],
  [ChainId.KAVA]: USDT[ChainId.KAVA],
  [ChainId.KAVA_TESTNET]: USDT[ChainId.KAVA_TESTNET],
  [ChainId.CLOVER]: USDT[ChainId.CLOVER],
  [ChainId.CLOVER_TESTNET]: USDT[ChainId.CLOVER_TESTNET],
  [ChainId.DEFICHAIN]: USDT[ChainId.DEFICHAIN],
  [ChainId.DEFICHAIN_TESTNET]: USDT[ChainId.DEFICHAIN_TESTNET],
  [ChainId.BRONOS]: USDT[ChainId.BRONOS],
  [ChainId.BRONOS_TESTNET]: USDT[ChainId.BRONOS_TESTNET],
  [ChainId.FILECOIN]: USDT[ChainId.FILECOIN],
  [ChainId.FILECOIN_CALIBRATION]: USDT[ChainId.FILECOIN_CALIBRATION],
  [ChainId.FLARE]: USDT[ChainId.FLARE],
  [ChainId.FLARE_TESTNET]: USDT[ChainId.FLARE_TESTNET],
  [ChainId.TARAXA]: USDT[ChainId.TARAXA],
  [ChainId.TARAXA_TESTNET]: USDT[ChainId.TARAXA_TESTNET],
  [ChainId.ARBITRUM_ONE]: USDT[ChainId.ARBITRUM_ONE],
  [ChainId.ARBITRUM_GOERLI]: USDC[ChainId.ARBITRUM_GOERLI],
  [ChainId.ZKSYNC]: USDC[ChainId.ZKSYNC],
  [ChainId.ZKSYNC_TESTNET]: USDC[ChainId.ZKSYNC_TESTNET],
  [ChainId.LINEA]: USDC[ChainId.LINEA],
  [ChainId.LINEA_TESTNET]: USDC[ChainId.LINEA_TESTNET],
  [ChainId.BTTCHAIN]: USDT[ChainId.BTTCHAIN],
  [ChainId.BTTCHAIN_TESTNET]: USDT[ChainId.BTTCHAIN_TESTNET],
  [ChainId.BOBA_AVAX]: USDT[ChainId.BOBA_AVAX],
  [ChainId.BOBA_BNB]: USDT[ChainId.BOBA_BNB],
  [ChainId.CMP]: USDT[ChainId.CMP],
  [ChainId.CMP_TESTNET]: USDT[ChainId.CMP_TESTNET],
  [ChainId.CORE]: USDT[ChainId.CORE],
  [ChainId.CORE_TESTNET]: USDT[ChainId.CORE_TESTNET],
  [ChainId.CUBECHAIN]: USDT[ChainId.CUBECHAIN],
  [ChainId.CUBECHAIN_TESTNET]: USDT[ChainId.CUBECHAIN_TESTNET],
  [ChainId.DARWINIA_CRAB]: USDT[ChainId.DARWINIA_CRAB],
  [ChainId.DARWINIA_PANGOLIN]: USDT[ChainId.DARWINIA_PANGOLIN],
  [ChainId.DIODE_PRETNET]: USDT[ChainId.DIODE_PRETNET],
  [ChainId.DIODE_TESTNET]: USDT[ChainId.DIODE_TESTNET],
  [ChainId.GOCHAIN]: USDT[ChainId.GOCHAIN],
  [ChainId.GOCHAIN_TESTNET]: USDT[ChainId.GOCHAIN_TESTNET],
  [ChainId.HAQQ]: USDT[ChainId.HAQQ],
  [ChainId.HAQQ_TESTEDGE2]: USDT[ChainId.HAQQ_TESTEDGE2],
  [ChainId.KARDIACHAIN]: USDT[ChainId.KARDIACHAIN],
  [ChainId.KARDIACHAIN_TESTNET]: USDT[ChainId.KARDIACHAIN_TESTNET],
  [ChainId.METADIUM]: USDT[ChainId.METADIUM],
  [ChainId.METADIUM_TESTNET]: USDT[ChainId.METADIUM],
  [ChainId.OP_BNB]: USDT[ChainId.OP_BNB],
  [ChainId.OP_BNB_TESTNET]: USDT[ChainId.OP_BNB_TESTNET],
  [ChainId.PALM]: USDT[ChainId.PALM],
  [ChainId.PALM_TESTNET]: USDT[ChainId.PALM_TESTNET],
  [ChainId.POLIS]: USDT[ChainId.POLIS],
  [ChainId.POLIS_TESTNET]: USDT[ChainId.POLIS_TESTNET],
  [ChainId.SHIBACHAIN]: USDT[ChainId.SHIBACHAIN],
  [ChainId.SMART_BCH]: USDT[ChainId.SMART_BCH],
  [ChainId.SMART_BCH_TESTNET]: USDT[ChainId.SMART_BCH_TESTNET],
  [ChainId.SONGBIRD_CANARY]: USDT[ChainId.SONGBIRD_CANARY],
  [ChainId.THAICHAIN]: USDT[ChainId.THAICHAIN],
  [ChainId.UBIQ]: USDT[ChainId.UBIQ],
  [ChainId.UBIQ_TESTNET]: USDT[ChainId.UBIQ_TESTNET],
  [ChainId.VECHAIN]: USDT[ChainId.VECHAIN],
  [ChainId.VECHAIN_TESTNET]: USDT[ChainId.VECHAIN_TESTNET],
  [ChainId.XINFIN]: USDT[ChainId.XINFIN],
  [ChainId.XINFIN_APOTHEM]: USDT[ChainId.XINFIN_APOTHEM],
  [ChainId.SCROLL]: USDT_SCROLL,
  [ChainId.SCROLL_SEPOLIA]: USDT_SCROLL_SEPOLIA,
  [ChainId.XRPL_DEVNET]: USDT_XRPL_DEVNET,
  [ChainId.ZETACHAIN]: USDT_ZETACHAIN,
  [ChainId.ZETACHAIN_ATHENS]: USDT_ZETACHAIN_ATHENS,
  [ChainId.ZYX]: USDT[ChainId.ZYX]
};
var EMPTY_LIST = {
  [ChainId.FIRECHAIN]: {},
  [ChainId.RINIA]: {},
  [ChainId.FIRECHAIN_ZKEVM]: {},
  [ChainId.FIRECHAIN_ZKEVM_GHOSTRIDER]: {},
  [ChainId.ETHEREUM]: {},
  [ChainId.GOERLI]: {},
  [ChainId.SEPOLIA]: {},
  [ChainId.HOLESKY]: {},
  [ChainId.BSC]: {},
  [ChainId.BSC_TESTNET]: {},
  [ChainId.POLYGON]: {},
  [ChainId.POLYGON_AMOY]: {},
  [ChainId.POLYGON_ZKEVM]: {},
  [ChainId.POLYGON_ZKEVM_TESTNET]: {},
  [ChainId.CRO]: {},
  [ChainId.CRO_TESTNET]: {},
  [ChainId.AVALANCHE]: {},
  [ChainId.AVALANCHE_FUJI]: {},
  [ChainId.FANTOM_OPERA]: {},
  [ChainId.FANTOM_TESTNET]: {},
  [ChainId.CELO]: {},
  [ChainId.CELO_ALFAJORES]: {},
  [ChainId.OPTIMISM]: {},
  [ChainId.OPTIMISM_GOERLI]: {},
  [ChainId.SHIBARIUM]: {},
  [ChainId.SHIBARIUM_TESTNET]: {},
  [ChainId.PULSECHAIN]: {},
  [ChainId.PULSECHAIN_TESTNET]: {},
  [ChainId.XEN]: {},
  [ChainId.XEN_DEVNET]: {},
  [ChainId.HARMONY]: {},
  [ChainId.HARMONY_TESTNET]: {},
  [ChainId.COINEX_TESTNET]: {},
  [ChainId.COINEX]: {},
  [ChainId.DOGECHAIN]: {},
  [ChainId.DOGECHAIN_TESTNET]: {},
  [ChainId.ENGRAM_TESTNET]: {},
  [ChainId.ETHEREUM_CLASSIC]: {},
  [ChainId.ETHEREUM_CLASSIC_TESTNET]: {},
  [ChainId.FUSION]: {},
  [ChainId.FUSION_TESTNET]: {},
  [ChainId.HECO]: {},
  [ChainId.HECO_TESTNET]: {},
  [ChainId.KCC]: {},
  [ChainId.KCC_TESTNET]: {},
  [ChainId.KLAYTN]: {},
  [ChainId.KLAYTN_BAOBAB]: {},
  [ChainId.OKXCHAIN]: {},
  [ChainId.OKXCHAIN_TESTNET]: {},
  [ChainId.THETHA]: {},
  [ChainId.THETHA_TESTNET]: {},
  [ChainId.ULTRON]: {},
  [ChainId.ULTRON_TESTNET]: {},
  [ChainId.MOONBEAM]: {},
  [ChainId.MOONRIVER]: {},
  [ChainId.MOONBASE_ALPHA]: {},
  [ChainId.AURORA]: {},
  [ChainId.AURORA_TESTNET]: {},
  [ChainId.BOBA]: {},
  [ChainId.BOBA_GOERLI]: {},
  [ChainId.GNOSIS]: {},
  [ChainId.GNOSIS_CHIADO]: {},
  [ChainId.METIS]: {},
  [ChainId.METIS_GOERLI]: {},
  [ChainId.TELOS]: {},
  [ChainId.TELOS_TESTNET]: {},
  [ChainId.SYSCOIN]: {},
  [ChainId.SYSCOIN_TANENBAUM]: {},
  [ChainId.IOTEX]: {},
  [ChainId.IOTEX_TESTNET]: {},
  [ChainId.SHIDEN]: {},
  [ChainId.ASTAR]: {},
  [ChainId.SHIBUNYA]: {},
  [ChainId.FUSE]: {},
  [ChainId.FUSE_SPARKNET]: {},
  [ChainId.VELAS]: {},
  [ChainId.VELAS_TESTNET]: {},
  [ChainId.REI]: {},
  [ChainId.REI_TESTNET]: {},
  [ChainId.KEKCHAIN]: {},
  [ChainId.KEKCHAIN_TESTNET]: {},
  [ChainId.TOMOCHAIN]: {},
  [ChainId.TOMOCHAIN_TESTNET]: {},
  [ChainId.THUNDERCORE]: {},
  [ChainId.THUNDERCORE_TESTNET]: {},
  [ChainId.WANCHAIN]: {},
  [ChainId.WANCHAIN_TESTNET]: {},
  [ChainId.RSK]: {},
  [ChainId.RSK_TESTNET]: {},
  [ChainId.ELASTOS]: {},
  [ChainId.ELASTOS_TESTNET]: {},
  [ChainId.CONFLUX]: {},
  [ChainId.CONFLUX_TESTNET]: {},
  [ChainId.BRISECHAIN]: {},
  [ChainId.BRISECHAIN_TESTNET]: {},
  [ChainId.MUUCHAIN]: {},
  [ChainId.MUUCHAIN_TESTNET]: {},
  [ChainId.CANTO]: {},
  [ChainId.CANTO_TESTNET]: {},
  [ChainId.OASIS_EMERALD]: {},
  [ChainId.OASIS_TESTNET]: {},
  [ChainId.VISION]: {},
  [ChainId.VISION_TESTNET]: {},
  [ChainId.STEP]: {},
  [ChainId.STEP_TESTNET]: {},
  [ChainId.METER]: {},
  [ChainId.METER_TESTNET]: {},
  [ChainId.GODWOKEN]: {},
  [ChainId.GODWOKEN_TESTNET]: {},
  [ChainId.CALLISTO]: {},
  [ChainId.CALLISTO_TESTNET]: {},
  [ChainId.EVMOS]: {},
  [ChainId.EVMOS_TESTNET]: {},
  [ChainId.ENERGY_WEB_CHAIN]: {},
  [ChainId.ENERGY_VOLTA]: {},
  [ChainId.BASE]: {},
  [ChainId.BASE_GOERLI]: {},
  [ChainId.KAVA]: {},
  [ChainId.KAVA_TESTNET]: {},
  [ChainId.CLOVER]: {},
  [ChainId.CLOVER_TESTNET]: {},
  [ChainId.DEFICHAIN]: {},
  [ChainId.DEFICHAIN_TESTNET]: {},
  [ChainId.BRONOS]: {},
  [ChainId.BRONOS_TESTNET]: {},
  [ChainId.FILECOIN]: {},
  [ChainId.FILECOIN_CALIBRATION]: {},
  [ChainId.FLARE]: {},
  [ChainId.FLARE_TESTNET]: {},
  [ChainId.TARAXA]: {},
  [ChainId.TARAXA_TESTNET]: {},
  [ChainId.ARBITRUM_ONE]: {},
  [ChainId.ARBITRUM_GOERLI]: {},
  [ChainId.ZKSYNC]: {},
  [ChainId.ZKSYNC_TESTNET]: {},
  [ChainId.LINEA]: {},
  [ChainId.LINEA_TESTNET]: {},
  [ChainId.BTTCHAIN]: {},
  [ChainId.BTTCHAIN_TESTNET]: {},
  [ChainId.BOBA_AVAX]: {},
  [ChainId.BOBA_BNB]: {},
  [ChainId.CMP]: {},
  [ChainId.CMP_TESTNET]: {},
  [ChainId.CORE]: {},
  [ChainId.CORE_TESTNET]: {},
  [ChainId.CUBECHAIN]: {},
  [ChainId.CUBECHAIN_TESTNET]: {},
  [ChainId.DARWINIA_CRAB]: {},
  [ChainId.DARWINIA_PANGOLIN]: {},
  [ChainId.DIODE_PRETNET]: {},
  [ChainId.DIODE_TESTNET]: {},
  [ChainId.GOCHAIN]: {},
  [ChainId.GOCHAIN_TESTNET]: {},
  [ChainId.HAQQ]: {},
  [ChainId.HAQQ_TESTEDGE2]: {},
  [ChainId.KARDIACHAIN]: {},
  [ChainId.KARDIACHAIN_TESTNET]: {},
  [ChainId.METADIUM]: {},
  [ChainId.METADIUM_TESTNET]: {},
  [ChainId.OP_BNB]: {},
  [ChainId.OP_BNB_TESTNET]: {},
  [ChainId.PALM]: {},
  [ChainId.PALM_TESTNET]: {},
  [ChainId.POLIS]: {},
  [ChainId.POLIS_TESTNET]: {},
  [ChainId.SHIBACHAIN]: {},
  [ChainId.SMART_BCH]: {},
  [ChainId.SMART_BCH_TESTNET]: {},
  [ChainId.SONGBIRD_CANARY]: {},
  [ChainId.THAICHAIN]: {},
  [ChainId.UBIQ]: {},
  [ChainId.UBIQ_TESTNET]: {},
  [ChainId.VECHAIN]: {},
  [ChainId.VECHAIN_TESTNET]: {},
  [ChainId.XINFIN]: {},
  [ChainId.XINFIN_APOTHEM]: {},
  [ChainId.SCROLL]: {},
  [ChainId.SCROLL_SEPOLIA]: {},
  [ChainId.XRPL_DEVNET]: {},
  [ChainId.ZETACHAIN]: {},
  [ChainId.ZETACHAIN_ATHENS]: {},
  [ChainId.ZYX]: {}
};
function serializeTokens(unserializedTokens) {
  const serializedTokens = Object.keys(unserializedTokens).reduce((accum, key) => {
    return { ...accum, [key]: unserializedTokens[key].serialize };
  }, {});
  return serializedTokens;
}
var firechainTokens = {
  wfire: WFIRE[ChainId.FIRECHAIN],
  usdt: USDT_FIRECHAIN,
  dona: DONA_FIRECHAIN,
  mockB: new ERC20Token(ChainId.FIRECHAIN, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.FIRECHAIN, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var riniaTokens = {
  wfire: WFIRE[ChainId.RINIA],
  usdt: USDT_RINIA,
  dona: DONA_RINIA,
  mockB: new ERC20Token(ChainId.RINIA, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.RINIA, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var firechainZkevmTokens = {
  weth: WETH9[ChainId.FIRECHAIN_ZKEVM],
  usdt: USDT_FIRECHAIN_ZKEVM,
  dona: DONA_FIRECHAIN_ZKEVM,
  mockB: new ERC20Token(ChainId.FIRECHAIN_ZKEVM, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.FIRECHAIN_ZKEVM, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var firechainZkevmGhostriderTokens = {
  weth: WETH9[ChainId.FIRECHAIN_ZKEVM_GHOSTRIDER],
  usdt: USDT_FIRECHAIN_ZKEVM_GHOSTRIDER,
  dona: DONA_FIRECHAIN_ZKEVM_GHOSTRIDER,
  mockB: new ERC20Token(ChainId.FIRECHAIN_ZKEVM_GHOSTRIDER, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.FIRECHAIN_ZKEVM_GHOSTRIDER, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var ethereumTokens = {
  dona: DONA[ChainId.ETHEREUM],
  weth: WETH9[ChainId.ETHEREUM],
  usdt: USDT[ChainId.ETHEREUM],
  usdc: USDC[ChainId.ETHEREUM],
  // flame: FLAME[ChainId.ETHEREUM],
  wbtc: WBTC_ETH,
  viz: new ERC20Token(ChainId.ETHEREUM, "0x777E2ae845272a2F540ebf6a3D03734A5a8f618e", 18, "VIZ", "Vision City", "https://www.ryoshisverse.io"),
  shib: new ERC20Token(ChainId.ETHEREUM, "0x95aD61b0a150d79219dCF64E1E6Cc01f0B64C4cE", 18, "SHIB", "Shiba Inu", "https://shibatoken.com/"),
  leash: new ERC20Token(ChainId.ETHEREUM, "0x27C70Cd1946795B66be9d954418546998b546634", 18, "LEASH", "Doge Killer", "https://shibatoken.com/"),
  bone: new ERC20Token(ChainId.ETHEREUM, "0x9813037ee2218799597d83D4a5B6F3b6778218d9", 18, "BONE", "Bone Token", "https://shibatoken.com/"),
  sdao: new ERC20Token(
    ChainId.ETHEREUM,
    "0x993864E43Caa7F7F12953AD6fEb1d1Ca635B875F",
    18,
    "SDAO",
    "Singularity Dao",
    "https://www.singularitydao.ai/"
  ),
  stg: new ERC20Token(
    ChainId.ETHEREUM,
    "0xAf5191B0De278C7286d6C7CC6ab6BB8A73bA2Cd6",
    18,
    "STG",
    "StargateToken",
    "https://stargate.finance/"
  ),
  fuse: new ERC20Token(
    ChainId.ETHEREUM,
    "0x970B9bB2C0444F5E81e9d0eFb84C8ccdcdcAf84d",
    18,
    "FUSE",
    "Fuse Token",
    "https://fuse.io/"
  ),
  caps: new ERC20Token(
    ChainId.ETHEREUM,
    "0x03Be5C903c727Ee2C8C4e9bc0AcC860Cca4715e2",
    18,
    "CAPS",
    "Capsule Coin",
    "https://www.ternoa.network/en"
  ),
  dai: new ERC20Token(
    ChainId.ETHEREUM,
    "0x6B175474E89094C44Da98b954EedeAC495271d0F",
    18,
    "DAI",
    "Dai Stablecoin",
    "https://www.makerdao.com/"
  ),
  ldo: new ERC20Token(
    ChainId.ETHEREUM,
    "0x5A98FcBEA516Cf06857215779Fd812CA3beF1B32",
    18,
    "LDO",
    "Lido DAO Token",
    "https://lido.fi/"
  ),
  wstETH: new ERC20Token(
    ChainId.ETHEREUM,
    "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
    18,
    "wstETH",
    "Wrapped liquid staked Ether 2.0",
    "https://lido.fi/"
  ),
  link: new ERC20Token(
    ChainId.ETHEREUM,
    "0x514910771AF9Ca656af840dff83E8264EcF986CA",
    18,
    "LINK",
    "ChainLink Token",
    "https://chain.link/"
  ),
  matic: new ERC20Token(
    ChainId.ETHEREUM,
    "0x7D1AfA7B718fb893dB30A3aBc0Cfc608AaCfeBB0",
    18,
    "MATIC",
    "Matic Token",
    "https://polygon.technology/"
  ),
  cbEth: new ERC20Token(
    ChainId.ETHEREUM,
    "0xBe9895146f7AF43049ca1c1AE358B0541Ea49704",
    18,
    "cbETH",
    "Coinbase Wrapped Staked ETH",
    "https://www.coinbase.com/cbeth"
  ),
  ape: new ERC20Token(
    ChainId.ETHEREUM,
    "0x4d224452801ACEd8B2F0aebE155379bb5D594381",
    18,
    "APE",
    "ApeCoin",
    "https://apecoin.com/"
  ),
  alcx: new ERC20Token(
    ChainId.ETHEREUM,
    "0xdBdb4d16EdA451D0503b854CF79D55697F90c8DF",
    18,
    "ALCX",
    "Alchemix",
    "https://alchemix.fi/"
  ),
  alETH: new ERC20Token(
    ChainId.ETHEREUM,
    "0x0100546F2cD4C9D97f798fFC9755E47865FF7Ee6",
    18,
    "alETH",
    "Alchemix ETH",
    "https://alchemix.fi/"
  ),
  fxs: new ERC20Token(
    ChainId.ETHEREUM,
    "0x3432B6A60D23Ca0dFCa7761B7ab56459D9C964D0",
    18,
    "FXS",
    "Frax Share",
    "https://frax.finance/"
  ),
  frxETH: new ERC20Token(
    ChainId.ETHEREUM,
    "0x5E8422345238F34275888049021821E8E08CAa1f",
    18,
    "frxETH",
    "Frax Ether",
    "https://frax.finance/"
  ),
  rpl: new ERC20Token(
    ChainId.ETHEREUM,
    "0xD33526068D116cE69F19A9ee46F0bd304F21A51f",
    18,
    "RPL",
    "Rocket Pool",
    "https://rocketpool.net/"
  ),
  rETH: new ERC20Token(
    ChainId.ETHEREUM,
    "0xae78736Cd615f374D3085123A210448E74Fc6393",
    18,
    "rETH",
    "Rocket Pool ETH",
    "https://rocketpool.net/"
  ),
  ankrETH: new ERC20Token(
    ChainId.ETHEREUM,
    "0xE95A203B1a91a908F9B9CE46459d101078c2c3cb",
    18,
    "ankrETH",
    "Ankr Staked ETH",
    "https://www.ankr.com/"
  ),
  axl: new ERC20Token(
    ChainId.ETHEREUM,
    "0x467719aD09025FcC6cF6F8311755809d45a5E5f3",
    6,
    "AXL",
    "Axelar",
    "https://axelar.network/"
  ),
  mask: new ERC20Token(
    ChainId.ETHEREUM,
    "0x69af81e73A73B40adF4f3d4223Cd9b1ECE623074",
    18,
    "MASK",
    "Mask Network",
    "https://mask.io/"
  ),
  wncg: new ERC20Token(
    ChainId.ETHEREUM,
    "0xf203Ca1769ca8e9e8FE1DA9D147DB68B6c919817",
    18,
    "WNCG",
    "Wrapped NCG",
    "https://nine-chronicles.com/"
  ),
  ush: new ERC20Token(
    ChainId.ETHEREUM,
    "0xE60779CC1b2c1d0580611c526a8DF0E3f870EC48",
    18,
    "USH",
    "unshETHing_Token",
    "https://unsheth.xyz/"
  ),
  unshETH: new ERC20Token(
    ChainId.ETHEREUM,
    "0x0Ae38f7E10A43B5b2fB064B42a2f4514cbA909ef",
    18,
    "unshETH",
    "unshETH Ether",
    "https://unsheth.xyz/"
  ),
  wbeth: new ERC20Token(
    ChainId.ETHEREUM,
    "0xa2E3356610840701BDf5611a53974510Ae27E2e1",
    18,
    "wBETH",
    "Wrapped Binance Beacon ETH",
    "https://ethereum.org/en/roadmap/beacon-chain/"
  ),
  pepe: new ERC20Token(
    ChainId.ETHEREUM,
    "0x6982508145454Ce325dDbE47a25d4ec3d2311933",
    18,
    "PEPE",
    "Pepe",
    "https://www.pepe.vip/"
  ),
  blur: new ERC20Token(
    ChainId.ETHEREUM,
    "0x5283D291DBCF85356A21bA090E6db59121208b44",
    18,
    "BLUR",
    "Blur",
    "https://blur.io/"
  ),
  ens: new ERC20Token(
    ChainId.ETHEREUM,
    "0xC18360217D8F7Ab5e7c516566761Ea12Ce7F9D72",
    18,
    "ENS",
    "Ethereum Name Service",
    "https://ens.domains/"
  ),
  tusd: new ERC20Token(
    ChainId.ETHEREUM,
    "0x0000000000085d4780B73119b644AE5ecd22b376",
    18,
    "TUSD",
    "TrueUSD",
    "https://tusd.io/"
  )
};
var goerliTestnetTokens = {
  weth: WETH9[ChainId.GOERLI],
  usdc: USDC_GOERLI,
  celr: new ERC20Token(ChainId.GOERLI, "0x5D3c0F4cA5EE99f8E8F59Ff9A5fAb04F6a7e007f", 18, "CELR", "CelerToken", ""),
  leet: new ERC20Token(ChainId.GOERLI, "0xBd509651E6374c327d24b9d7E3Ea46704f6F31E8", 18, "LEET", "Leet Token", ""),
  mockB: new ERC20Token(ChainId.GOERLI, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.GOERLI, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var sepoliaTokens = {
  weth: WETH9[ChainId.SEPOLIA],
  usdt: USDT[ChainId.SEPOLIA],
  dona: DONA[ChainId.SEPOLIA],
  mockB: new ERC20Token(ChainId.SEPOLIA, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.SEPOLIA, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var holeskyTokens = {
  weth: WETH9[ChainId.HOLESKY],
  usdt: USDT[ChainId.HOLESKY],
  dona: DONA[ChainId.HOLESKY],
  mockB: new ERC20Token(ChainId.HOLESKY, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.HOLESKY, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var bscTokens = {
  dona: DONA[ChainId.BSC],
  flame: FLAME_MAINNET,
  wbnb: WBNB[ChainId.BSC],
  // bnb here points to the wbnb contract. Wherever the currency BNB is required, conditional checks for the symbol 'BNB' can be used
  bnb: new ERC20Token(
    ChainId.BSC,
    "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
    18,
    "BNB",
    "BNB",
    "https://www.binance.com/"
  ),
  // flame: FLAME_BSC,
  gmi: new ERC20Token(
    ChainId.BSC,
    "0x93D8d25E3C9A847a5Da79F79ecaC89461FEcA846",
    18,
    "GMI",
    "Gamifi",
    "https://gamifi.gg/"
  ),
  tlos: new ERC20Token(
    ChainId.BSC,
    "0xb6C53431608E626AC81a9776ac3e999c5556717c",
    18,
    "TLOS",
    "Telos",
    "https://www.telos.net/"
  ),
  beta: new ERC20Token(
    ChainId.BSC,
    "0xBe1a001FE942f96Eea22bA08783140B9Dcc09D28",
    18,
    "BETA",
    "Beta Finance",
    "https://betafinance.org"
  ),
  nft: new ERC20Token(
    ChainId.BSC,
    "0x1fC9004eC7E5722891f5f38baE7678efCB11d34D",
    6,
    "NFT",
    "APENFT",
    "https://apenft.org"
  ),
  stephero: new ERC20Token(
    ChainId.BSC,
    "0xE8176d414560cFE1Bf82Fd73B986823B89E4F545",
    18,
    "HERO",
    "StepHero",
    "https://stephero.io/"
  ),
  pros: new ERC20Token(
    ChainId.BSC,
    "0xEd8c8Aa8299C10f067496BB66f8cC7Fb338A3405",
    18,
    "PROS",
    "Prosper",
    "https://prosper.so/"
  ),
  qbt: new ERC20Token(
    ChainId.BSC,
    "0x17B7163cf1Dbd286E262ddc68b553D899B93f526",
    18,
    "QBT",
    "Qubit Token",
    "https://qbt.fi/"
  ),
  cvp: new ERC20Token(
    ChainId.BSC,
    "0x5Ec3AdBDae549Dce842e24480Eb2434769e22B2E",
    18,
    "CVP",
    "Concentrated Voting Power Token",
    "https://powerpool.finance/"
  ),
  bscdefi: new ERC20Token(
    ChainId.BSC,
    "0x40E46dE174dfB776BB89E04dF1C47d8a66855EB3",
    18,
    "BSCDEFI",
    "ChainId.BSC Defi blue chips token",
    "https://powerpool.finance/"
  ),
  busd: BUSD_BSC,
  dai: new ERC20Token(
    ChainId.BSC,
    "0x1AF3F329e8BE154074D8769D1FFa4eE058B1DBc3",
    18,
    "DAI",
    "Dai Stablecoin",
    "https://www.makerdao.com/"
  ),
  usdt: USDT_BSC,
  btcb: new ERC20Token(
    ChainId.BSC,
    "0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c",
    18,
    "BTCB",
    "Binance BTC",
    "https://bitcoin.org/"
  ),
  ust: new ERC20Token(
    ChainId.BSC,
    "0x23396cF899Ca06c4472205fC903bDB4de249D6fC",
    18,
    "UST",
    "Wrapped UST Token",
    "https://mirror.finance/"
  ),
  eth: new ERC20Token(
    ChainId.BSC,
    "0x2170Ed0880ac9A755fd29B2688956BD959F933F8",
    18,
    "ETH",
    "Binance-Peg Ethereum Token",
    "https://ethereum.org/en/"
  ),
  usdc: new ERC20Token(
    ChainId.BSC,
    "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d",
    18,
    "USDC",
    "Binance-Peg USD Coin",
    "https://www.centre.io/usdc"
  ),
  kalm: new ERC20Token(
    ChainId.BSC,
    "0x4BA0057f784858a48fe351445C672FF2a3d43515",
    18,
    "KALM",
    "Kalmar Token",
    "https://kalmar.io/"
  ),
  dkt: new ERC20Token(
    ChainId.BSC,
    "0x7Ceb519718A80Dd78a8545AD8e7f401dE4f2faA7",
    18,
    "DKT",
    "Duelist King",
    "https://duelistking.com/"
  ),
  hotcross: new ERC20Token(
    ChainId.BSC,
    "0x4FA7163E153419E0E1064e418dd7A99314Ed27b6",
    18,
    "HOTCROSS",
    "Hotcross Token",
    "https://www.hotcross.com/"
  ),
  belt: new ERC20Token(
    ChainId.BSC,
    "0xE0e514c71282b6f4e823703a39374Cf58dc3eA4f",
    18,
    "BELT",
    "Belt Token",
    "https://beta.belt.fi/"
  ),
  watch: new ERC20Token(
    ChainId.BSC,
    "0x7A9f28EB62C791422Aa23CeAE1dA9C847cBeC9b0",
    18,
    "WATCH",
    "Yieldwatch Token",
    "https://yieldwatch.net/"
  ),
  bry: new ERC20Token(
    ChainId.BSC,
    "0xf859Bf77cBe8699013d6Dbc7C2b926Aaf307F830",
    18,
    "BRY",
    "Berry Token",
    "https://berrydata.co/"
  ),
  wsote: new ERC20Token(
    ChainId.BSC,
    "0x541E619858737031A1244A5d0Cd47E5ef480342c",
    18,
    "wSOTE",
    "Soteria Token",
    "https://soteria.finance/"
  ),
  helmet: new ERC20Token(
    ChainId.BSC,
    "0x948d2a81086A075b3130BAc19e4c6DEe1D2E3fE8",
    18,
    "Helmet",
    "Helmet Token",
    "https://www.helmet.insure/"
  ),
  ten: new ERC20Token(
    ChainId.BSC,
    "0xdFF8cb622790b7F92686c722b02CaB55592f152C",
    18,
    "TEN",
    "Tenet Token",
    "https://www.tenet.farm/"
  ),
  ditto: new ERC20Token(
    ChainId.BSC,
    "0x233d91A0713155003fc4DcE0AFa871b508B3B715",
    9,
    "DITTO",
    "Ditto Token",
    "https://ditto.money/"
  ),
  blink: new ERC20Token(
    ChainId.BSC,
    "0x63870A18B6e42b01Ef1Ad8A2302ef50B7132054F",
    6,
    "BLINK",
    "Blink Token",
    "https://blink.wink.org"
  ),
  syrup: new ERC20Token(
    ChainId.BSC,
    "0x009cF7bC57584b7998236eff51b98A168DceA9B0",
    18,
    "SYRUP",
    "SyrupBar Token",
    "https://donaswap.io/"
  ),
  pha: new ERC20Token(
    ChainId.BSC,
    "0x0112e557d400474717056C4e6D40eDD846F38351",
    18,
    "PHA",
    "Phala Token",
    "https://phala.network"
  ),
  babycake: new ERC20Token(
    ChainId.BSC,
    "0xdB8D30b74bf098aF214e862C90E647bbB1fcC58c",
    18,
    "BABYCAKE",
    "Baby Cake Token",
    "https://babycake.app/"
  ),
  bmon: new ERC20Token(
    ChainId.BSC,
    "0x08ba0619b1e7A582E0BCe5BBE9843322C954C340",
    18,
    "BMON",
    "Binamon Token",
    "https://binamon.org/"
  ),
  hero: new ERC20Token(
    ChainId.BSC,
    "0xD40bEDb44C081D2935eebA6eF5a3c8A31A1bBE13",
    18,
    "HERO",
    "Metahero Token",
    "https://metahero.io/"
  ),
  wsg: new ERC20Token(
    ChainId.BSC,
    "0xA58950F05FeA2277d2608748412bf9F802eA4901",
    18,
    "WSG",
    "Wall Street Games Token",
    "https://wsg.gg/"
  ),
  mcrn: new ERC20Token(
    ChainId.BSC,
    "0xacb2d47827C9813AE26De80965845D80935afd0B",
    18,
    "MCRN",
    "Macaronswap Token",
    "https://www.macaronswap.finance/"
  ),
  revv: new ERC20Token(
    ChainId.BSC,
    "0x833F307aC507D47309fD8CDD1F835BeF8D702a93",
    18,
    "REVV",
    "REVV Token",
    "https://revvmotorsport.com/"
  ),
  skill: new ERC20Token(
    ChainId.BSC,
    "0x154A9F9cbd3449AD22FDaE23044319D6eF2a1Fab",
    18,
    "SKILL",
    "Cryptoblades Token",
    "https://www.cryptoblades.io/"
  ),
  if: new ERC20Token(
    ChainId.BSC,
    "0xB0e1fc65C1a741b4662B813eB787d369b8614Af1",
    18,
    "IF",
    "Impossible Finance Token",
    "https://impossible.finance/"
  ),
  sps: new ERC20Token(
    ChainId.BSC,
    "0x1633b7157e7638C4d6593436111Bf125Ee74703F",
    18,
    "SPS",
    "Splinterlands Token",
    "https://splinterlands.com"
  ),
  chess: new ERC20Token(
    ChainId.BSC,
    "0x20de22029ab63cf9A7Cf5fEB2b737Ca1eE4c82A6",
    18,
    "CHESS",
    "Chess Token",
    "https://tranchess.com/"
  ),
  titan: new ERC20Token(
    ChainId.BSC,
    "0xe898EDc43920F357A93083F1d4460437dE6dAeC2",
    18,
    "TITAN",
    "Titanswap Token",
    "https://titanswap.org"
  ),
  harmony: new ERC20Token(
    ChainId.BSC,
    "0x03fF0ff224f904be3118461335064bB48Df47938",
    18,
    "ONE",
    "Harmony ONE Token",
    "https://www.harmony.one/"
  ),
  mask: new ERC20Token(
    ChainId.BSC,
    "0x2eD9a5C8C13b93955103B9a7C167B67Ef4d568a3",
    18,
    "MASK",
    "Mask Token",
    "https://mask.io/"
  ),
  dvi: new ERC20Token(
    ChainId.BSC,
    "0x758FB037A375F17c7e195CC634D77dA4F554255B",
    18,
    "DVI",
    "Dvision Network Token",
    "https://dvision.network/"
  ),
  adx: new ERC20Token(
    ChainId.BSC,
    "0x6bfF4Fb161347ad7de4A625AE5aa3A1CA7077819",
    18,
    "ADX",
    "Adex Network Token",
    "https://www.adex.network"
  ),
  bscpad: new ERC20Token(
    ChainId.BSC,
    "0x5A3010d4d8D3B5fB49f8B6E57FB9E48063f16700",
    18,
    "BSCPAD",
    "Bscpad Token",
    "https://bscpad.com/"
  ),
  rabbit: new ERC20Token(
    ChainId.BSC,
    "0x95a1199EBA84ac5f19546519e287d43D2F0E1b41",
    18,
    "RABBIT",
    "Rabbit Finance Token",
    "https://rabbitfinance.io/earn"
  ),
  form: new ERC20Token(
    ChainId.BSC,
    "0x25A528af62e56512A19ce8c3cAB427807c28CC19",
    18,
    "FORM",
    "Formation Token",
    "https://formation.fi/"
  ),
  txl: new ERC20Token(
    ChainId.BSC,
    "0x1FFD0b47127fdd4097E54521C9E2c7f0D66AafC5",
    18,
    "TXL",
    "Tixl Token",
    "https://tixl.org/"
  ),
  orbs: new ERC20Token(
    ChainId.BSC,
    "0xeBd49b26169e1b52c04cFd19FCf289405dF55F80",
    18,
    "ORBS",
    "Orbs Token",
    "https://www.orbs.com/"
  ),
  cos: new ERC20Token(
    ChainId.BSC,
    "0x96Dd399F9c3AFda1F194182F71600F1B65946501",
    18,
    "COS",
    "Contentos Token",
    "https://www.contentos.io/"
  ),
  bunny: new ERC20Token(
    ChainId.BSC,
    "0xC9849E6fdB743d08fAeE3E34dd2D1bc69EA11a51",
    18,
    "BUNNY",
    "Pancakebunny Token",
    "https://pancakebunny.finance/"
  ),
  alice: new ERC20Token(
    ChainId.BSC,
    "0xAC51066d7bEC65Dc4589368da368b212745d63E8",
    6,
    "ALICE",
    "My Neighbor Alice Token",
    "https://www.myneighboralice.com/"
  ),
  for: new ERC20Token(
    ChainId.BSC,
    "0x658A109C5900BC6d2357c87549B651670E5b0539",
    18,
    "FOR",
    "Fortube Token",
    "https://www.for.tube/home"
  ),
  bux: new ERC20Token(
    ChainId.BSC,
    "0x211FfbE424b90e25a15531ca322adF1559779E45",
    18,
    "BUX",
    "Bux Crypto Token",
    "https://getbux.com/bux-crypto/"
  ),
  nuls: new ERC20Token(
    ChainId.BSC,
    "0x8CD6e29d3686d24d3C2018CEe54621eA0f89313B",
    8,
    "NULS",
    "Nuls Token",
    "https://www.nuls.io/"
  ),
  ramp: new ERC20Token(
    ChainId.BSC,
    "0x8519EA49c997f50cefFa444d240fB655e89248Aa",
    18,
    "RAMP",
    "RAMP DEFI Token",
    "https://rampdefi.com/"
  ),
  bfi: new ERC20Token(
    ChainId.BSC,
    "0x81859801b01764D4f0Fa5E64729f5a6C3b91435b",
    18,
    "BFI",
    "bearn.fi Token",
    "https://bearn.fi/"
  ),
  dexe: new ERC20Token(
    ChainId.BSC,
    "0x039cB485212f996A9DBb85A9a75d898F94d38dA6",
    18,
    "DEXE",
    "DeXe Token",
    "https://dexe.network/"
  ),
  bel: new ERC20Token(
    ChainId.BSC,
    "0x8443f091997f06a61670B735ED92734F5628692F",
    18,
    "BEL",
    "Bella Protocol Token",
    "https://bella.fi/"
  ),
  tpt: new ERC20Token(
    ChainId.BSC,
    "0xECa41281c24451168a37211F0bc2b8645AF45092",
    4,
    "TPT",
    "Tokenpocket Token",
    "https://www.tokenpocket.pro/"
  ),
  xmark: new ERC20Token(
    ChainId.BSC,
    "0x26A5dFab467d4f58fB266648CAe769503CEC9580",
    9,
    "xMARK",
    "Benchmark Protocol Token",
    "https://benchmarkprotocol.finance/"
  ),
  bmxx: new ERC20Token(
    ChainId.BSC,
    "0x4131b87F74415190425ccD873048C708F8005823",
    18,
    "bMXX",
    "Multiplier Token",
    "https://multiplier.finance/"
  ),
  iotx: new ERC20Token(
    ChainId.BSC,
    "0x9678E42ceBEb63F23197D726B29b1CB20d0064E5",
    18,
    "IOTX",
    "Binance-Peg IoTeX Network Token",
    "https://iotex.io/"
  ),
  bor: new ERC20Token(
    ChainId.BSC,
    "0x92D7756c60dcfD4c689290E8A9F4d263b3b32241",
    18,
    "BOR",
    "BoringDAO Token",
    "https://www.boringdao.com/"
  ),
  bopen: new ERC20Token(
    ChainId.BSC,
    "0xF35262a9d427F96d2437379eF090db986eaE5d42",
    18,
    "bOPEN",
    "OPEN Governance Token",
    "https://opendao.io/"
  ),
  dodo: new ERC20Token(
    ChainId.BSC,
    "0x67ee3Cb086F8a16f34beE3ca72FAD36F7Db929e2",
    18,
    "DODO",
    "Dodo Token",
    "https://dodoex.io/"
  ),
  swingby: new ERC20Token(
    ChainId.BSC,
    "0x71DE20e0C4616E7fcBfDD3f875d568492cBE4739",
    18,
    "SWINGBY",
    "Swingby Network Token",
    "https://swingby.network/"
  ),
  zee: new ERC20Token(
    ChainId.BSC,
    "0x44754455564474A89358B2C2265883DF993b12F0",
    18,
    "ZEE",
    "Zeroswap Token",
    "https://zeroswap.io/"
  ),
  swgb: new ERC20Token(
    ChainId.BSC,
    "0xE40255C5d7fa7ceEc5120408C78C787CECB4cfdb",
    18,
    "SWGb",
    "SWGb Token",
    "https://swirgepay.com/"
  ),
  swg: new ERC20Token(
    ChainId.BSC,
    "0xe792f64C582698b8572AAF765bDC426AC3aEfb6B",
    18,
    "SWG",
    "SWG Token",
    "https://swirgepay.com/"
  ),
  sfp: new ERC20Token(
    ChainId.BSC,
    "0xD41FDb03Ba84762dD66a0af1a6C8540FF1ba5dfb",
    18,
    "SFP",
    "Safepal Token",
    "https://www.safepal.io/"
  ),
  lina: new ERC20Token(
    ChainId.BSC,
    "0x762539b45A1dCcE3D36d080F74d1AED37844b878",
    18,
    "LINA",
    "Linear Finance Token",
    "https://linear.finance/"
  ),
  lit: new ERC20Token(
    ChainId.BSC,
    "0xb59490aB09A0f526Cc7305822aC65f2Ab12f9723",
    18,
    "LIT",
    "Litentry Token",
    "https://www.litentry.com/"
  ),
  hget: new ERC20Token(
    ChainId.BSC,
    "0xC7d8D35EBA58a0935ff2D5a33Df105DD9f071731",
    6,
    "HGET",
    "Hedget Token",
    "https://www.hedget.com/"
  ),
  bdo: new ERC20Token(
    ChainId.BSC,
    "0x190b589cf9Fb8DDEabBFeae36a813FFb2A702454",
    18,
    "BDO",
    "Bdollar Token",
    "https://bdollar.fi/"
  ),
  egld: new ERC20Token(
    ChainId.BSC,
    "0xbF7c81FFF98BbE61B40Ed186e4AfD6DDd01337fe",
    18,
    "EGLD",
    "Elrond Token",
    "https://elrond.com/"
  ),
  front: new ERC20Token(
    ChainId.BSC,
    "0x928e55daB735aa8260AF3cEDadA18B5f70C72f1b",
    18,
    "FRONT",
    "Frontier Token",
    "https://frontier.xyz/"
  ),
  btcst: new ERC20Token(
    ChainId.BSC,
    "0x78650B139471520656b9E7aA7A5e9276814a38e9",
    17,
    "BTCST",
    "StandardBTCHashrate Token",
    "https://www.1-b.tc/"
  ),
  bscx: new ERC20Token(
    ChainId.BSC,
    "0x5Ac52EE5b2a633895292Ff6d8A89bB9190451587",
    18,
    "BSCX",
    "BSCX Token",
    "https://bscex.org/"
  ),
  balbt: new ERC20Token(
    ChainId.BSC,
    "0x72fAa679E1008Ad8382959FF48E392042A8b06f7",
    18,
    "bALBT",
    "AllianceBlock Token",
    "https://allianceblock.io/"
  ),
  asr: new ERC20Token(
    ChainId.BSC,
    "0x80D5f92C2c8C682070C95495313dDB680B267320",
    2,
    "ASR",
    "AS Roma Token",
    "https://www.chiliz.com"
  ),
  atm: new ERC20Token(
    ChainId.BSC,
    "0x25E9d05365c867E59C1904E7463Af9F312296f9E",
    2,
    "ATM",
    "Athletico Madrid Token",
    "https://www.chiliz.com"
  ),
  og: new ERC20Token(
    ChainId.BSC,
    "0xf05E45aD22150677a017Fbd94b84fBB63dc9b44c",
    2,
    "OG",
    "OG Nice Token",
    "https://www.chiliz.com"
  ),
  reef: new ERC20Token(
    ChainId.BSC,
    "0xF21768cCBC73Ea5B6fd3C687208a7c2def2d966e",
    18,
    "REEF",
    "Reef.finance Token",
    "https://reef.finance/"
  ),
  juv: new ERC20Token(
    ChainId.BSC,
    "0xC40C9A843E1c6D01b7578284a9028854f6683b1B",
    2,
    "JUV",
    "Juventus Token",
    "https://www.chiliz.com"
  ),
  psg: new ERC20Token(
    ChainId.BSC,
    "0xBc5609612b7C44BEf426De600B5fd1379DB2EcF1",
    2,
    "PSG",
    "Paris Saint-Germain Token",
    "https://www.chiliz.com"
  ),
  vai: new ERC20Token(
    ChainId.BSC,
    "0x4BD17003473389A42DAF6a0a729f6Fdb328BbBd7",
    18,
    "VAI",
    "VAI Stablecoin",
    "0x4BD17003473389A42DAF6a0a729f6Fdb328BbBd7"
  ),
  unfi: new ERC20Token(
    ChainId.BSC,
    "0x728C5baC3C3e370E372Fc4671f9ef6916b814d8B",
    18,
    "UNFI",
    "UNFI Token",
    "https://unifiprotocol.com"
  ),
  twt: new ERC20Token(
    ChainId.BSC,
    "0x4B0F1812e5Df2A09796481Ff14017e6005508003",
    18,
    "TWT",
    "Trust Wallet Token",
    "https://trustwallet.com/"
  ),
  hard: new ERC20Token(
    ChainId.BSC,
    "0xf79037F6f6bE66832DE4E7516be52826BC3cBcc4",
    6,
    "HARD",
    "HARD Token",
    "https://hard.kava.io"
  ),
  broobee: new ERC20Token(
    ChainId.BSC,
    "0xE64F5Cb844946C1F102Bd25bBD87a5aB4aE89Fbe",
    18,
    "bROOBEE",
    "ROOBEE Token",
    "https://roobee.io/"
  ),
  stax: new ERC20Token(
    ChainId.BSC,
    "0x0Da6Ed8B13214Ff28e9Ca979Dd37439e8a88F6c4",
    18,
    "STAX",
    "StableX Token",
    "https://stablexswap.com/"
  ),
  nar: new ERC20Token(
    ChainId.BSC,
    "0xA1303E6199b319a891b79685F0537D289af1FC83",
    18,
    "NAR",
    "Narwhalswap Token",
    "https://narwhalswap.org/"
  ),
  nya: new ERC20Token(
    ChainId.BSC,
    "0xbFa0841F7a90c4CE6643f651756EE340991F99D5",
    18,
    "NYA",
    "Nyanswop Token",
    "https://nyanswop.org/"
  ),
  ctk: new ERC20Token(
    ChainId.BSC,
    "0xA8c2B8eec3d368C0253ad3dae65a5F2BBB89c929",
    6,
    "CTK",
    "Certik Token",
    "https://www.certik.foundation/"
  ),
  inj: new ERC20Token(
    ChainId.BSC,
    "0xa2B726B1145A4773F68593CF171187d8EBe4d495",
    18,
    "INJ",
    "Injective Protocol Token",
    "https://injectiveprotocol.com/"
  ),
  sxp: new ERC20Token(
    ChainId.BSC,
    "0x47BEAd2563dCBf3bF2c9407fEa4dC236fAbA485A",
    18,
    "SXP",
    "Swipe Token",
    "https://swipe.io/"
  ),
  alpha: new ERC20Token(
    ChainId.BSC,
    "0xa1faa113cbE53436Df28FF0aEe54275c13B40975",
    18,
    "ALPHA",
    "Alpha Finance Token",
    "https://alphafinance.io/"
  ),
  xvs: new ERC20Token(
    ChainId.BSC,
    "0xcF6BB5389c92Bdda8a3747Ddb454cB7a64626C63",
    18,
    "XVS",
    "Venus Token",
    "https://venus.io/"
  ),
  sushi: new ERC20Token(
    ChainId.BSC,
    "0x947950BcC74888a40Ffa2593C5798F11Fc9124C4",
    18,
    "SUSHI",
    "Binance-Peg SushiToken",
    "https://sushi.com/"
  ),
  comp: new ERC20Token(
    ChainId.BSC,
    "0x52CE071Bd9b1C4B00A0b92D298c512478CaD67e8",
    18,
    "COMP",
    "Compound Finance Token",
    "https://compound.finance/"
  ),
  bifi: new ERC20Token(
    ChainId.BSC,
    "0xCa3F508B8e4Dd382eE878A314789373D80A5190A",
    18,
    "BIFI",
    "Beefy Finance Token",
    "https://beefy.finance/"
  ),
  dusk: new ERC20Token(
    ChainId.BSC,
    "0xB2BD0749DBE21f623d9BABa856D3B0f0e1BFEc9C",
    18,
    "DUSK",
    "Dusk Network Token",
    "https://dusk.network/"
  ),
  beth: new ERC20Token(
    ChainId.BSC,
    "0x250632378E573c6Be1AC2f97Fcdf00515d0Aa91B",
    18,
    "BETH",
    "Binance Beacon ETH",
    "https://ethereum.org/en/eth2/beacon-chain/"
  ),
  mamzn: new ERC20Token(
    ChainId.BSC,
    "0x3947B992DC0147D2D89dF0392213781b04B25075",
    18,
    "mAMZN",
    "Wrapped Mirror AMZN Token",
    "https://mirror.finance/"
  ),
  mgoogl: new ERC20Token(
    ChainId.BSC,
    "0x62D71B23bF15218C7d2D7E48DBbD9e9c650B173f",
    18,
    "mGOOGL",
    "Wrapped Mirror GOOGL Token",
    "https://mirror.finance/"
  ),
  mnflx: new ERC20Token(
    ChainId.BSC,
    "0xa04F060077D90Fe2647B61e4dA4aD1F97d6649dc",
    18,
    "mNFLX",
    "Wrapped Mirror NFLX Token",
    "https://mirror.finance/"
  ),
  mtsla: new ERC20Token(
    ChainId.BSC,
    "0xF215A127A196e3988C09d052e16BcFD365Cd7AA3",
    18,
    "mTSLA",
    "Wrapped Mirror TSLA Token",
    "https://mirror.finance/"
  ),
  ltc: new ERC20Token(
    ChainId.BSC,
    "0x4338665CBB7B2485A8855A139b75D5e34AB0DB94",
    18,
    "LTC",
    "Binance-Peg Litecoin Token",
    "https://litecoin.org/"
  ),
  ada: new ERC20Token(
    ChainId.BSC,
    "0x3EE2200Efb3400fAbB9AacF31297cBdD1d435D47",
    18,
    "ADA",
    "Binance-Peg Cardano Token",
    "https://www.cardano.org/"
  ),
  band: new ERC20Token(
    ChainId.BSC,
    "0xAD6cAEb32CD2c308980a548bD0Bc5AA4306c6c18",
    18,
    "BAND",
    "Binance-Peg Band Protocol Token",
    "https://bandprotocol.com/"
  ),
  dot: new ERC20Token(
    ChainId.BSC,
    "0x7083609fCE4d1d8Dc0C979AAb8c869Ea2C873402",
    18,
    "DOT",
    "Binance-Peg Polkadot Token",
    "https://polkadot.network/"
  ),
  eos: new ERC20Token(
    ChainId.BSC,
    "0x56b6fB708fC5732DEC1Afc8D8556423A2EDcCbD6",
    18,
    "EOS",
    "Binance-Peg EOS Token",
    "https://eos.io/"
  ),
  link: new ERC20Token(
    ChainId.BSC,
    "0xF8A0BF9cF54Bb92F17374d9e9A321E6a111a51bD",
    18,
    "LINK",
    "Binance-Peg Chainlink Token",
    "https://chain.link/"
  ),
  xrp: new ERC20Token(
    ChainId.BSC,
    "0x1D2F0da169ceB9fC7B3144628dB156f3F6c60dBE",
    18,
    "XRP",
    "Binance-Peg XRP Token",
    "https://ripple.com/xrp/"
  ),
  atom: new ERC20Token(
    ChainId.BSC,
    "0x0Eb3a705fc54725037CC9e008bDede697f62F335",
    18,
    "ATOM",
    "Binance-Peg Cosmos Token",
    "https://cosmos.network/"
  ),
  yfii: new ERC20Token(
    ChainId.BSC,
    "0x7F70642d88cf1C4a3a7abb072B53B929b653edA5",
    18,
    "YFII",
    "Binance-Peg YFII.finance Token",
    "https://dfi.money/#/"
  ),
  xtz: new ERC20Token(
    ChainId.BSC,
    "0x16939ef78684453bfDFb47825F8a5F714f12623a",
    18,
    "XTZ",
    "Binance-Peg Tezos Token",
    "https://www.tezos.com/"
  ),
  bch: new ERC20Token(
    ChainId.BSC,
    "0x8fF795a6F4D97E7887C79beA79aba5cc76444aDf",
    18,
    "BCH",
    "Binance-Peg Bitcoin Cash Token",
    "https://bch.info/"
  ),
  yfi: new ERC20Token(
    ChainId.BSC,
    "0x88f1A5ae2A3BF98AEAF342D26B30a79438c9142e",
    18,
    "YFI",
    "Binance-Peg yearn.finance Token",
    "https://yearn.finance/"
  ),
  uni: new ERC20Token(
    ChainId.BSC,
    "0xBf5140A22578168FD562DCcF235E5D43A02ce9B1",
    18,
    "UNI",
    "Binance-Peg Uniswap Token",
    "https://uniswap.org/"
  ),
  fil: new ERC20Token(
    ChainId.BSC,
    "0x0D8Ce2A99Bb6e3B7Db580eD848240e4a0F9aE153",
    18,
    "FIL",
    "Binance-Peg Filecoin Token",
    "https://filecoin.io/"
  ),
  bake: new ERC20Token(
    ChainId.BSC,
    "0xE02dF9e3e622DeBdD69fb838bB799E3F168902c5",
    18,
    "BAKE",
    "Bakeryswap Token",
    "https://www.bakeryswap.org/"
  ),
  burger: new ERC20Token(
    ChainId.BSC,
    "0xAe9269f27437f0fcBC232d39Ec814844a51d6b8f",
    18,
    "BURGER",
    "Burgerswap Token",
    "https://burgerswap.org/"
  ),
  bdigg: new ERC20Token(
    ChainId.BSC,
    "0x5986D5c77c65e5801a5cAa4fAE80089f870A71dA",
    18,
    "bDIGG",
    "Badger Sett Digg Token",
    "https://badger.finance/"
  ),
  bbadger: new ERC20Token(
    ChainId.BSC,
    "0x1F7216fdB338247512Ec99715587bb97BBf96eae",
    18,
    "bBadger",
    "Badger Sett Badger Token",
    "https://badger.finance/"
  ),
  trade: new ERC20Token(
    ChainId.BSC,
    "0x7af173F350D916358AF3e218Bdf2178494Beb748",
    18,
    "TRADE",
    "Unitrade Token",
    "https://unitrade.app/"
  ),
  pnt: new ERC20Token(
    ChainId.BSC,
    "0xdaacB0Ab6Fb34d24E8a67BfA14BF4D95D4C7aF92",
    18,
    "PNT",
    "pNetwork Token",
    "https://ptokens.io/"
  ),
  mir: new ERC20Token(
    ChainId.BSC,
    "0x5B6DcF557E2aBE2323c48445E8CC948910d8c2c9",
    18,
    "MIR",
    "Mirror Protocol Token",
    "https://mirror.finance/"
  ),
  pbtc: new ERC20Token(
    ChainId.BSC,
    "0xeD28A457A5A76596ac48d87C0f577020F6Ea1c4C",
    18,
    "pBTC",
    "pTokens BTC Token",
    "https://ptokens.io/"
  ),
  lto: new ERC20Token(
    ChainId.BSC,
    "0x857B222Fc79e1cBBf8Ca5f78CB133d1b7CF34BBd",
    18,
    "LTO",
    "LTO Network Token",
    "https://ltonetwork.com/"
  ),
  pcws: new ERC20Token(
    ChainId.BSC,
    "0xbcf39F0EDDa668C58371E519AF37CA705f2bFcbd",
    18,
    "pCWS",
    "PolyCrowns Token",
    "https://game.seascape.network/"
  ),
  zil: new ERC20Token(
    ChainId.BSC,
    "0xb86AbCb37C3A4B64f74f59301AFF131a1BEcC787",
    12,
    "ZIL",
    "Zilliqa Token",
    "https://www.zilliqa.com/"
  ),
  lien: new ERC20Token(
    ChainId.BSC,
    "0x5d684ADaf3FcFe9CFb5ceDe3abf02F0Cdd1012E3",
    8,
    "LIEN",
    "Lien Finance Token",
    "https://lien.finance/"
  ),
  swth: new ERC20Token(
    ChainId.BSC,
    "0x250b211EE44459dAd5Cd3bCa803dD6a7EcB5d46C",
    8,
    "SWTH",
    "Switcheo Network Token",
    "https://switcheo.network/"
  ),
  dft: new ERC20Token(
    ChainId.BSC,
    "0x42712dF5009c20fee340B245b510c0395896cF6e",
    18,
    "DFT",
    "Dfuture Token",
    "https://www.dfuture.com/home"
  ),
  gum: new ERC20Token(
    ChainId.BSC,
    "0xc53708664b99DF348dd27C3Ac0759d2DA9c40462",
    18,
    "GUM",
    "GourmetGalaxy Token",
    "https://gourmetgalaxy.io/"
  ),
  dego: new ERC20Token(
    ChainId.BSC,
    "0x3FdA9383A84C05eC8f7630Fe10AdF1fAC13241CC",
    18,
    "DEGO",
    "Dego Finance Token",
    "https://bsc.dego.finance/home"
  ),
  nrv: new ERC20Token(
    ChainId.BSC,
    "0x42F6f551ae042cBe50C739158b4f0CAC0Edb9096",
    18,
    "NRV",
    "Nerve Finance Token",
    "https://nerve.fi/"
  ),
  easy: new ERC20Token(
    ChainId.BSC,
    "0x7C17c8bED8d14bAccE824D020f994F4880D6Ab3B",
    18,
    "EASY",
    "EASY Token",
    "https://easyfi.network/"
  ),
  oddz: new ERC20Token(
    ChainId.BSC,
    "0xCD40F2670CF58720b694968698A5514e924F742d",
    18,
    "ODDZ",
    "Oddz Token",
    "https://oddz.fi/"
  ),
  hoo: new ERC20Token(
    ChainId.BSC,
    "0xE1d1F66215998786110Ba0102ef558b22224C016",
    8,
    "HOO",
    "Hoo Token",
    "https://hoo.com/"
  ),
  apys: new ERC20Token(
    ChainId.BSC,
    "0x37dfACfaeDA801437Ff648A1559d73f4C40aAcb7",
    18,
    "APYS",
    "APY Swap Token",
    "https://apyswap.com/"
  ),
  bondly: new ERC20Token(
    ChainId.BSC,
    "0x96058f8C3e16576D9BD68766f3836d9A33158f89",
    18,
    "BONDLY",
    "Bondly Token",
    "https://www.bondly.finance/"
  ),
  tko: new ERC20Token(
    ChainId.BSC,
    "0x9f589e3eabe42ebC94A44727b3f3531C0c877809",
    18,
    "TKO",
    "Tokocrypto Token",
    "https://www.tokocrypto.com/"
  ),
  itam: new ERC20Token(
    ChainId.BSC,
    "0x04C747b40Be4D535fC83D09939fb0f626F32800B",
    18,
    "ITAM",
    "Itam Network Token",
    "https://itam.network/"
  ),
  arpa: new ERC20Token(
    ChainId.BSC,
    "0x6F769E65c14Ebd1f68817F5f1DcDb61Cfa2D6f7e",
    18,
    "ARPA",
    "Arpachain Token",
    "https://arpachain.io/"
  ),
  eps: new ERC20Token(
    ChainId.BSC,
    "0xA7f552078dcC247C2684336020c03648500C6d9F",
    18,
    "EPS",
    "Ellipsis Finance Token",
    "https://ellipsis.finance/"
  ),
  jgn: new ERC20Token(
    ChainId.BSC,
    "0xC13B7a43223BB9Bf4B69BD68Ab20ca1B79d81C75",
    18,
    "JGN",
    "Juggernaut DeFi Token",
    "https://jgndefi.com/"
  ),
  tlm: new ERC20Token(
    ChainId.BSC,
    "0x2222227E22102Fe3322098e4CBfE18cFebD57c95",
    4,
    "TLM",
    "Alien Worlds Trilium Token",
    "https://alienworlds.io/"
  ),
  perl: new ERC20Token(
    ChainId.BSC,
    "0x0F9E4D49f25de22c2202aF916B681FBB3790497B",
    18,
    "PERL",
    "Perlin",
    "https://perlinx.finance/"
  ),
  alpa: new ERC20Token(
    ChainId.BSC,
    "0xc5E6689C9c8B02be7C49912Ef19e79cF24977f03",
    18,
    "ALPA",
    "AlpaToken",
    "https://bsc.alpaca.city/"
  ),
  hzn: new ERC20Token(
    ChainId.BSC,
    "0xC0eFf7749b125444953ef89682201Fb8c6A917CD",
    18,
    "HZN",
    "Horizon Protocol Token",
    "https://horizonprotocol.com/"
  ),
  suter: new ERC20Token(
    ChainId.BSC,
    "0x4CfbBdfBd5BF0814472fF35C72717Bd095ADa055",
    18,
    "SUTER",
    "Suterusu Token",
    "https://shield.suterusu.io/"
  ),
  cgg: new ERC20Token(
    ChainId.BSC,
    "0x1613957159E9B0ac6c80e824F7Eea748a32a0AE2",
    18,
    "CGG",
    "pTokens CGG Token",
    "https://chainguardians.io/"
  ),
  mix: new ERC20Token(
    ChainId.BSC,
    "0xB67754f5b4C704A24d2db68e661b2875a4dDD197",
    18,
    "MIX",
    "Mix Token",
    "https://mixie.chainguardians.io/"
  ),
  hakka: new ERC20Token(
    ChainId.BSC,
    "0x1D1eb8E8293222e1a29d2C0E4cE6C0Acfd89AaaC",
    18,
    "HAKKA",
    "Hakka Token",
    "https://hakka.finance/"
  ),
  xed: new ERC20Token(
    ChainId.BSC,
    "0x5621b5A3f4a8008c4CCDd1b942B121c8B1944F1f",
    18,
    "XED",
    "Exeedme Token",
    "https://www.exeedme.com/"
  ),
  \u03C4btc: new ERC20Token(
    ChainId.BSC,
    "0x2cD1075682b0FCCaADd0Ca629e138E64015Ba11c",
    9,
    "\u03C4BTC",
    "\u03C4Bitcoin Token",
    "https://www.btcst.finance/"
  ),
  alpaca: new ERC20Token(
    ChainId.BSC,
    "0x8F0528cE5eF7B51152A59745bEfDD91D97091d2F",
    18,
    "ALPACA",
    "AlpacaToken",
    "https://www.alpacafinance.org/"
  ),
  dfd: new ERC20Token(
    ChainId.BSC,
    "0x9899a98b222fCb2f3dbee7dF45d943093a4ff9ff",
    18,
    "DFD",
    "DefiDollar DAO",
    "https://dusd.finance/"
  ),
  lmt: new ERC20Token(
    ChainId.BSC,
    "0x9617857E191354dbEA0b714d78Bc59e57C411087",
    18,
    "LMT",
    "Lympo Market Token",
    "https://lympo.io/lmt/"
  ),
  bttold: new ERC20Token(
    ChainId.BSC,
    "0x8595F9dA7b868b1822194fAEd312235E43007b49",
    18,
    "BTTOLD",
    "Binance-Peg BitTorrent Token (Old)",
    "https://www.bittorrent.com/"
  ),
  trx: new ERC20Token(
    ChainId.BSC,
    "0x85EAC5Ac2F758618dFa09bDbe0cf174e7d574D5B",
    18,
    "TRX",
    "TRON Token",
    "https://tron.network/"
  ),
  win: new ERC20Token(
    ChainId.BSC,
    "0xaeF0d72a118ce24feE3cD1d43d383897D05B4e99",
    18,
    "WIN",
    "WIN Token",
    "https://winklink.org/"
  ),
  mcoin: new ERC20Token(
    ChainId.BSC,
    "0x49022089e78a8D46Ec87A3AF86a1Db6c189aFA6f",
    18,
    "MCOIN",
    "Wrapped Mirror COIN Token",
    "https://mirror.finance/"
  ),
  math: new ERC20Token(
    ChainId.BSC,
    "0xF218184Af829Cf2b0019F8E6F0b2423498a36983",
    18,
    "MATH",
    "MATH Token",
    "https://mathwallet.org/"
  ),
  kun: new ERC20Token(
    ChainId.BSC,
    "0x1A2fb0Af670D0234c2857FaD35b789F8Cb725584",
    18,
    "KUN",
    "QIAN governance token",
    "https://chemix.io/home"
  ),
  qsd: new ERC20Token(
    ChainId.BSC,
    "0x07AaA29E63FFEB2EBf59B33eE61437E1a91A3bb2",
    18,
    "QSD",
    "QIAN second generation dollar",
    "https://chemix.io/home"
  ),
  hyfi: new ERC20Token(
    ChainId.BSC,
    "0x9a319b959e33369C5eaA494a770117eE3e585318",
    18,
    "HYFI",
    "HYFI Token",
    "https://hyfi.pro/#/"
  ),
  oin: new ERC20Token(
    ChainId.BSC,
    "0x658E64FFcF40D240A43D52CA9342140316Ae44fA",
    8,
    "OIN",
    "oinfinance Token",
    "https://oin.finance/"
  ),
  doge: new ERC20Token(
    ChainId.BSC,
    "0xbA2aE424d960c26247Dd6c32edC70B295c744C43",
    8,
    "DOGE",
    "Binance-Peg Dogecoin",
    "https://dogecoin.com/"
  ),
  fine: new ERC20Token(
    ChainId.BSC,
    "0x4e6415a5727ea08aAE4580057187923aeC331227",
    18,
    "FINE",
    "Refinable Token",
    "https://refinable.com/"
  ),
  one: new ERC20Token(
    ChainId.BSC,
    "0x04BAf95Fd4C52fd09a56D840bAEe0AB8D7357bf0",
    18,
    "ONE",
    "BigONE Token",
    "https://www.bigone.com/"
  ),
  pmon: new ERC20Token(
    ChainId.BSC,
    "0x1796ae0b0fa4862485106a0de9b654eFE301D0b2",
    18,
    "PMON",
    "Polkamon Token",
    "https://polkamon.com/"
  ),
  \u03C4doge: new ERC20Token(
    ChainId.BSC,
    "0xe550a593d09FBC8DCD557b5C88Cea6946A8b404A",
    8,
    "\u03C4DOGE",
    "\u03C4Dogecoin",
    "https://www.btcst.finance/"
  ),
  btr: new ERC20Token(
    ChainId.BSC,
    "0x5a16E8cE8cA316407c6E6307095dc9540a8D62B3",
    18,
    "BTR",
    "Bitrue Token",
    "https://www.bitrue.com/"
  ),
  ubxt: new ERC20Token(
    ChainId.BSC,
    "0xBbEB90cFb6FAFa1F69AA130B7341089AbeEF5811",
    18,
    "UBXT",
    "UpBots Token",
    "https://upbots.com/"
  ),
  wmass: new ERC20Token(
    ChainId.BSC,
    "0x7e396BfC8a2f84748701167c2d622F041A1D7a17",
    8,
    "WMASS",
    "Wrapped MASS Token",
    "https://massnet.org/en/"
  ),
  rfox: new ERC20Token(
    ChainId.BSC,
    "0x0a3A21356793B49154Fd3BbE91CBc2A16c0457f5",
    18,
    "RFOX",
    "RFOX Token",
    "https://www.redfoxlabs.io/"
  ),
  xend: new ERC20Token(
    ChainId.BSC,
    "0x4a080377f83D669D7bB83B3184a8A5E61B500608",
    18,
    "XEND",
    "XEND Token",
    "https://xend.finance/"
  ),
  cyc: new ERC20Token(
    ChainId.BSC,
    "0x810EE35443639348aDbbC467b33310d2AB43c168",
    18,
    "CYC",
    "CYC Token",
    "https://cyclone.xyz/"
  ),
  chr: new ERC20Token(
    ChainId.BSC,
    "0xf9CeC8d50f6c8ad3Fb6dcCEC577e05aA32B224FE",
    6,
    "CHR",
    "Chroma Token",
    "https://chromia.com/"
  ),
  deri: new ERC20Token(
    ChainId.BSC,
    "0xe60eaf5A997DFAe83739e035b005A33AfdCc6df5",
    18,
    "DERI",
    "Deri Token",
    "https://deri.finance/#/index"
  ),
  well: new ERC20Token(
    ChainId.BSC,
    "0xf07a32Eb035b786898c00bB1C64d8c6F8E7a46D5",
    18,
    "WELL",
    "BitWell Token",
    "https://www.bitwellex.com/"
  ),
  wex: new ERC20Token(
    ChainId.BSC,
    "0xa9c41A46a6B3531d28d5c32F6633dd2fF05dFB90",
    18,
    "WEX",
    "WaultSwap Token",
    "https://wault.finance/"
  ),
  waultx: new ERC20Token(
    ChainId.BSC,
    "0xB64E638E60D154B43f660a6BF8fD8a3b249a6a21",
    18,
    "WAULTx",
    "Wault Token",
    "https://wault.finance/"
  ),
  popen: new ERC20Token(
    ChainId.BSC,
    "0xaBaE871B7E3b67aEeC6B46AE9FE1A91660AadAC5",
    18,
    "pOPEN",
    "OPEN Governance Token",
    "https://opendao.io/"
  ),
  ez: new ERC20Token(
    ChainId.BSC,
    "0x5512014efa6Cd57764Fa743756F7a6Ce3358cC83",
    18,
    "EZ",
    "Easy V2 Token",
    "https://easyfi.network/"
  ),
  vrt: new ERC20Token(
    ChainId.BSC,
    "0x5F84ce30DC3cF7909101C69086c50De191895883",
    18,
    "VRT",
    "Venus Reward Token",
    "https://venus.io/"
  ),
  deprecated_tusd: new ERC20Token(
    ChainId.BSC,
    "0x14016E85a25aeb13065688cAFB43044C2ef86784",
    18,
    "TUSDOLD",
    "Binance-Peg TrueUSD Token",
    "https://www.trueusd.com/"
  ),
  mtrg: new ERC20Token(
    ChainId.BSC,
    "0xBd2949F67DcdC549c6Ebe98696449Fa79D988A9F",
    18,
    "MTRG",
    "Wrapped MTRG Token",
    "https://www.meter.io/"
  ),
  ktn: new ERC20Token(
    ChainId.BSC,
    "0xDAe6c2A48BFAA66b43815c5548b10800919c993E",
    18,
    "KTN",
    "Kattana Token",
    "https://kattana.io/"
  ),
  qkc: new ERC20Token(
    ChainId.BSC,
    "0xA1434F1FC3F437fa33F7a781E041961C0205B5Da",
    18,
    "QKC",
    "QuarkChain Token",
    "https://quarkchain.io/"
  ),
  bcfx: new ERC20Token(
    ChainId.BSC,
    "0x045c4324039dA91c52C55DF5D785385Aab073DcF",
    18,
    "bCFX",
    "ChainId.BSC Conflux Token",
    "https://www.confluxnetwork.org/"
  ),
  mx: new ERC20Token(
    ChainId.BSC,
    "0x9F882567A62a5560d147d64871776EeA72Df41D3",
    18,
    "MX",
    "MX Token",
    "https://www.mxc.com/"
  ),
  ata: new ERC20Token(
    ChainId.BSC,
    "0xA2120b9e674d3fC3875f415A7DF52e382F141225",
    18,
    "ATA",
    "Automata Token",
    "https://www.ata.network/"
  ),
  mbox: new ERC20Token(
    ChainId.BSC,
    "0x3203c9E46cA618C8C1cE5dC67e7e9D75f5da2377",
    18,
    "MBOX",
    "Mobox Token",
    "https://www.mobox.io/#/"
  ),
  boring: new ERC20Token(
    ChainId.BSC,
    "0xffEecbf8D7267757c2dc3d13D730E97E15BfdF7F",
    18,
    "BORING",
    "BoringDAO Token",
    "https://www.boringdao.com/"
  ),
  marsh: new ERC20Token(
    ChainId.BSC,
    "0x2FA5dAF6Fe0708fBD63b1A7D1592577284f52256",
    18,
    "MARSH",
    "Unmarshal Token",
    "https://unmarshal.io/"
  ),
  ampl: new ERC20Token(
    ChainId.BSC,
    "0xDB021b1B247fe2F1fa57e0A87C748Cc1E321F07F",
    9,
    "AMPL",
    "AMPL Token",
    "https://www.ampleforth.org/"
  ),
  o3: new ERC20Token(
    ChainId.BSC,
    "0xEe9801669C6138E84bD50dEB500827b776777d28",
    18,
    "O3",
    "O3 Swap Token",
    "https://o3swap.com/"
  ),
  hai: new ERC20Token(
    ChainId.BSC,
    "0xaA9E582e5751d703F85912903bacADdFed26484C",
    8,
    "HAI",
    "Hacken Token",
    "https://hacken.io/"
  ),
  htb: new ERC20Token(
    ChainId.BSC,
    "0x4e840AADD28DA189B9906674B4Afcb77C128d9ea",
    18,
    "HTB",
    "Hotbit Token",
    "https://www.hotbit.io/"
  ),
  woo: new ERC20Token(
    ChainId.BSC,
    "0x4691937a7508860F876c9c0a2a617E7d9E945D4B",
    18,
    "WOO",
    "Wootrade Network Token",
    "https://woo.network/"
  ),
  $dg: new ERC20Token(
    ChainId.BSC,
    "0x9Fdc3ae5c814b79dcA2556564047C5e7e5449C19",
    18,
    "$DG",
    "Decentral Games Token",
    "https://decentral.games/"
  ),
  axs: new ERC20Token(
    ChainId.BSC,
    "0x715D400F88C167884bbCc41C5FeA407ed4D2f8A0",
    18,
    "AXS",
    "Binance-Pegged Axie Infinity Shard",
    "https://axieinfinity.com/"
  ),
  c98: new ERC20Token(
    ChainId.BSC,
    "0xaEC945e04baF28b135Fa7c640f624f8D90F1C3a6",
    18,
    "c98",
    "Coin98 Token",
    "https://coin98.com/"
  ),
  pots: new ERC20Token(
    ChainId.BSC,
    "0x3Fcca8648651E5b974DD6d3e50F61567779772A8",
    18,
    "POTS",
    "Moonpot Token",
    "https://moonpot.com/"
  ),
  gnt: new ERC20Token(
    ChainId.BSC,
    "0xF750A26EB0aCf95556e8529E72eD530f3b60f348",
    18,
    "GNT",
    "GreenTrust Token",
    "https://www.greentrusttoken.com/"
  ),
  rusd: new ERC20Token(
    ChainId.BSC,
    "0x07663837218A003e66310a01596af4bf4e44623D",
    18,
    "rUSD",
    "rUSD Token",
    "https://appv2.rampdefi.com/#/"
  ),
  bp: new ERC20Token(
    ChainId.BSC,
    "0xACB8f52DC63BB752a51186D1c55868ADbFfEe9C1",
    18,
    "BP",
    "BunnyPark Token",
    "https://www.bunnypark.com/"
  ),
  sfund: new ERC20Token(
    ChainId.BSC,
    "0x477bC8d23c634C154061869478bce96BE6045D12",
    18,
    "SFUND",
    "Seedify Fund Token",
    "https://seedify.fund/"
  ),
  naos: new ERC20Token(
    ChainId.BSC,
    "0x758d08864fB6cCE3062667225ca10b8F00496cc2",
    18,
    "NAOS",
    "NAOSToken",
    "https://naos.finance/"
  ),
  cart: new ERC20Token(
    ChainId.BSC,
    "0x5C8C8D560048F34E5f7f8ad71f2f81a89DBd273e",
    18,
    "CART",
    "CryptoArt.ai",
    "https://cryptoart.ai/"
  ),
  light: new ERC20Token(
    ChainId.BSC,
    "0x037838b556d9c9d654148a284682C55bB5f56eF4",
    18,
    "LIGHT",
    "Lightning",
    "https://lightningprotocol.finance/"
  ),
  rpg: new ERC20Token(
    ChainId.BSC,
    "0xc2098a8938119A52B1F7661893c0153A6CB116d5",
    18,
    "RPG",
    "Rangers Protocol",
    "https://www.rangersprotocol.com/"
  ),
  mcb: new ERC20Token(
    ChainId.BSC,
    "0x5fE80d2CD054645b9419657d3d10d26391780A7B",
    18,
    "MCB",
    "MCDEX",
    "https://mcdex.io/homepage/"
  ),
  lazio: new ERC20Token(
    ChainId.BSC,
    "0x77d547256A2cD95F32F67aE0313E450Ac200648d",
    8,
    "LAZIO",
    "FC Lazio Fan Token",
    "https://launchpad.binance.com/en/subscription/LAZIO_BNB"
  ),
  arv: new ERC20Token(
    ChainId.BSC,
    "0x6679eB24F59dFe111864AEc72B443d1Da666B360",
    8,
    "ARV",
    "ARIVA",
    "https://ariva.digital"
  ),
  moni: new ERC20Token(
    ChainId.BSC,
    "0x9573c88aE3e37508f87649f87c4dd5373C9F31e0",
    18,
    "MONI",
    "Monsta Infinite",
    "https://monstainfinite.com/"
  ),
  xms: new ERC20Token(
    ChainId.BSC,
    "0x7859B01BbF675d67Da8cD128a50D155cd881B576",
    18,
    "XMS",
    "Mars Ecosystem",
    "https://marsecosystem.com/"
  ),
  zoo: new ERC20Token(
    ChainId.BSC,
    "0x1D229B958D5DDFca92146585a8711aECbE56F095",
    18,
    "ZOO",
    "ZOO Crypto World",
    "https://zoogame.finance/"
  ),
  fina: new ERC20Token(
    ChainId.BSC,
    "0x426c72701833fdDBdFc06c944737C6031645c708",
    18,
    "FINA",
    "Defina Finance",
    "https://defina.finance/"
  ),
  dar: new ERC20Token(
    ChainId.BSC,
    "0x23CE9e926048273eF83be0A3A8Ba9Cb6D45cd978",
    6,
    "DAR",
    "Mines of Dalarnia",
    "https://www.minesofdalarnia.com/"
  ),
  xwg: new ERC20Token(
    ChainId.BSC,
    "0x6b23C89196DeB721e6Fd9726E6C76E4810a464bc",
    18,
    "XWG",
    "X World Games",
    "https://xwg.games/"
  ),
  eternal: new ERC20Token(
    ChainId.BSC,
    "0xD44FD09d74cd13838F137B590497595d6b3FEeA4",
    18,
    "ETERNAL",
    "CryptoMines Eternal",
    "https://cryptomines.app/"
  ),
  porto: new ERC20Token(
    ChainId.BSC,
    "0x49f2145d6366099e13B10FbF80646C0F377eE7f6",
    8,
    "PORTO",
    "FC Porto Fan Token",
    "https://launchpad.binance.com/en/subscription/PORTO_BNB"
  ),
  kart: new ERC20Token(
    ChainId.BSC,
    "0x8BDd8DBcBDf0C066cA5f3286d33673aA7A553C10",
    18,
    "KART",
    "Dragon Kart",
    "https://dragonkart.com/"
  ),
  qi: new ERC20Token(ChainId.BSC, "0x8729438EB15e2C8B576fCc6AeCdA6A148776C0F5", 18, "QI", "BENQI", "https://benqi.fi/"),
  sheesha: new ERC20Token(
    ChainId.BSC,
    "0x232FB065D9d24c34708eeDbF03724f2e95ABE768",
    18,
    "SHEESHA",
    "Sheesha Finance",
    "https://www.sheeshafinance.io/"
  ),
  bcoin: new ERC20Token(
    ChainId.BSC,
    "0x00e1656e45f18ec6747F5a8496Fd39B50b38396D",
    18,
    "BCOIN",
    "Bomb Crypto",
    "https://bombcrypto.io/"
  ),
  quidd: new ERC20Token(
    ChainId.BSC,
    "0x7961Ade0a767c0E5B67Dd1a1F78ba44F727642Ed",
    18,
    "QUIDD",
    "Quidd Token",
    "https://www.quiddtoken.com/"
  ),
  santos: new ERC20Token(
    ChainId.BSC,
    "0xA64455a4553C9034236734FadDAddbb64aCE4Cc7",
    8,
    "SANTOS",
    "FC Santos Fan Token",
    "https://launchpad.binance.com/en/launchpool/SANTOS_BNB"
  ),
  nabox: new ERC20Token(
    ChainId.BSC,
    "0x755f34709E369D37C6Fa52808aE84A32007d1155",
    18,
    "NABOX",
    "Nabox Token",
    "https://nabox.io/"
  ),
  xcv: new ERC20Token(
    ChainId.BSC,
    "0x4be63a9b26EE89b9a3a13fd0aA1D0b2427C135f8",
    18,
    "XCV",
    "XCarnival",
    "https://xcarnival.fi/"
  ),
  idia: new ERC20Token(
    ChainId.BSC,
    "0x0b15Ddf19D47E6a86A56148fb4aFFFc6929BcB89",
    18,
    "IDIA",
    "Impossible Decentralized Incubator Access Token",
    "https://impossible.finance/"
  ),
  tt: new ERC20Token(
    ChainId.BSC,
    "0x990E7154bB999FAa9b2fa5Ed29E822703311eA85",
    18,
    "TT",
    "ThunderCore",
    "https://www.thundercore.com/"
  ),
  gmee: new ERC20Token(
    ChainId.BSC,
    "0x84e9a6F9D240FdD33801f7135908BfA16866939A",
    18,
    "GMEE",
    "GAMEE",
    "https://www.gamee.com/token"
  ),
  htd: new ERC20Token(
    ChainId.BSC,
    "0x5E2689412Fae5c29BD575fbe1d5C1CD1e0622A8f",
    18,
    "HTD",
    "HeroesTD",
    "https://heroestd.io/"
  ),
  dpt: new ERC20Token(
    ChainId.BSC,
    "0xE69cAef10A488D7AF31Da46c89154d025546e990",
    18,
    "DPT",
    "Diviner Protocol",
    "https://diviner.finance/"
  ),
  thg: new ERC20Token(
    ChainId.BSC,
    "0x9fD87aEfe02441B123c3c32466cD9dB4c578618f",
    18,
    "THG",
    "Thetan Gem",
    "https://thetanarena.com/"
  ),
  ccar: new ERC20Token(
    ChainId.BSC,
    "0x50332bdca94673F33401776365b66CC4e81aC81d",
    18,
    "CCAR",
    "CryptoCars",
    "https://cryptocars.me/"
  ),
  high: new ERC20Token(
    ChainId.BSC,
    "0x5f4Bde007Dc06b867f86EBFE4802e34A1fFEEd63",
    18,
    "HIGH",
    "Highstreet Token",
    "https://highstreet.market/"
  ),
  sdao: new ERC20Token(
    ChainId.BSC,
    "0x90Ed8F1dc86388f14b64ba8fb4bbd23099f18240",
    18,
    "SDAO",
    "Singularity Dao",
    "https://app.singularitydao.ai/"
  ),
  antex: new ERC20Token(
    ChainId.BSC,
    "0xCA1aCAB14e85F30996aC83c64fF93Ded7586977C",
    8,
    "ANTEX",
    "Antex",
    "https://antex.org/"
  ),
  bbt: new ERC20Token(
    ChainId.BSC,
    "0xD48474E7444727bF500a32D5AbE01943f3A59A64",
    8,
    "BBT",
    "BitBook",
    "https://www.bitbook.network/"
  ),
  woop: new ERC20Token(
    ChainId.BSC,
    "0x8b303d5BbfBbf46F1a4d9741E491e06986894e18",
    18,
    "WOOP",
    "Woonkly Power",
    "https://www.woonkly.com/"
  ),
  gm: new ERC20Token(
    ChainId.BSC,
    "0xe2604C9561D490624AA35e156e65e590eB749519",
    18,
    "GM",
    "GoldMiner",
    "https://goldminer.games/"
  ),
  aog: new ERC20Token(
    ChainId.BSC,
    "0x40C8225329Bd3e28A043B029E0D07a5344d2C27C",
    18,
    "AOG",
    "AgeOfGods",
    "https://ageofgods.net/"
  ),
  "8pay": new ERC20Token(
    ChainId.BSC,
    "0xFeea0bDd3D07eb6FE305938878C0caDBFa169042",
    18,
    "8PAY",
    "8PAY Network",
    "https://8pay.network/"
  ),
  bath: new ERC20Token(
    ChainId.BSC,
    "0x0bc89aa98Ad94E6798Ec822d0814d934cCD0c0cE",
    18,
    "BATH",
    "Battle Hero",
    "https://battlehero.io/"
  ),
  insur: new ERC20Token(
    ChainId.BSC,
    "0x3192CCDdf1CDcE4Ff055EbC80f3F0231b86A7E30",
    18,
    "INSUR",
    "Bsc-Peg INSUR Token",
    "https://www.insurace.io/"
  ),
  froyo: new ERC20Token(
    ChainId.BSC,
    "0xe369fec23380f9F14ffD07a1DC4b7c1a9fdD81c9",
    18,
    "FROYO",
    "Froyo Games",
    "https://froyo.games/"
  ),
  apx: new ERC20Token(
    ChainId.BSC,
    "0x78F5d389F5CDCcFc41594aBaB4B0Ed02F31398b3",
    18,
    "APX",
    "ApolloX Token",
    "https://www.apollox.finance/"
  ),
  prl: new ERC20Token(
    ChainId.BSC,
    "0xd07e82440A395f3F3551b42dA9210CD1Ef4f8B24",
    18,
    "PRL",
    "Parallel Token",
    "https://theparallel.io"
  ),
  fuse: new ERC20Token(
    ChainId.BSC,
    "0x5857c96DaE9cF8511B08Cb07f85753C472D36Ea3",
    18,
    "FUSE",
    "Fuse Token",
    "https://fuse.io/"
  ),
  ertha: new ERC20Token(
    ChainId.BSC,
    "0x62823659d09F9F9D2222058878f89437425eB261",
    18,
    "ERTHA",
    "Ertha Token",
    "https://ertha.io/"
  ),
  raca: new ERC20Token(
    ChainId.BSC,
    "0x12BB890508c125661E03b09EC06E404bc9289040",
    18,
    "RACA",
    "Radio Caca V2",
    "https://www.radiocaca.com/#/home"
  ),
  gear: new ERC20Token(
    ChainId.BSC,
    "0xb4404DaB7C0eC48b428Cf37DeC7fb628bcC41B36",
    18,
    "GEAR",
    "MetaGear Token",
    "https://metagear.game/"
  ),
  ach: new ERC20Token(
    ChainId.BSC,
    "0xBc7d6B50616989655AfD682fb42743507003056D",
    8,
    "ACH",
    "Alchemy Token",
    "https://alchemytech.io/"
  ),
  btt: new ERC20Token(
    ChainId.BSC,
    "0x352Cb5E19b12FC216548a2677bD0fce83BaE434B",
    18,
    "BTT",
    "BitTorrent",
    "https://bittorrent.com/"
  ),
  era: new ERC20Token(
    ChainId.BSC,
    "0x6f9F0c4ad9Af7EbD61Ac5A1D4e0F2227F7B0E5f9",
    18,
    "ERA",
    "Era Token",
    "https://www.era7.io/"
  ),
  fight: new ERC20Token(
    ChainId.BSC,
    "0x4f39c3319188A723003670c3F9B9e7EF991E52F3",
    18,
    "FIGHT",
    "Fight Token",
    "https://www.cryptofightclub.io/"
  ),
  loa: new ERC20Token(
    ChainId.BSC,
    "0x94b69263FCA20119Ae817b6f783Fc0F13B02ad50",
    18,
    "LOA",
    "League Of Ancients",
    "https://www.leagueofancients.com/"
  ),
  duet: new ERC20Token(
    ChainId.BSC,
    "0x95EE03e1e2C5c4877f9A298F1C0D6c98698FAB7B",
    18,
    "DUET",
    "Duet Governance Token",
    "https://duet.finance"
  ),
  gmt: new ERC20Token(
    ChainId.BSC,
    "0x3019BF2a2eF8040C242C9a4c5c4BD4C81678b2A1",
    8,
    "GMT",
    "Green Metaverse Token",
    "https://www.stepn.com/"
  ),
  bsw: new ERC20Token(
    ChainId.BSC,
    "0x965F527D9159dCe6288a2219DB51fc6Eef120dD1",
    18,
    "BSW",
    "Biswap",
    "https://biswap.org/"
  ),
  tem: new ERC20Token(
    ChainId.BSC,
    "0x19e6BfC1A6e4B042Fb20531244D47E252445df01",
    9,
    "TEM",
    "TemplarDAO",
    "https://templar.finance/"
  ),
  pex: new ERC20Token(
    ChainId.BSC,
    "0x6a0b66710567b6beb81A71F7e9466450a91a384b",
    18,
    "PEX",
    "PearDAO",
    "https://peardao.io/"
  ),
  yel: new ERC20Token(
    ChainId.BSC,
    "0xD3b71117E6C1558c1553305b44988cd944e97300",
    18,
    "YEL",
    "YEL",
    "https://yel.finance/"
  ),
  tinc: new ERC20Token(
    ChainId.BSC,
    "0x05aD6E30A855BE07AfA57e08a4f30d00810a402e",
    18,
    "TINC",
    "Tiny Coin",
    "https://tinyworlds.io/"
  ),
  happy: new ERC20Token(
    ChainId.BSC,
    "0xF5d8A096CcCb31b9D7bcE5afE812BE23e3D4690d",
    18,
    "Happy",
    "HappyFans",
    "https://happyfans.club/"
  ),
  wzrd: new ERC20Token(
    ChainId.BSC,
    "0xFa40d8FC324bcdD6Bbae0e086De886c571C225d4",
    18,
    "WZRD",
    "Wizardia Token",
    "https://wizardia.io/"
  ),
  ceek: new ERC20Token(
    ChainId.BSC,
    "0xe0F94Ac5462997D2BC57287Ac3a3aE4C31345D66",
    18,
    "CEEK",
    "CEEK",
    "https://www.ceek.com/"
  ),
  abnbc: new ERC20Token(
    ChainId.BSC,
    "0xE85aFCcDaFBE7F2B096f268e31ccE3da8dA2990A",
    18,
    "aBNBc",
    "Ankr BNB Reward Bearing Certificate",
    "https://www.ankr.com/"
  ),
  ankr: new ERC20Token(
    ChainId.BSC,
    "0xf307910A4c7bbc79691fD374889b36d8531B08e3",
    18,
    "ANKR",
    "Ankr",
    "https://www.ankr.com/"
  ),
  gal: new ERC20Token(
    ChainId.BSC,
    "0xe4Cc45Bb5DBDA06dB6183E8bf016569f40497Aa5",
    18,
    "GAL",
    "Galxe",
    "https://galaxy.eco/"
  ),
  xcn: new ERC20Token(
    ChainId.BSC,
    "0x7324c7C0d95CEBC73eEa7E85CbAac0dBdf88a05b",
    18,
    "XCN",
    "Chain",
    "https://chain.com/"
  ),
  metis: new ERC20Token(
    ChainId.BSC,
    "0xe552Fb52a4F19e44ef5A967632DBc320B0820639",
    18,
    "Metis",
    "Metis Token",
    "https://www.metis.io/"
  ),
  MIX: new ERC20Token(
    ChainId.BSC,
    "0x398f7827DcCbeFe6990478876bBF3612D93baF05",
    18,
    "MIX",
    "MixMarvel Token",
    "https://www.mixmarvel.com/"
  ),
  peak: new ERC20Token(
    ChainId.BSC,
    "0x630d98424eFe0Ea27fB1b3Ab7741907DFFEaAd78",
    8,
    "PEAK",
    "PEAKDEFI",
    "https://peakdefi.com/"
  ),
  nbt: new ERC20Token(
    ChainId.BSC,
    "0x1D3437E570e93581Bd94b2fd8Fbf202d4a65654A",
    18,
    "NBT",
    "NanoByte Token",
    "https://www.nanobyte.finance/"
  ),
  trivia: new ERC20Token(
    ChainId.BSC,
    "0xb465f3cb6Aba6eE375E12918387DE1eaC2301B05",
    3,
    "TRIVIA",
    "Trivian Token",
    "https://trivians.io/"
  ),
  mhunt: new ERC20Token(
    ChainId.BSC,
    "0x2C717059b366714d267039aF8F59125CAdce6D8c",
    18,
    "MHUNT",
    "MetaShooter",
    "https://metashooter.gg/"
  ),
  ole: new ERC20Token(
    ChainId.BSC,
    "0xa865197A84E780957422237B5D152772654341F3",
    18,
    "OLE",
    "OpenLeverage",
    "https://openleverage.finance/"
  ),
  xcad: new ERC20Token(
    ChainId.BSC,
    "0xa026Ad2ceDa16Ca5FC28fd3C72f99e2C332c8a26",
    18,
    "XCAD",
    "Chainport.io-Peg XCAD Token",
    "https://xcadnetwork.com/"
  ),
  shell: new ERC20Token(
    ChainId.BSC,
    "0x208cfEc94d2BA8B8537da7A9BB361c6baAD77272",
    18,
    "SHELL",
    "Meta Apes Shell",
    "https://metaapesgame.com/"
  ),
  peel: new ERC20Token(
    ChainId.BSC,
    "0x734548a9e43d2D564600b1B2ed5bE9C2b911c6aB",
    18,
    "PEEL",
    "Meta Apes Peel",
    "https://metaapesgame.com/"
  ),
  stkbnb: new ERC20Token(
    ChainId.BSC,
    "0xc2E9d07F66A89c44062459A47a0D2Dc038E4fb16",
    18,
    "stkBNB",
    "Staked BNB",
    "https://pstake.finance/bnb"
  ),
  pstake: new ERC20Token(
    ChainId.BSC,
    "0x4C882ec256823eE773B25b414d36F92ef58a7c0C",
    18,
    "PSTAKE",
    "pStake Finance",
    "https://pstake.finance/"
  ),
  wom: new ERC20Token(
    ChainId.BSC,
    "0xAD6742A35fB341A9Cc6ad674738Dd8da98b94Fb1",
    18,
    "WOM",
    "Wombat Token",
    "https://www.wombat.exchange/"
  ),
  hay: new ERC20Token(
    ChainId.BSC,
    "0x0782b6d8c4551B9760e74c0545a9bCD90bdc41E5",
    18,
    "HAY",
    "Hay Destablecoin",
    "https://helio.money/"
  ),
  spin: new ERC20Token(
    ChainId.BSC,
    "0x6AA217312960A21aDbde1478DC8cBCf828110A67",
    18,
    "SPIN",
    "Spintop",
    "https://spintop.network/"
  ),
  snfts: new ERC20Token(
    ChainId.BSC,
    "0x6f51A1674BEFDD77f7ab1246b83AdB9f13613762",
    18,
    "SNFTS",
    "Seedify NFT Space",
    "https://snfts.seedify.fund/"
  ),
  gq: new ERC20Token(
    ChainId.BSC,
    "0xF700D4c708C2be1463E355F337603183D20E0808",
    18,
    "GQ",
    "Galactic Quadrant",
    "https://outerringmmo.com/"
  ),
  hoop: new ERC20Token(
    ChainId.BSC,
    "0xF19cfb40B3774dF6Eed83169Ad5aB0Aaf6865F25",
    18,
    "HOOP",
    "Chibi Dinos",
    "https://www.chibidinos.io/"
  ),
  co: new ERC20Token(ChainId.BSC, "0x936B6659Ad0C1b244Ba8Efe639092acae30dc8d6", 6, "CO", "CO", "https://corite.com/"),
  krs: new ERC20Token(
    ChainId.BSC,
    "0x37b53894e7429f794B56F22a32E1695567Ee9913",
    18,
    "KRS",
    "Kingdom Raids",
    "https://kingdomraids.io/"
  ),
  wmx: new ERC20Token(
    ChainId.BSC,
    "0xa75d9ca2a0a1D547409D82e1B06618EC284A2CeD",
    18,
    "WMX",
    "Wombex Token",
    "https://wombex.finance/"
  ),
  mgp: new ERC20Token(
    ChainId.BSC,
    "0xD06716E1Ff2E492Cc5034c2E81805562dd3b45fa",
    18,
    "MGP",
    "Magpie Token",
    "https://www.magpiexyz.io/"
  ),
  hook: new ERC20Token(
    ChainId.BSC,
    "0xa260E12d2B924cb899AE80BB58123ac3fEE1E2F0",
    18,
    "HOOK",
    "Hook Token",
    "https://hooked.io/"
  ),
  hft: new ERC20Token(
    ChainId.BSC,
    "0x44Ec807ce2F4a6F2737A92e985f318d035883e47",
    18,
    "HFT",
    "Hashflow",
    "https://www.hashflow.com/"
  ),
  squad: new ERC20Token(
    ChainId.BSC,
    "0x724A32dFFF9769A0a0e1F0515c0012d1fB14c3bd",
    18,
    "SQUAD",
    "Token SQUAD",
    "https://ssquad.games/"
  ),
  zbc: new ERC20Token(
    ChainId.BSC,
    "0x37a56cdcD83Dce2868f721De58cB3830C44C6303",
    9,
    "ZBC",
    "ZEBEC",
    "https://zebec.io/"
  ),
  primal: new ERC20Token(
    ChainId.BSC,
    "0xCb5327Ed4649548e0d73E70b633cdfd99aF6Da87",
    18,
    "PRIMAL",
    "PRIMAL Token",
    "https://www.getprimal.com/"
  ),
  ankrbnb: new ERC20Token(
    ChainId.BSC,
    "0x52F24a5e03aee338Da5fd9Df68D2b6FAe1178827",
    18,
    "ankrBNB",
    "Ankr Staked BNB",
    "https://www.ankr.com/staking-crypto/"
  ),
  arena: new ERC20Token(
    ChainId.BSC,
    "0xCfFD4D3B517b77BE32C76DA768634dE6C738889B",
    18,
    "ARENA",
    "ESPL ARENA",
    "https://espl.co/"
  ),
  champ: new ERC20Token(
    ChainId.BSC,
    "0x7e9AB560d37E62883E882474b096643caB234B65",
    18,
    "CHAMP",
    "Ultimate Champions Token",
    "https://beta.ultimate-champions.com/"
  ),
  axlusdc: new ERC20Token(
    ChainId.BSC,
    "0x4268B8F0B87b6Eae5d897996E6b845ddbD99Adf3",
    6,
    "axlUSDC",
    "Axelar Wrapped USDC",
    "https://axelarscan.io/assets/"
  ),
  csix: new ERC20Token(
    ChainId.BSC,
    "0x04756126F044634C9a0f0E985e60c88a51ACC206",
    18,
    "CSIX",
    "Carbon",
    "https://carbon.website/"
  ),
  bnbx: new ERC20Token(
    ChainId.BSC,
    "0x1bdd3Cf7F79cfB8EdbB955f20ad99211551BA275",
    18,
    "BNBx",
    "Liquid Staking BNB",
    "https://www.staderlabs.com/bnb/liquid-staking/bnbx/"
  ),
  sd: new ERC20Token(
    ChainId.BSC,
    "0x3BC5AC0dFdC871B365d159f728dd1B9A0B5481E8",
    18,
    "SD",
    "Stader (Wormhole)",
    "https://www.staderlabs.com/"
  ),
  ageur: new ERC20Token(
    ChainId.BSC,
    "0x12f31B73D812C6Bb0d735a218c086d44D5fe5f89",
    18,
    "agEUR",
    "agEUR",
    "https://app.angle.money/#/"
  ),
  caps: new ERC20Token(
    ChainId.BSC,
    "0xFfBa7529AC181c2Ee1844548e6D7061c9A597dF4",
    18,
    "CAPS",
    "Capsule Coin",
    "https://www.ternoa.network/en"
  ),
  lvl: new ERC20Token(
    ChainId.BSC,
    "0xB64E280e9D1B5DbEc4AcceDb2257A87b400DB149",
    18,
    "LVL",
    "Level Token",
    "https://level.finance/"
  ),
  unw: new ERC20Token(
    ChainId.BSC,
    "0x5b65cd9feb54F1Df3D0C60576003344079f8Dc06",
    18,
    "UNW",
    "Uniwhale Token",
    "https://www.uniwhale.co/"
  ),
  id: new ERC20Token(
    ChainId.BSC,
    "0x2dfF88A56767223A5529eA5960Da7A3F5f766406",
    18,
    "ID",
    "SPACE ID",
    "https://space.id/"
  ),
  rdnt: new ERC20Token(
    ChainId.BSC,
    "0xf7DE7E8A6bd59ED41a4b5fe50278b3B7f31384dF",
    18,
    "RDNT",
    "Radiant",
    "https://radiant.capital/"
  ),
  sis: new ERC20Token(
    ChainId.BSC,
    "0xF98b660AdF2ed7d9d9D9dAACC2fb0CAce4F21835",
    18,
    "SIS",
    "Symbiosis",
    "https://symbiosis.finance/"
  ),
  ankrETH: new ERC20Token(
    ChainId.BSC,
    "0xe05A08226c49b636ACf99c40Da8DC6aF83CE5bB3",
    18,
    "ankrETH",
    "Ankr Staked ETH",
    "https://www.ankr.com/"
  ),
  axl: new ERC20Token(
    ChainId.BSC,
    "0x8b1f4432F943c465A973FeDC6d7aa50Fc96f1f65",
    6,
    "AXL",
    "Axelar",
    "https://axelar.network/"
  ),
  ush: new ERC20Token(
    ChainId.BSC,
    "0x91d6d6aF7635B7b23A8CED9508117965180e2362",
    18,
    "USH",
    "unshETHing_Token",
    "https://unsheth.xyz/"
  ),
  unshETH: new ERC20Token(
    ChainId.BSC,
    "0x0Ae38f7E10A43B5b2fB064B42a2f4514cbA909ef",
    18,
    "unshETH",
    "unshETH Ether",
    "https://unsheth.xyz/"
  ),
  wbeth: new ERC20Token(
    ChainId.BSC,
    "0xa2E3356610840701BDf5611a53974510Ae27E2e1",
    18,
    "wBETH",
    "Wrapped Binance Beacon ETH",
    "https://ethereum.org/en/roadmap/beacon-chain/"
  ),
  edu: new ERC20Token(
    ChainId.BSC,
    "0xBdEAe1cA48894A1759A8374D63925f21f2Ee2639",
    18,
    "EDU",
    "EDU Coin",
    "https://www.opencampus.xyz/"
  ),
  pepe: new ERC20Token(
    ChainId.BSC,
    "0x25d887Ce7a35172C62FeBFD67a1856F20FaEbB00",
    18,
    "PEPE",
    "Pepe",
    "https://www.pepe.vip/"
  ),
  cgpt: new ERC20Token(
    ChainId.BSC,
    "0x9840652DC04fb9db2C43853633f0F62BE6f00f98",
    18,
    "CGPT",
    "ChainGPT",
    "https://www.chaingpt.org/"
  ),
  play: new ERC20Token(
    ChainId.BSC,
    "0xD069599E718f963bD84502b49ba8F8657fAF5B3a",
    18,
    "PLAY",
    "PLAY",
    "https://xcadnetwork.com/play"
  ),
  tusd: new ERC20Token(
    ChainId.BSC,
    "0x40af3827F39D0EAcBF4A168f8D4ee67c121D11c9",
    18,
    "TUSD",
    "TrueUSD",
    "https://tusd.io/"
  )
};
var bscTestnetTokens = {
  dona: DONA[ChainId.BSC_TESTNET],
  wbnb: WBNB[ChainId.BSC_TESTNET],
  flame: FLAME_TESTNET,
  busd: BUSD_TESTNET,
  syrup: new ERC20Token(
    ChainId.BSC_TESTNET,
    "0xfE1e507CeB712BDe086f3579d2c03248b2dB77f9",
    18,
    "SYRUP",
    "SyrupBar Token",
    "https://donaswap.io/"
  ),
  hbtc: new ERC20Token(ChainId.BSC_TESTNET, "0x3Fb6a6C06c7486BD194BB99a078B89B9ECaF4c82", 18, "HBTC", "Huobi BTC"),
  wbtc: new ERC20Token(ChainId.BSC_TESTNET, "0xfC8bFbe9644e1BC836b8821660593e7de711e564", 8, "WBTC", "Wrapped BTC"),
  usdc: new ERC20Token(
    ChainId.BSC_TESTNET,
    "0xCA8eB2dec4Fe3a5abbFDc017dE48E461A936623D",
    18,
    "USDC",
    "Binance-Peg USD Coin"
  ),
  usdt: new ERC20Token(ChainId.BSC_TESTNET, "0x0fB5D7c73FA349A90392f873a4FA1eCf6a3d0a96", 18, "USDT", "Tether USD"),
  mockBusd: new ERC20Token(
    ChainId.BSC_TESTNET,
    "0x3304dd20f6Fe094Cb0134a6c8ae07EcE26c7b6A7",
    18,
    "BUSD",
    "Binance USD"
  ),
  mockB: new ERC20Token(ChainId.BSC_TESTNET, "0x828E3FC56dD48E072e3B6F3C4FD4DDB4733c2C5e", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.BSC_TESTNET, "0xc1eD9955C11585F47d0d6BfBC29034349A746a81", 18, "MOCK A", "MOCK A"),
  msix: new ERC20Token(ChainId.BSC_TESTNET, "0xE4a9f36B61a84Dc2495dAf46417bd258a56bDfdD", 6, "MSIX", "MSIX"),
  flame2: new ERC20Token(
    ChainId.BSC_TESTNET,
    "0x8d008B313C1d6C7fE2982F62d32Da7507cF43551",
    18,
    "FLAME2",
    "Fire Flame Token",
    "https://donaswap.io/"
  )
};
var polygonTokens = {
  flame: FLAME_POLYGON,
  dona: DONA[ChainId.POLYGON],
  wmatic: WMATIC[ChainId.POLYGON],
  usdt: USDT_POLYGON
  // mockB: new ERC20Token(ChainId.POLYGON, '0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327', 18, 'MOCK B', 'MOCK B'),
  // mockA: new ERC20Token(ChainId.POLYGON, '0xD134B434682dF091E398a844Dc3c613fe728cE2D', 18, 'MOCK A', 'MOCK A'),
};
var polygonAmoyTokens = {
  flame: FLAME_AMOY,
  wmatic: WMATIC[ChainId.POLYGON_AMOY],
  usdt: USDT[ChainId.POLYGON_AMOY],
  dona: DONA[ChainId.POLYGON_AMOY],
  mockB: new ERC20Token(ChainId.POLYGON_AMOY, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.POLYGON_AMOY, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var cronosTokens = {
  wcro: WCRO[ChainId.CRO],
  usdt: USDT_CRO,
  dona: DONA_CRO
  // mockB: new ERC20Token(ChainId.CRO, '0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327', 18, 'MOCK B', 'MOCK B'),
  // mockA: new ERC20Token(ChainId.CRO, '0xD134B434682dF091E398a844Dc3c613fe728cE2D', 18, 'MOCK A', 'MOCK A'),
};
var cronosTestnetTokens = {
  wcro: WCRO[ChainId.CRO_TESTNET],
  usdt: USDT[ChainId.CRO_TESTNET],
  dona: DONA[ChainId.CRO_TESTNET]
  // mockB: new ERC20Token(ChainId.CRO_TESTNET, '0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327', 18, 'MOCK B', 'MOCK B'),
  // mockA: new ERC20Token(ChainId.CRO_TESTNET, '0xD134B434682dF091E398a844Dc3c613fe728cE2D', 18, 'MOCK A', 'MOCK A'),
};
var avalancheTokens = {
  wavax: WAVAX[ChainId.AVALANCHE],
  usdt: USDT_AVALANCHE,
  dona: DONA_AVALANCHE,
  mockB: new ERC20Token(ChainId.AVALANCHE, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.AVALANCHE, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var avalancheFujiTokens = {
  wavax: WAVAX[ChainId.AVALANCHE_FUJI],
  usdt: USDT_FUJI,
  dona: DONA_FUJI,
  mockB: new ERC20Token(ChainId.AVALANCHE_FUJI, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.AVALANCHE_FUJI, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var fantomOperaTokens = {
  wftm: WFTM[ChainId.FANTOM_OPERA],
  usdt: USDT_FANTOM_OPERA,
  dona: DONA_FANTOM_OPERA,
  mockB: new ERC20Token(ChainId.FANTOM_OPERA, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.FANTOM_OPERA, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var fantomTestnetTokens = {
  wftm: WFTM[ChainId.FANTOM_TESTNET],
  usdt: USDT_FANTOM_TESTNET,
  dona: DONA_FANTOM_TESTNET,
  mockB: new ERC20Token(ChainId.FANTOM_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.FANTOM_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var celoTokens = {
  wcelo: WCELO[ChainId.CELO],
  usdt: USDT_CELO,
  dona: DONA_CELO,
  mockB: new ERC20Token(ChainId.CELO, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.CELO, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var celoAlfajoresTokens = {
  wcelo: WCELO[ChainId.CELO_ALFAJORES],
  usdt: USDT_ALFAJORES,
  dona: DONA_ALFAJORES,
  mockB: new ERC20Token(ChainId.CELO_ALFAJORES, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.CELO_ALFAJORES, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var optimismTokens = {
  weth: WETH9[ChainId.OPTIMISM],
  usdt: USDT_OPTIMISM,
  dona: DONA_OPTIMISM,
  mockB: new ERC20Token(ChainId.OPTIMISM, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.OPTIMISM, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var optimismGoerliTokens = {
  weth: WETH9[ChainId.OPTIMISM_GOERLI],
  usdt: USDT_OPTIMISM_GOERLI,
  dona: DONA_OPTIMISM_GOERLI,
  mockB: new ERC20Token(ChainId.OPTIMISM_GOERLI, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.OPTIMISM_GOERLI, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var arbitrumTokens = {
  weth: WETH9[ChainId.ARBITRUM_ONE],
  usdt: USDT[ChainId.ARBITRUM_ONE],
  usdc: USDC[ChainId.ARBITRUM_ONE],
  dona: DONA[ChainId.ARBITRUM_ONE]
};
var arbitrumGoerliTokens = {
  weth: WETH9[ChainId.ARBITRUM_GOERLI],
  usdc: USDC[ChainId.ARBITRUM_GOERLI],
  usdt: USDT_ARBITRUM_GOERLI
  // dona: DONA_ARBITRUM_GOERLI,
};
var shibariumTokens = {
  wbone: WBONE[ChainId.SHIBARIUM],
  usdt: USDT_SHIBARIUM,
  dona: DONA_SHIBARIUM,
  mockB: new ERC20Token(ChainId.SHIBARIUM, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.SHIBARIUM, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var shibariumTestnetTokens = {
  wbone: WBONE[ChainId.SHIBARIUM_TESTNET],
  usdt: USDT_SHIBARIUM_TESTNET,
  dona: DONA_SHIBARIUM_TESTNET,
  mockB: new ERC20Token(ChainId.SHIBARIUM_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.SHIBARIUM_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var pulsechainTokens = {
  wpls: WPLS[ChainId.PULSECHAIN],
  usdt: USDT_PULSECHAIN,
  dona: DONA_PULSECHAIN,
  mockB: new ERC20Token(ChainId.PULSECHAIN, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.PULSECHAIN, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var pulsechainTestnetTokens = {
  wpls: WPLS[ChainId.PULSECHAIN_TESTNET],
  usdt: USDT_PULSECHAIN_TESTNET,
  dona: DONA_PULSECHAIN_TESTNET,
  mockB: new ERC20Token(ChainId.PULSECHAIN_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.PULSECHAIN_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var xenTokens = {
  wxn: WXN[ChainId.XEN],
  usdt: USDT_XEN,
  dona: DONA_XEN,
  mockB: new ERC20Token(ChainId.XEN, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.XEN, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var xenDevnetTokens = {
  wxn: WXN[ChainId.XEN_DEVNET],
  usdt: USDT_XEN_DEVNET,
  dona: DONA_XEN_DEVNET,
  mockB: new ERC20Token(ChainId.XEN_DEVNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.XEN_DEVNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var harmonyTokens = {
  wone: WONE[ChainId.HARMONY],
  usdt: USDT_HARMONY,
  dona: DONA_HARMONY,
  mockB: new ERC20Token(ChainId.HARMONY, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.HARMONY, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var harmonyTestnetTokens = {
  wone: WONE[ChainId.HARMONY_TESTNET],
  usdt: USDT_HARMONY_TESTNET,
  dona: DONA_HARMONY_TESTNET,
  mockB: new ERC20Token(ChainId.HARMONY_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.HARMONY_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var coinExTokens = {
  wcet: WCET[ChainId.COINEX],
  usdt: USDT_COINEX,
  dona: DONA_COINEX,
  mockB: new ERC20Token(ChainId.COINEX, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.COINEX, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var coinExTestnetTokens = {
  wcet: WCET[ChainId.COINEX_TESTNET],
  usdt: USDT_COINEX_TESTNET,
  dona: DONA_COINEX_TESTNET,
  mockB: new ERC20Token(ChainId.COINEX_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.COINEX_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var dogechainTokens = {
  wdoge: WDOGE[ChainId.DOGECHAIN],
  usdt: USDT_DOGECHAIN,
  dona: DONA_DOGECHAIN,
  mockB: new ERC20Token(ChainId.DOGECHAIN, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.DOGECHAIN, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var dogechainTestnetTokens = {
  wdoge: WDOGE[ChainId.DOGECHAIN_TESTNET],
  usdt: USDT_DOGECHAIN_TESTNET,
  dona: DONA_DOGECHAIN_TESTNET,
  mockB: new ERC20Token(ChainId.DOGECHAIN_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.DOGECHAIN_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var engramTestnetTokens = {
  wgram: WGRAM[ChainId.ENGRAM_TESTNET],
  usdt: USDT_ENGRAM_TESTNET,
  dona: DONA_ENGRAM_TESTNET,
  mockB: new ERC20Token(ChainId.ENGRAM_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.ENGRAM_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var etcTokens = {
  wetc: WETC[ChainId.ETHEREUM_CLASSIC],
  usdt: USDT_ETHEREUM_CLASSIC,
  dona: DONA_ETHEREUM_CLASSIC,
  mockB: new ERC20Token(ChainId.ETHEREUM_CLASSIC, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.ETHEREUM_CLASSIC, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var etcTestnetTokens = {
  wetc: WETC[ChainId.ETHEREUM_CLASSIC_TESTNET],
  usdt: USDT_ETHEREUM_CLASSIC_TESTNET,
  dona: DONA_ETHEREUM_CLASSIC_TESTNET,
  mockB: new ERC20Token(ChainId.ETHEREUM_CLASSIC_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.ETHEREUM_CLASSIC_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var fusionTokens = {
  wfsn: WFSN[ChainId.FUSION],
  usdt: USDT_FUSION,
  dona: DONA_FUSION,
  mockB: new ERC20Token(ChainId.FUSION, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.FUSION, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var fusionTestnetTokens = {
  wfsn: WFSN[ChainId.FUSION_TESTNET],
  usdt: USDT_FUSION_TESTNET,
  dona: DONA_FUSION_TESTNET,
  mockB: new ERC20Token(ChainId.FUSION_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.FUSION_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var hecoTokens = {
  wht: WHT[ChainId.HECO],
  usdt: USDT_HECO,
  dona: DONA_HECO,
  mockB: new ERC20Token(ChainId.HECO, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.HECO, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var hecoTestnetTokens = {
  wht: WHT[ChainId.HECO_TESTNET],
  usdt: USDT_HECO_TESTNET,
  dona: DONA_HECO_TESTNET,
  mockB: new ERC20Token(ChainId.HECO_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.HECO_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var kccTokens = {
  wkcs: WKCS[ChainId.KCC],
  usdt: USDT_KCC,
  dona: DONA_KCC,
  mockB: new ERC20Token(ChainId.KCC, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.KCC, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var kccTestnetTokens = {
  wkcs: WKCS[ChainId.KCC_TESTNET],
  usdt: USDT_KCC_TESTNET,
  dona: DONA_KCC_TESTNET,
  mockB: new ERC20Token(ChainId.KCC_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.KCC_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var klaytnCypressTokens = {
  wklay: WKLAY[ChainId.KLAYTN],
  usdt: USDT_KLAYTN,
  dona: DONA_KLAYTN,
  mockB: new ERC20Token(ChainId.KLAYTN, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.KLAYTN, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var klaytnBaobabTokens = {
  wklay: WKLAY[ChainId.KLAYTN_BAOBAB],
  usdt: USDT_KLAYTN_BAOBAB,
  dona: DONA_KLAYTN_BAOBAB,
  mockB: new ERC20Token(ChainId.KLAYTN_BAOBAB, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.KLAYTN_BAOBAB, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var okxChainTokens = {
  wokt: WOKT[ChainId.OKXCHAIN],
  usdt: USDT_OKXCHAIN,
  dona: DONA_OKXCHAIN,
  mockB: new ERC20Token(ChainId.OKXCHAIN, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.OKXCHAIN, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var okxChainTestnetTokens = {
  wokt: WOKT[ChainId.OKXCHAIN_TESTNET],
  usdt: USDT_OKXCHAIN_TESTNET,
  dona: DONA_OKXCHAIN_TESTNET,
  mockB: new ERC20Token(ChainId.OKXCHAIN_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.OKXCHAIN_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var thetaTokens = {
  wtfuel: WTFUEL[ChainId.THETHA],
  usdt: USDT_THETHA,
  dona: DONA_THETHA,
  mockB: new ERC20Token(ChainId.THETHA, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.THETHA, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var thetaTestnetTokens = {
  wtfuel: WTFUEL[ChainId.THETHA_TESTNET],
  usdt: USDT_THETHA_TESTNET,
  dona: DONA_THETHA_TESTNET,
  mockB: new ERC20Token(ChainId.THETHA_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.THETHA_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var ultronTokens = {
  wulx: WULX[ChainId.ULTRON],
  usdt: USDT_ULTRON,
  dona: DONA_ULTRON,
  mockB: new ERC20Token(ChainId.ULTRON, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.ULTRON, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var ultronTestnetTokens = {
  wulx: WULX[ChainId.ULTRON_TESTNET],
  usdt: USDT_ULTRON_TESTNET,
  dona: DONA_ULTRON_TESTNET,
  mockB: new ERC20Token(ChainId.ULTRON_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.ULTRON_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var moonbeamTokens = {
  wglmr: WGLMR[ChainId.MOONBEAM],
  usdt: USDT_MOONBEAM,
  dona: DONA_MOONBEAM,
  mockB: new ERC20Token(ChainId.MOONBEAM, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.MOONBEAM, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var moonriverTokens = {
  wmovr: WMOVR[ChainId.MOONRIVER],
  usdt: USDT_MOONRIVER,
  dona: DONA_MOONRIVER,
  mockB: new ERC20Token(ChainId.MOONRIVER, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.MOONRIVER, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var moonbaseAlphaTokens = {
  wdev: WDEV[ChainId.MOONBASE_ALPHA],
  usdt: USDT_MOONBASE_ALPHA,
  dona: DONA_MOONBASE_ALPHA,
  mockB: new ERC20Token(ChainId.MOONBASE_ALPHA, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.MOONBASE_ALPHA, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var auroraTokens = {
  weth: WETH9[ChainId.AURORA],
  usdt: USDT_AURORA,
  dona: DONA_AURORA,
  mockB: new ERC20Token(ChainId.AURORA, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.AURORA, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var auroraTestnetTokens = {
  weth: WETH9[ChainId.AURORA_TESTNET],
  usdt: USDT_AURORA_TESTNET,
  dona: DONA_AURORA_TESTNET,
  mockB: new ERC20Token(ChainId.AURORA_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.AURORA_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var bobaTokens = {
  weth: WETH9[ChainId.BOBA],
  usdt: USDT_BOBA,
  dona: DONA_BOBA,
  mockB: new ERC20Token(ChainId.BOBA, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.BOBA, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var bobaGoerliTokens = {
  weth: WETH9[ChainId.BOBA_GOERLI],
  usdt: USDT_BOBA_GOERLI,
  dona: DONA_BOBA_GOERLI,
  mockB: new ERC20Token(ChainId.BOBA_GOERLI, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.BOBA_GOERLI, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var gnosisTokens = {
  wxdai: WXDAI[ChainId.GNOSIS],
  usdt: USDT_GNOSIS,
  dona: DONA_GNOSIS,
  mockB: new ERC20Token(ChainId.GNOSIS, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.GNOSIS, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var gnosisChiadoTokens = {
  wxdai: WXDAI[ChainId.GNOSIS_CHIADO],
  usdt: USDT_GNOSIS_CHIADO,
  dona: DONA_GNOSIS_CHIADO,
  mockB: new ERC20Token(ChainId.GNOSIS_CHIADO, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.GNOSIS_CHIADO, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var metisTokens = {
  wmetis: WMETIS[ChainId.METIS],
  usdt: USDT_METIS,
  dona: DONA_METIS,
  mockB: new ERC20Token(ChainId.METIS, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.METIS, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var metisGoerliTokens = {
  wmetis: WMETIS[ChainId.METIS_GOERLI],
  usdt: USDT_METIS_GOERLI,
  dona: DONA_METIS_GOERLI,
  mockB: new ERC20Token(ChainId.METIS_GOERLI, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.METIS_GOERLI, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var telosTokens = {
  wtlos: WTLOS[ChainId.TELOS],
  usdt: USDT_TELOS,
  dona: DONA_TELOS,
  mockB: new ERC20Token(ChainId.TELOS, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.TELOS, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var telosTestnetTokens = {
  wtlos: WTLOS[ChainId.TELOS_TESTNET],
  usdt: USDT_TELOS_TESTNET,
  dona: DONA_TELOS_TESTNET,
  mockB: new ERC20Token(ChainId.TELOS_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.TELOS_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var syscoinTokens = {
  wsys: WSYS[ChainId.SYSCOIN],
  usdt: USDT_SYSCOIN,
  dona: DONA_SYSCOIN,
  mockB: new ERC20Token(ChainId.SYSCOIN, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.SYSCOIN, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var syscoinTanenbaumTokens = {
  wsys: WSYS[ChainId.SYSCOIN_TANENBAUM],
  usdt: USDT_SYSCOIN_TANENBAUM,
  dona: DONA_SYSCOIN_TANENBAUM,
  mockB: new ERC20Token(ChainId.SYSCOIN_TANENBAUM, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.SYSCOIN_TANENBAUM, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var iotexTokens = {
  wiotx: WIOTX[ChainId.IOTEX],
  usdt: USDT_IOTEX,
  dona: DONA_IOTEX,
  mockB: new ERC20Token(ChainId.IOTEX, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.IOTEX, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var iotexTestnetTokens = {
  wiotx: WIOTX[ChainId.IOTEX_TESTNET],
  usdt: USDT_IOTEX_TESTNET,
  dona: DONA_IOTEX_TESTNET,
  mockB: new ERC20Token(ChainId.IOTEX_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.IOTEX_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var shidenTokens = {
  wsdn: WSDN[ChainId.SHIDEN],
  usdt: USDT_SHIDEN,
  dona: DONA_SHIDEN,
  mockB: new ERC20Token(ChainId.SHIDEN, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.SHIDEN, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var astarTokens = {
  wastr: WASTR[ChainId.ASTAR],
  usdt: USDT_ASTAR,
  dona: DONA_ASTAR,
  mockB: new ERC20Token(ChainId.ASTAR, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.ASTAR, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var shibunyaTokens = {
  wsby: WSBY[ChainId.SHIBUNYA],
  usdt: USDT_SHIBUNYA,
  dona: DONA_SHIBUNYA,
  mockB: new ERC20Token(ChainId.SHIBUNYA, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.SHIBUNYA, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var fuseTokens = {
  wfuse: WFUSE[ChainId.FUSE],
  usdt: USDT_FUSE,
  dona: DONA_FUSE,
  mockB: new ERC20Token(ChainId.FUSE, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.FUSE, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var fuseSparknetTokens = {
  wfuse: WFUSE[ChainId.FUSE_SPARKNET],
  usdt: USDT_FUSE_SPARKNET,
  dona: DONA_FUSE_SPARKNET,
  mockB: new ERC20Token(ChainId.FUSE_SPARKNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.FUSE_SPARKNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var velasTokens = {
  wvlx: WVLX[ChainId.VELAS],
  usdt: USDT_VELAS,
  dona: DONA_VELAS,
  mockB: new ERC20Token(ChainId.VELAS, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.VELAS, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var velasTestnetTokens = {
  wvlx: WVLX[ChainId.VELAS_TESTNET],
  usdt: USDT_VELAS_TESTNET,
  dona: DONA_VELAS_TESTNET,
  mockB: new ERC20Token(ChainId.VELAS_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.VELAS_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var reiTokens = {
  wrei: WREI[ChainId.REI],
  usdt: USDT_REI,
  dona: DONA_REI,
  mockB: new ERC20Token(ChainId.REI, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.REI, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var reiTestnetTokens = {
  wrei: WREI[ChainId.REI_TESTNET],
  usdt: USDT_REI_TESTNET,
  dona: DONA_REI_TESTNET,
  mockB: new ERC20Token(ChainId.REI_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.REI_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var kekchainTokens = {
  wkek: WKEK[ChainId.KEKCHAIN],
  usdt: USDT_KEKCHAIN,
  dona: DONA_KEKCHAIN,
  mockB: new ERC20Token(ChainId.KEKCHAIN, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.KEKCHAIN, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var kekchainTestnetTokens = {
  wkek: WKEK[ChainId.KEKCHAIN_TESTNET],
  usdt: USDT_KEKCHAIN_TESTNET,
  dona: DONA_KEKCHAIN_TESTNET,
  mockB: new ERC20Token(ChainId.KEKCHAIN_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.KEKCHAIN_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var tomochainTokens = {
  wtomo: WTOMO[ChainId.TOMOCHAIN],
  usdt: USDT_TOMOCHAIN,
  dona: DONA_TOMOCHAIN,
  mockB: new ERC20Token(ChainId.TOMOCHAIN, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.TOMOCHAIN, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var tomochainTestnetTokens = {
  wtomo: WTOMO[ChainId.TOMOCHAIN_TESTNET],
  usdt: USDT_TOMOCHAIN_TESTNET,
  dona: DONA_TOMOCHAIN_TESTNET,
  mockB: new ERC20Token(ChainId.TOMOCHAIN_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.TOMOCHAIN_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var thundercoreTokens = {
  wtt: WTT[ChainId.THUNDERCORE],
  usdt: USDT_THUNDERCORE,
  dona: DONA_THUNDERCORE,
  mockB: new ERC20Token(ChainId.THUNDERCORE, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.THUNDERCORE, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var thundercoreTestnetTokens = {
  wtt: WTT[ChainId.THUNDERCORE_TESTNET],
  usdt: USDT_THUNDERCORE_TESTNET,
  dona: DONA_THUNDERCORE_TESTNET,
  mockB: new ERC20Token(ChainId.THUNDERCORE_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.THUNDERCORE_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var wanchainTokens = {
  wwan: WWAN[ChainId.WANCHAIN],
  usdt: USDT_WANCHAIN,
  dona: DONA_WANCHAIN,
  mockB: new ERC20Token(ChainId.WANCHAIN, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.WANCHAIN, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var wanchainTestnetTokens = {
  wwan: WWAN[ChainId.WANCHAIN_TESTNET],
  usdt: USDT_WANCHAIN_TESTNET,
  dona: DONA_WANCHAIN_TESTNET,
  mockB: new ERC20Token(ChainId.WANCHAIN_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.WANCHAIN_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var rskTokens = {
  wrbtc: WRBTC[ChainId.RSK],
  usdt: USDT_RSK,
  dona: DONA_RSK,
  mockB: new ERC20Token(ChainId.RSK, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.RSK, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var rskTestnetTokens = {
  wrbtc: WRBTC[ChainId.RSK_TESTNET],
  usdt: USDT_RSK_TESTNET,
  dona: DONA_RSK_TESTNET,
  mockB: new ERC20Token(ChainId.RSK_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.RSK_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var elastosTokens = {
  wela: WELA[ChainId.ELASTOS],
  usdt: USDT_ELASTOS,
  dona: DONA_ELASTOS,
  mockB: new ERC20Token(ChainId.ELASTOS, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.ELASTOS, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var elastosTestnetTokens = {
  wela: WELA[ChainId.ELASTOS_TESTNET],
  usdt: USDT_ELASTOS_TESTNET,
  dona: DONA_ELASTOS_TESTNET,
  mockB: new ERC20Token(ChainId.ELASTOS_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.ELASTOS_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var confluxTokens = {
  wcfx: WCFX[ChainId.CONFLUX],
  usdt: USDT_CONFLUX,
  dona: DONA_CONFLUX,
  mockB: new ERC20Token(ChainId.CONFLUX, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.CONFLUX, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var confluxTestnetTokens = {
  wcfx: WCFX[ChainId.CONFLUX_TESTNET],
  usdt: USDT_CONFLUX_TESTNET,
  dona: DONA_CONFLUX_TESTNET,
  mockB: new ERC20Token(ChainId.CONFLUX_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.CONFLUX_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var brisechainTokens = {
  wbrise: WBRISE[ChainId.BRISECHAIN],
  usdt: USDT_BRISECHAIN,
  dona: DONA_BRISECHAIN,
  mockB: new ERC20Token(ChainId.BRISECHAIN, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.BRISECHAIN, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var brisechainTestnetTokens = {
  wbrise: WBRISE[ChainId.BRISECHAIN_TESTNET],
  usdt: USDT_BRISECHAIN_TESTNET,
  dona: DONA_BRISECHAIN_TESTNET,
  mockB: new ERC20Token(ChainId.BRISECHAIN_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.BRISECHAIN_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var muuchainTokens = {
  wmuu: WMUU[ChainId.MUUCHAIN],
  usdt: USDT_MUUCHAIN,
  dona: DONA_MUUCHAIN,
  mockB: new ERC20Token(ChainId.MUUCHAIN, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.MUUCHAIN, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var muuchainTestnetTokens = {
  wmuu: WMUU[ChainId.MUUCHAIN_TESTNET],
  usdt: USDT_MUUCHAIN_TESTNET,
  dona: DONA_MUUCHAIN_TESTNET,
  mockB: new ERC20Token(ChainId.MUUCHAIN_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.MUUCHAIN_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var cantoTokens = {
  wcanto: WCANTO[ChainId.CANTO],
  usdt: USDT_CANTO,
  dona: DONA_CANTO,
  mockB: new ERC20Token(ChainId.CANTO, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.CANTO, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var cantoTestnetTokens = {
  wcanto: WCANTO[ChainId.CANTO_TESTNET],
  usdt: USDT_CANTO_TESTNET,
  dona: DONA_CANTO_TESTNET,
  mockB: new ERC20Token(ChainId.CANTO_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.CANTO_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var oasisEmeraldTokens = {
  wrose: WROSE[ChainId.OASIS_EMERALD],
  usdt: USDT_OASIS_EMERALD,
  dona: DONA_OASIS_EMERALD,
  mockB: new ERC20Token(ChainId.OASIS_EMERALD, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.OASIS_EMERALD, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var oasisTestnetTokens = {
  wrose: WROSE[ChainId.OASIS_TESTNET],
  usdt: USDT_OASIS_TESTNET,
  dona: DONA_OASIS_TESTNET,
  mockB: new ERC20Token(ChainId.OASIS_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.OASIS_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var visionTokens = {
  wvs: WVS[ChainId.VISION],
  usdt: USDT[ChainId.VISION],
  dona: DONA_VISION,
  mockB: new ERC20Token(ChainId.VISION, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.VISION, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var visionTestnetTokens = {
  wvs: WVS[ChainId.VISION_TESTNET],
  usdt: USDT_VISION_TESTNET,
  dona: DONA_VISION_TESTNET,
  mockB: new ERC20Token(ChainId.VISION_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.VISION_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var stepTokens = {
  wfitfi: WFITFI[ChainId.STEP],
  usdt: USDT_STEP,
  dona: DONA_STEP,
  mockB: new ERC20Token(ChainId.STEP, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.STEP, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var stepTestnetTokens = {
  wfitfi: WFITFI[ChainId.STEP_TESTNET],
  usdt: USDT_STEP_TESTNET,
  dona: DONA_STEP_TESTNET,
  mockB: new ERC20Token(ChainId.STEP_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.STEP_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var meterTokens = {
  wmtr: WMTR[ChainId.METER],
  usdt: USDT_METER,
  dona: DONA_METER,
  mockB: new ERC20Token(ChainId.METER, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.METER, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var meterTestnetTokens = {
  wmtr: WMTR[ChainId.METER_TESTNET],
  usdt: USDT_METER_TESTNET,
  dona: DONA_METER_TESTNET,
  mockB: new ERC20Token(ChainId.METER_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.METER_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var godwokenTokens = {
  wpckb: WPCKB[ChainId.GODWOKEN],
  usdt: USDT_GODWOKEN,
  dona: DONA_GODWOKEN,
  mockB: new ERC20Token(ChainId.GODWOKEN, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.GODWOKEN, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var godwokenTestnetTokens = {
  wpckb: WPCKB[ChainId.GODWOKEN_TESTNET],
  usdt: USDT_GODWOKEN_TESTNET,
  dona: DONA_GODWOKEN_TESTNET,
  mockB: new ERC20Token(ChainId.GODWOKEN_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.GODWOKEN_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var callistoTokens = {
  wclo: WCLO[ChainId.CALLISTO],
  usdt: USDT_CALLISTO,
  dona: DONA_CALLISTO,
  mockB: new ERC20Token(ChainId.CALLISTO, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.CALLISTO, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var callistoTestnetTokens = {
  wclo: WCLO[ChainId.CALLISTO_TESTNET],
  usdt: USDT_CALLISTO_TESTNET,
  dona: DONA_CALLISTO_TESTNET,
  mockB: new ERC20Token(ChainId.CALLISTO_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.CALLISTO_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var evmosTokens = {
  wevmos: WEVMOS[ChainId.EVMOS],
  usdt: USDT_EVMOS,
  dona: DONA_EVMOS,
  mockB: new ERC20Token(ChainId.EVMOS, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.EVMOS, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var evmosTestnetTokens = {
  wevmos: WEVMOS[ChainId.EVMOS_TESTNET],
  usdt: USDT_EVMOS_TESTNET,
  dona: DONA_EVMOS_TESTNET,
  mockB: new ERC20Token(ChainId.EVMOS_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.EVMOS_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var energyWebchainTokens = {
  wewt: WEWT[ChainId.ENERGY_WEB_CHAIN],
  usdt: USDT_ENERGY_WEB_CHAIN,
  dona: DONA_ENERGY_WEB_CHAIN,
  mockB: new ERC20Token(ChainId.ENERGY_WEB_CHAIN, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.ENERGY_WEB_CHAIN, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var energyVoltaTokens = {
  wewt: WEWT[ChainId.ENERGY_VOLTA],
  usdt: USDT_ENERGY_VOLTA,
  dona: DONA_ENERGY_VOLTA,
  mockB: new ERC20Token(ChainId.ENERGY_VOLTA, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.ENERGY_VOLTA, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var baseTokens = {
  weth: WETH9[ChainId.BASE],
  usdt: USDT_BASE,
  dona: DONA_BASE,
  mockB: new ERC20Token(ChainId.BASE, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.BASE, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var baseGoerliTokens = {
  weth: WETH9[ChainId.BASE_GOERLI],
  usdt: USDT_BASE_GOERLI,
  dona: DONA_BASE_GOERLI,
  mockB: new ERC20Token(ChainId.BASE_GOERLI, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.BASE_GOERLI, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var kavaTokens = {
  wkava: WKAVA[ChainId.KAVA],
  usdt: USDT_KAVA,
  dona: DONA_KAVA,
  mockB: new ERC20Token(ChainId.KAVA, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.KAVA, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var kavaTestnetTokens = {
  wkava: WKAVA[ChainId.KAVA_TESTNET],
  usdt: USDT_KAVA_TESTNET,
  dona: DONA_KAVA_TESTNET,
  mockB: new ERC20Token(ChainId.KAVA_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.KAVA_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var cloverTokens = {
  wclv: WCLV[ChainId.CLOVER],
  usdt: USDT_CLOVER,
  dona: DONA_CLOVER,
  mockB: new ERC20Token(ChainId.CLOVER, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.CLOVER, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var cloverTestnetTokens = {
  wclv: WCLV[ChainId.CLOVER_TESTNET],
  usdt: USDT_CLOVER_TESTNET,
  dona: DONA_CLOVER_TESTNET,
  mockB: new ERC20Token(ChainId.CLOVER_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.CLOVER_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var defichainTokens = {
  wdfi: WDFI[ChainId.DEFICHAIN],
  usdt: USDT_DEFICHAIN,
  dona: DONA_DEFICHAIN,
  mockB: new ERC20Token(ChainId.DEFICHAIN, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.DEFICHAIN, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var defichainTestnetTokens = {
  wdfi: WDFI[ChainId.DEFICHAIN_TESTNET],
  usdt: USDT_DEFICHAIN_TESTNET,
  dona: DONA_DEFICHAIN_TESTNET,
  mockB: new ERC20Token(ChainId.DEFICHAIN_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.DEFICHAIN_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var bronosTokens = {
  wbro: WBRO[ChainId.BRONOS],
  usdt: USDT_BRONOS,
  dona: DONA_BRONOS,
  mockB: new ERC20Token(ChainId.BRONOS, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.BRONOS, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var bronosTestnetTokens = {
  wbro: WBRO[ChainId.BRONOS_TESTNET],
  usdt: USDT_BRONOS_TESTNET,
  dona: DONA_BRONOS_TESTNET,
  mockB: new ERC20Token(ChainId.BRONOS_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.BRONOS_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var filecoinTokens = {
  wfil: WFIL[ChainId.FILECOIN],
  usdt: USDT_FILECOIN,
  dona: DONA_FILECOIN,
  mockB: new ERC20Token(ChainId.FILECOIN, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.FILECOIN, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var filecoinCalibrationTokens = {
  wfil: WFIL[ChainId.FILECOIN_CALIBRATION],
  usdt: USDT_FILECOIN_CALIBRATION,
  dona: DONA_FILECOIN_CALIBRATION,
  mockB: new ERC20Token(ChainId.FILECOIN_CALIBRATION, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.FILECOIN_CALIBRATION, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var flareTokens = {
  wflr: WFLR[ChainId.FLARE],
  usdt: USDT_FLARE,
  dona: DONA_FLARE,
  mockB: new ERC20Token(ChainId.FLARE, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.FLARE, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var flareTestnetTokens = {
  wflr: WFLR[ChainId.FLARE_TESTNET],
  usdt: USDT_FLARE_TESTNET,
  dona: DONA_FLARE_TESTNET,
  mockB: new ERC20Token(ChainId.FLARE_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.FLARE_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var taraxaTokens = {
  wtara: WTARA[ChainId.TARAXA],
  usdt: USDT_TARAXA,
  dona: DONA_TARAXA,
  mockB: new ERC20Token(ChainId.TARAXA, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.TARAXA, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var taraxaTestnetTokens = {
  wtara: WTARA[ChainId.TARAXA_TESTNET],
  usdt: USDT_TARAXA_TESTNET,
  dona: DONA_TARAXA_TESTNET,
  mockB: new ERC20Token(ChainId.TARAXA_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.TARAXA_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var zksyncTokens = {
  dona: DONA[ChainId.ZKSYNC],
  weth: WETH9[ChainId.ZKSYNC],
  usdc: USDC[ChainId.ZKSYNC],
  usdt: USDT_ZKSYNC
  // dona: DONA_ZKSYNC,
};
var zkSyncTestnetTokens = {
  dona: DONA[ChainId.ZKSYNC_TESTNET],
  weth: WETH9[ChainId.ZKSYNC_TESTNET],
  usdc: USDC[ChainId.ZKSYNC_TESTNET],
  usdt: USDT_ZKSYNC_TESTNET
};
var polygonZkEvmTokens = {
  weth: WETH9[ChainId.POLYGON_ZKEVM],
  usdc: USDC[ChainId.POLYGON_ZKEVM],
  usdt: USDT[ChainId.POLYGON_ZKEVM],
  dona: DONA[ChainId.POLYGON_ZKEVM]
};
var polygonZkEvmTestnetTokens = {
  weth: WETH9[ChainId.POLYGON_ZKEVM_TESTNET],
  usdt: USDT[ChainId.POLYGON_ZKEVM_TESTNET],
  dona: DONA[ChainId.POLYGON_ZKEVM_TESTNET]
};
var lineaTestnetTokens = {
  weth: WETH9[ChainId.LINEA_TESTNET],
  usdc: USDC[ChainId.LINEA_TESTNET],
  dona: DONA_LINEA_TESTNET
};
var lineaTokens = {
  weth: WETH9[ChainId.LINEA],
  usdc: USDC[ChainId.LINEA_TESTNET],
  dona: DONA_LINEA,
  mockB: new ERC20Token(ChainId.LINEA, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.LINEA, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var opBnbTokens = {
  wbnb: WBNB[ChainId.OP_BNB],
  usdt: USDT_OP_BNB,
  dona: DONA_OP_BNB,
  mockB: new ERC20Token(ChainId.OP_BNB, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.OP_BNB, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var opBnbTestnetTokens = {
  wbnb: WBNB[ChainId.OP_BNB_TESTNET],
  usdt: USDT_OP_BNB_TESTNET,
  dona: DONA_OP_BNB_TESTNET,
  mockB: new ERC20Token(ChainId.OP_BNB_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.OP_BNB_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var bobaAvaxTokens = {
  wboba: WBOBA[ChainId.BOBA_AVAX],
  usdt: USDT_BOBA_AVAX,
  dona: DONA_BOBA_AVAX,
  mockB: new ERC20Token(ChainId.BOBA_AVAX, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.BOBA_AVAX, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var bobaBnbTokens = {
  wboba: WBOBA[ChainId.BOBA_BNB],
  usdt: USDT_BOBA_BNB,
  dona: DONA_BOBA_BNB,
  mockB: new ERC20Token(ChainId.BOBA_BNB, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.BOBA_BNB, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var bttchainTokens = {
  wbtt: WBTT[ChainId.BTTCHAIN],
  usdt: USDT_BTTCHAIN,
  dona: DONA_BTTCHAIN,
  mockB: new ERC20Token(ChainId.BTTCHAIN, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.BTTCHAIN, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var bttchainTestnetTokens = {
  wbtt: WBTT[ChainId.BTTCHAIN_TESTNET],
  usdt: USDT_BTTCHAIN_TESTNET,
  dona: DONA_BTTCHAIN_TESTNET,
  mockB: new ERC20Token(ChainId.BTTCHAIN_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.BTTCHAIN_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var cmpTokens = {
  wcmp: WCMP[ChainId.CMP],
  usdt: USDT_CMP,
  dona: DONA_CMP,
  mockB: new ERC20Token(ChainId.CMP, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.CMP, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var cmpTestnetTokens = {
  wcmp: WCMP[ChainId.CMP_TESTNET],
  usdt: USDT_CMP_TESTNET,
  dona: DONA_CMP_TESTNET,
  mockB: new ERC20Token(ChainId.CMP_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.CMP_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var coreTestnetTokens = {
  wcore: WCORE[ChainId.CORE_TESTNET],
  usdt: USDT_CORE_TESTNET,
  dona: DONA_CORE_TESTNET,
  mockB: new ERC20Token(ChainId.CORE_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.CORE_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var coreTokens = {
  wcore: WCORE[ChainId.CORE],
  usdt: USDT_CORE,
  dona: DONA_CORE,
  mockB: new ERC20Token(ChainId.CORE, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.CORE, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var cubechainTokens = {
  wcube: WCUBE[ChainId.CUBECHAIN],
  usdt: USDT_CUBECHAIN,
  dona: DONA_CUBECHAIN,
  mockB: new ERC20Token(ChainId.CUBECHAIN, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.CUBECHAIN, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var cubechainTestnetTokens = {
  wcube: WCUBE[ChainId.CUBECHAIN_TESTNET],
  usdt: USDT_CUBECHAIN_TESTNET,
  dona: DONA_CUBECHAIN_TESTNET,
  mockB: new ERC20Token(ChainId.CUBECHAIN_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.CUBECHAIN_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var darwiniaCrabTokens = {
  wcrab: WCRAB[ChainId.DARWINIA_CRAB],
  usdt: USDT_DARWINIA_CRAB,
  dona: DONA_DARWINIA_CRAB,
  mockB: new ERC20Token(ChainId.DARWINIA_CRAB, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.DARWINIA_CRAB, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var darwiniaPangolinTokens = {
  wpring: WPRING[ChainId.DARWINIA_PANGOLIN],
  usdt: USDT_DARWINIA_PANGOLIN,
  dona: DONA_DARWINIA_PANGOLIN,
  mockB: new ERC20Token(ChainId.DARWINIA_PANGOLIN, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.DARWINIA_PANGOLIN, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var diodePretnetTokens = {
  wdiode: WDIODE[ChainId.DIODE_PRETNET],
  usdt: USDT_DIODE_PRETNET,
  dona: DONA_DIODE_PRETNET,
  mockB: new ERC20Token(ChainId.DIODE_PRETNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.DIODE_PRETNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var diodeTestnetTokens = {
  wdiode: WDIODE[ChainId.DIODE_TESTNET],
  usdt: USDT_DIODE_TESTNET,
  dona: DONA_DIODE_TESTNET,
  mockB: new ERC20Token(ChainId.DIODE_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.DIODE_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var gochainTokens = {
  wgo: WGO[ChainId.GOCHAIN],
  usdt: USDT_GOCHAIN,
  dona: DONA_GOCHAIN,
  mockB: new ERC20Token(ChainId.GOCHAIN, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.GOCHAIN, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var gochainTestnetTokens = {
  wgo: WGO[ChainId.GOCHAIN_TESTNET],
  usdt: USDT_GOCHAIN_TESTNET,
  dona: DONA_GOCHAIN_TESTNET,
  mockB: new ERC20Token(ChainId.GOCHAIN_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.GOCHAIN_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var haqqTokens = {
  wislm: WISLM[ChainId.HAQQ],
  usdt: USDT_HAQQ,
  dona: DONA_HAQQ,
  mockB: new ERC20Token(ChainId.HAQQ, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.HAQQ, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var haqqTestedgeTokens = {
  wislm: WISLM[ChainId.HAQQ_TESTEDGE2],
  usdt: USDT_HAQQ_TESTEDGE2,
  dona: DONA_HAQQ_TESTEDGE2,
  mockB: new ERC20Token(ChainId.HAQQ_TESTEDGE2, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.HAQQ_TESTEDGE2, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var kardiachainTokens = {
  wkai: WKAI[ChainId.KARDIACHAIN],
  usdt: USDT_KARDIACHAIN,
  dona: DONA_KARDIACHAIN,
  mockB: new ERC20Token(ChainId.KARDIACHAIN, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.KARDIACHAIN, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var kardiachainTestnetTokens = {
  wkai: WKAI[ChainId.KARDIACHAIN_TESTNET],
  usdt: USDT_KARDIACHAIN_TESTNET,
  dona: DONA_KARDIACHAIN_TESTNET,
  mockB: new ERC20Token(ChainId.KARDIACHAIN_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.KARDIACHAIN_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var metadiumTokens = {
  wmeta: WMETA[ChainId.METADIUM],
  usdt: USDT_METADIUM,
  dona: DONA_METADIUM,
  mockB: new ERC20Token(ChainId.METADIUM, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.METADIUM, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var metadiumTestnetTokens = {
  wkal: WKAL[ChainId.METADIUM_TESTNET],
  usdt: USDT_METADIUM_TESTNET,
  dona: DONA_METADIUM_TESTNET,
  mockB: new ERC20Token(ChainId.METADIUM_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.METADIUM_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var palmTokens = {
  wpalm: WPALM[ChainId.PALM],
  usdt: USDT_PALM,
  dona: DONA_PALM,
  mockB: new ERC20Token(ChainId.PALM, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.PALM, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var palmTestnetTokens = {
  wpalm: WPALM[ChainId.PALM_TESTNET],
  usdt: USDT_PALM_TESTNET,
  dona: DONA_PALM_TESTNET,
  mockB: new ERC20Token(ChainId.PALM_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.PALM_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var polisTokens = {
  wpolis: WPOLIS[ChainId.POLIS_TESTNET],
  usdt: USDT_POLIS_TESTNET,
  dona: DONA_POLIS_TESTNET,
  mockB: new ERC20Token(ChainId.POLIS_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.POLIS_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var polisTestnetTokens = {
  wpolis: WPOLIS[ChainId.POLIS],
  usdt: USDT_POLIS,
  dona: DONA_POLIS,
  mockB: new ERC20Token(ChainId.POLIS, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.POLIS, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var shibachainTokens = {
  wshib: WSHIB[ChainId.SHIBACHAIN],
  usdt: USDT_SHIBACHAIN,
  dona: DONA_SHIBACHAIN,
  mockB: new ERC20Token(ChainId.SHIBACHAIN, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.SHIBACHAIN, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var smartBchTokens = {
  wbch: WBCH[ChainId.SMART_BCH],
  usdt: USDT_SMART_BCH,
  dona: DONA_SMART_BCH,
  mockB: new ERC20Token(ChainId.SMART_BCH, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.SMART_BCH, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var smartBchTestnetTokens = {
  wbch: WBCH[ChainId.SMART_BCH_TESTNET],
  usdt: USDT_SMART_BCH_TESTNET,
  dona: DONA_SMART_BCH_TESTNET,
  mockB: new ERC20Token(ChainId.SMART_BCH_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.SMART_BCH_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var songbirdCanaryTokens = {
  wsgb: WSGB[ChainId.SONGBIRD_CANARY],
  usdt: USDT_SONGBIRD_CANARY,
  dona: DONA_SONGBIRD_CANARY,
  mockB: new ERC20Token(ChainId.SONGBIRD_CANARY, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.SONGBIRD_CANARY, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var thaichainTokens = {
  wtch: WTCH[ChainId.THAICHAIN],
  usdt: USDT_THAICHAIN,
  dona: DONA_THAICHAIN,
  mockB: new ERC20Token(ChainId.THAICHAIN, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.THAICHAIN, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var ubiqTokens = {
  wubq: WUBQ[ChainId.UBIQ],
  usdt: USDT_UBIQ,
  dona: DONA_UBIQ,
  mockB: new ERC20Token(ChainId.UBIQ, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.UBIQ, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var ubiqTestnetTokens = {
  wubq: WUBQ[ChainId.UBIQ_TESTNET],
  usdt: USDT_UBIQ_TESTNET,
  dona: DONA_UBIQ_TESTNET,
  mockB: new ERC20Token(ChainId.UBIQ_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.UBIQ_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var vechainTokens = {
  wvet: WVET[ChainId.VECHAIN],
  usdt: USDT_VECHAIN,
  dona: DONA_VECHAIN,
  mockB: new ERC20Token(ChainId.VECHAIN, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.VECHAIN, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var vechainTestnetTokens = {
  wvet: WVET[ChainId.VECHAIN_TESTNET],
  usdt: USDT_VECHAIN_TESTNET,
  dona: DONA_VECHAIN_TESTNET,
  mockB: new ERC20Token(ChainId.VECHAIN_TESTNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.VECHAIN_TESTNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var xinfinTokens = {
  wxdc: WXDC[ChainId.XINFIN],
  usdt: USDT_XINFIN,
  dona: DONA_XINFIN,
  mockB: new ERC20Token(ChainId.XINFIN, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.XINFIN, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var xinfinApothemTokens = {
  wxdc: WXDC[ChainId.XINFIN_APOTHEM],
  usdt: USDT_XINFIN_APOTHEM,
  dona: DONA_XINFIN_APOTHEM,
  mockB: new ERC20Token(ChainId.XINFIN_APOTHEM, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.XINFIN_APOTHEM, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var scrollTokens = {
  weth: WETH9[ChainId.SCROLL],
  usdt: USDT_SCROLL,
  dona: DONA_SCROLL,
  mockB: new ERC20Token(ChainId.SCROLL, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.SCROLL, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var scrollSepoliaTokens = {
  weth: WETH9[ChainId.SCROLL_SEPOLIA],
  usdt: USDT_SCROLL_SEPOLIA,
  dona: DONA_SCROLL_SEPOLIA,
  mockB: new ERC20Token(ChainId.SCROLL_SEPOLIA, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.SCROLL_SEPOLIA, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var xrplDevnetTokens = {
  wxrp: WXRP[ChainId.XRPL_DEVNET],
  usdt: USDT_XRPL_DEVNET,
  dona: DONA_XRPL_DEVNET,
  mockB: new ERC20Token(ChainId.XRPL_DEVNET, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.XRPL_DEVNET, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var zetachainTokens = {
  wzeta: WZETA[ChainId.ZETACHAIN],
  usdt: USDT_ZETACHAIN,
  dona: DONA_ZETACHAIN,
  mockB: new ERC20Token(ChainId.ZETACHAIN, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.ZETACHAIN, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var zetachainAthensTokens = {
  wzeta: WZETA[ChainId.ZETACHAIN_ATHENS],
  usdt: USDT_ZETACHAIN_ATHENS,
  dona: DONA_ZETACHAIN_ATHENS,
  mockB: new ERC20Token(ChainId.ZETACHAIN_ATHENS, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.ZETACHAIN_ATHENS, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};
var zyxTokens = {
  wzyx: WZYX[ChainId.ZYX],
  usdt: USDT_ZYX,
  dona: DONA_ZYX,
  mockB: new ERC20Token(ChainId.ZYX, "0xB8DA084D035C9c38518D86A9D079ba6A0Aec4327", 18, "MOCK B", "MOCK B"),
  mockA: new ERC20Token(ChainId.ZYX, "0xD134B434682dF091E398a844Dc3c613fe728cE2D", 18, "MOCK A", "MOCK A")
};

export { BUSD, BUSD_ALFAJORES, BUSD_AMOY, BUSD_ARBITRUM, BUSD_ARBITRUM_GOERLI, BUSD_ASTAR, BUSD_AURORA, BUSD_AURORA_TESTNET, BUSD_AVALANCHE, BUSD_BASE, BUSD_BASE_GOERLI, BUSD_BOBA, BUSD_BOBA_AVAX, BUSD_BOBA_BNB, BUSD_BOBA_GOERLI, BUSD_BRISECHAIN, BUSD_BRISECHAIN_TESTNET, BUSD_BRONOS, BUSD_BRONOS_TESTNET, BUSD_BSC, BUSD_BTTCHAIN, BUSD_BTTCHAIN_TESTNET, BUSD_CALLISTO, BUSD_CALLISTO_TESTNET, BUSD_CANTO, BUSD_CANTO_TESTNET, BUSD_CELO, BUSD_CLOVER, BUSD_CLOVER_TESTNET, BUSD_CMP, BUSD_CMP_TESTNET, BUSD_COINEX, BUSD_COINEX_TESTNET, BUSD_CONFLUX, BUSD_CONFLUX_TESTNET, BUSD_CORE, BUSD_CORE_TESTNET, BUSD_CRO, BUSD_CRO_TESTNET, BUSD_CUBECHAIN, BUSD_CUBECHAIN_TESTNET, BUSD_DARWINIA_CRAB, BUSD_DARWINIA_PANGOLIN, BUSD_DEFICHAIN, BUSD_DEFICHAIN_TESTNET, BUSD_DIODE_PRETNET, BUSD_DIODE_TESTNET, BUSD_DOGECHAIN, BUSD_DOGECHAIN_TESTNET, BUSD_ELASTOS, BUSD_ELASTOS_TESTNET, BUSD_ENERGY_VOLTA, BUSD_ENERGY_WEB_CHAIN, BUSD_ENGRAM_TESTNET, BUSD_ETH, BUSD_ETHEREUM_CLASSIC, BUSD_ETHEREUM_CLASSIC_TESTNET, BUSD_EVMOS, BUSD_EVMOS_TESTNET, BUSD_FANTOM_OPERA, BUSD_FANTOM_TESTNET, BUSD_FILECOIN, BUSD_FILECOIN_CALIBRATION, BUSD_FIRECHAIN, BUSD_FIRECHAIN_ZKEVM, BUSD_FIRECHAIN_ZKEVM_GHOSTRIDER, BUSD_FLARE, BUSD_FLARE_TESTNET, BUSD_FUJI, BUSD_FUSE, BUSD_FUSE_SPARKNET, BUSD_FUSION, BUSD_FUSION_TESTNET, BUSD_GNOSIS, BUSD_GNOSIS_CHIADO, BUSD_GOCHAIN, BUSD_GOCHAIN_TESTNET, BUSD_GODWOKEN, BUSD_GODWOKEN_TESTNET, BUSD_GOERLI, BUSD_HAQQ, BUSD_HAQQ_TESTEDGE2, BUSD_HARMONY, BUSD_HARMONY_TESTNET, BUSD_HECO, BUSD_HECO_TESTNET, BUSD_HOLESKY, BUSD_IOTEX, BUSD_IOTEX_TESTNET, BUSD_KARDIACHAIN, BUSD_KARDIACHAIN_TESTNET, BUSD_KAVA, BUSD_KAVA_TESTNET, BUSD_KCC, BUSD_KCC_TESTNET, BUSD_KEKCHAIN, BUSD_KEKCHAIN_TESTNET, BUSD_KLAYTN, BUSD_KLAYTN_BAOBAB, BUSD_LINEA, BUSD_LINEA_TESTNET, BUSD_METADIUM, BUSD_METADIUM_TESTNET, BUSD_METER, BUSD_METER_TESTNET, BUSD_METIS, BUSD_METIS_GOERLI, BUSD_MOONBASE_ALPHA, BUSD_MOONBEAM, BUSD_MOONRIVER, BUSD_MUUCHAIN, BUSD_MUUCHAIN_TESTNET, BUSD_OASIS_EMERALD, BUSD_OASIS_TESTNET, BUSD_OKXCHAIN, BUSD_OKXCHAIN_TESTNET, BUSD_OPTIMISM, BUSD_OPTIMISM_GOERLI, BUSD_OP_BNB, BUSD_OP_BNB_TESTNET, BUSD_PALM, BUSD_PALM_TESTNET, BUSD_POLIS, BUSD_POLIS_TESTNET, BUSD_POLYGON, BUSD_POLYGON_ZKEVM, BUSD_POLYGON_ZKEVM_TESTNET, BUSD_PULSECHAIN, BUSD_PULSECHAIN_TESTNET, BUSD_REI, BUSD_REI_TESTNET, BUSD_RINIA, BUSD_RSK, BUSD_RSK_TESTNET, BUSD_SCROLL, BUSD_SCROLL_SEPOLIA, BUSD_SEPOLIA, BUSD_SHIBACHAIN, BUSD_SHIBARIUM, BUSD_SHIBARIUM_TESTNET, BUSD_SHIBUNYA, BUSD_SHIDEN, BUSD_SMART_BCH, BUSD_SMART_BCH_TESTNET, BUSD_SONGBIRD_CANARY, BUSD_STEP, BUSD_STEP_TESTNET, BUSD_SYSCOIN, BUSD_SYSCOIN_TANENBAUM, BUSD_TARAXA, BUSD_TARAXA_TESTNET, BUSD_TELOS, BUSD_TELOS_TESTNET, BUSD_TESTNET, BUSD_THAICHAIN, BUSD_THETHA, BUSD_THETHA_TESTNET, BUSD_THUNDERCORE, BUSD_THUNDERCORE_TESTNET, BUSD_TOMOCHAIN, BUSD_TOMOCHAIN_TESTNET, BUSD_UBIQ, BUSD_UBIQ_TESTNET, BUSD_ULTRON, BUSD_ULTRON_TESTNET, BUSD_VECHAIN, BUSD_VECHAIN_TESTNET, BUSD_VELAS, BUSD_VELAS_TESTNET, BUSD_VISION, BUSD_VISION_TESTNET, BUSD_WANCHAIN, BUSD_WANCHAIN_TESTNET, BUSD_XEN, BUSD_XEN_DEVNET, BUSD_XINFIN, BUSD_XINFIN_APOTHEM, BUSD_XRPL_DEVNET, BUSD_ZETACHAIN, BUSD_ZETACHAIN_ATHENS, BUSD_ZKSYNC, BUSD_ZKSYNC_TESTNET, BUSD_ZYX, DONA, DONA_ALFAJORES, DONA_AMOY, DONA_ARBITRUM, DONA_ARBITRUM_GOERLI, DONA_ASTAR, DONA_AURORA, DONA_AURORA_TESTNET, DONA_AVALANCHE, DONA_BASE, DONA_BASE_GOERLI, DONA_BOBA, DONA_BOBA_AVAX, DONA_BOBA_BNB, DONA_BOBA_GOERLI, DONA_BRISECHAIN, DONA_BRISECHAIN_TESTNET, DONA_BRONOS, DONA_BRONOS_TESTNET, DONA_BSC, DONA_BTTCHAIN, DONA_BTTCHAIN_TESTNET, DONA_CALLISTO, DONA_CALLISTO_TESTNET, DONA_CANTO, DONA_CANTO_TESTNET, DONA_CELO, DONA_CLOVER, DONA_CLOVER_TESTNET, DONA_CMP, DONA_CMP_TESTNET, DONA_COINEX, DONA_COINEX_TESTNET, DONA_CONFLUX, DONA_CONFLUX_TESTNET, DONA_CORE, DONA_CORE_TESTNET, DONA_CRO, DONA_CRO_TESTNET, DONA_CUBECHAIN, DONA_CUBECHAIN_TESTNET, DONA_DARWINIA_CRAB, DONA_DARWINIA_PANGOLIN, DONA_DEFICHAIN, DONA_DEFICHAIN_TESTNET, DONA_DIODE_PRETNET, DONA_DIODE_TESTNET, DONA_DOGECHAIN, DONA_DOGECHAIN_TESTNET, DONA_ELASTOS, DONA_ELASTOS_TESTNET, DONA_ENERGY_VOLTA, DONA_ENERGY_WEB_CHAIN, DONA_ENGRAM_TESTNET, DONA_ETH, DONA_ETHEREUM_CLASSIC, DONA_ETHEREUM_CLASSIC_TESTNET, DONA_EVMOS, DONA_EVMOS_TESTNET, DONA_FANTOM_OPERA, DONA_FANTOM_TESTNET, DONA_FILECOIN, DONA_FILECOIN_CALIBRATION, DONA_FIRECHAIN, DONA_FIRECHAIN_ZKEVM, DONA_FIRECHAIN_ZKEVM_GHOSTRIDER, DONA_FLARE, DONA_FLARE_TESTNET, DONA_FUJI, DONA_FUSE, DONA_FUSE_SPARKNET, DONA_FUSION, DONA_FUSION_TESTNET, DONA_GNOSIS, DONA_GNOSIS_CHIADO, DONA_GOCHAIN, DONA_GOCHAIN_TESTNET, DONA_GODWOKEN, DONA_GODWOKEN_TESTNET, DONA_GOERLI, DONA_HAQQ, DONA_HAQQ_TESTEDGE2, DONA_HARMONY, DONA_HARMONY_TESTNET, DONA_HECO, DONA_HECO_TESTNET, DONA_HOLESKY, DONA_IOTEX, DONA_IOTEX_TESTNET, DONA_KARDIACHAIN, DONA_KARDIACHAIN_TESTNET, DONA_KAVA, DONA_KAVA_TESTNET, DONA_KCC, DONA_KCC_TESTNET, DONA_KEKCHAIN, DONA_KEKCHAIN_TESTNET, DONA_KLAYTN, DONA_KLAYTN_BAOBAB, DONA_LINEA, DONA_LINEA_TESTNET, DONA_METADIUM, DONA_METADIUM_TESTNET, DONA_METER, DONA_METER_TESTNET, DONA_METIS, DONA_METIS_GOERLI, DONA_MOONBASE_ALPHA, DONA_MOONBEAM, DONA_MOONRIVER, DONA_MUUCHAIN, DONA_MUUCHAIN_TESTNET, DONA_OASIS_EMERALD, DONA_OASIS_TESTNET, DONA_OKXCHAIN, DONA_OKXCHAIN_TESTNET, DONA_OPTIMISM, DONA_OPTIMISM_GOERLI, DONA_OP_BNB, DONA_OP_BNB_TESTNET, DONA_PALM, DONA_PALM_TESTNET, DONA_POLIS, DONA_POLIS_TESTNET, DONA_POLYGON, DONA_POLYGON_ZKEVM, DONA_POLYGON_ZKEVM_TESTNET, DONA_PULSECHAIN, DONA_PULSECHAIN_TESTNET, DONA_REI, DONA_REI_TESTNET, DONA_RINIA, DONA_RSK, DONA_RSK_TESTNET, DONA_SCROLL, DONA_SCROLL_SEPOLIA, DONA_SEPOLIA, DONA_SHIBACHAIN, DONA_SHIBARIUM, DONA_SHIBARIUM_TESTNET, DONA_SHIBUNYA, DONA_SHIDEN, DONA_SMART_BCH, DONA_SMART_BCH_TESTNET, DONA_SONGBIRD_CANARY, DONA_STEP, DONA_STEP_TESTNET, DONA_SYSCOIN, DONA_SYSCOIN_TANENBAUM, DONA_TARAXA, DONA_TARAXA_TESTNET, DONA_TELOS, DONA_TELOS_TESTNET, DONA_TESTNET, DONA_THAICHAIN, DONA_THETHA, DONA_THETHA_TESTNET, DONA_THUNDERCORE, DONA_THUNDERCORE_TESTNET, DONA_TOMOCHAIN, DONA_TOMOCHAIN_TESTNET, DONA_UBIQ, DONA_UBIQ_TESTNET, DONA_ULTRON, DONA_ULTRON_TESTNET, DONA_VECHAIN, DONA_VECHAIN_TESTNET, DONA_VELAS, DONA_VELAS_TESTNET, DONA_VISION, DONA_VISION_TESTNET, DONA_WANCHAIN, DONA_WANCHAIN_TESTNET, DONA_XEN, DONA_XEN_DEVNET, DONA_XINFIN, DONA_XINFIN_APOTHEM, DONA_XRPL_DEVNET, DONA_ZETACHAIN, DONA_ZETACHAIN_ATHENS, DONA_ZKSYNC, DONA_ZKSYNC_TESTNET, DONA_ZYX, EMPTY_LIST, FLAME, FLAME_ALFAJORES, FLAME_AMOY, FLAME_ARBITRUM, FLAME_ARBITRUM_GOERLI, FLAME_ASTAR, FLAME_AURORA, FLAME_AURORA_TESTNET, FLAME_AVALANCHE, FLAME_BASE, FLAME_BASE_GOERLI, FLAME_BOBA, FLAME_BOBA_AVAX, FLAME_BOBA_BNB, FLAME_BOBA_GOERLI, FLAME_BRISECHAIN, FLAME_BRISECHAIN_TESTNET, FLAME_BRONOS, FLAME_BRONOS_TESTNET, FLAME_BTTCHAIN, FLAME_BTTCHAIN_TESTNET, FLAME_CALLISTO, FLAME_CALLISTO_TESTNET, FLAME_CANTO, FLAME_CANTO_TESTNET, FLAME_CELO, FLAME_CLOVER, FLAME_CLOVER_TESTNET, FLAME_CMP, FLAME_CMP_TESTNET, FLAME_COINEX, FLAME_COINEX_TESTNET, FLAME_CONFLUX, FLAME_CONFLUX_TESTNET, FLAME_CORE, FLAME_CORE_TESTNET, FLAME_CRO, FLAME_CRO_TESTNET, FLAME_CUBECHAIN, FLAME_CUBECHAIN_TESTNET, FLAME_DARWINIA_CRAB, FLAME_DARWINIA_PANGOLIN, FLAME_DEFICHAIN, FLAME_DEFICHAIN_TESTNET, FLAME_DIODE_PRETNET, FLAME_DIODE_TESTNET, FLAME_DOGECHAIN, FLAME_DOGECHAIN_TESTNET, FLAME_ELASTOS, FLAME_ELASTOS_TESTNET, FLAME_ENERGY_VOLTA, FLAME_ENERGY_WEB_CHAIN, FLAME_ENGRAM_TESTNET, FLAME_ETH, FLAME_ETHEREUM_CLASSIC, FLAME_ETHEREUM_CLASSIC_TESTNET, FLAME_EVMOS, FLAME_EVMOS_TESTNET, FLAME_FANTOM_OPERA, FLAME_FANTOM_TESTNET, FLAME_FILECOIN, FLAME_FILECOIN_CALIBRATION, FLAME_FIRECHAIN, FLAME_FIRECHAIN_ZKEVM, FLAME_FIRECHAIN_ZKEVM_GHOSTRIDER, FLAME_FLARE, FLAME_FLARE_TESTNET, FLAME_FUJI, FLAME_FUSE, FLAME_FUSE_SPARKNET, FLAME_FUSION, FLAME_FUSION_TESTNET, FLAME_GNOSIS, FLAME_GNOSIS_CHIADO, FLAME_GOCHAIN, FLAME_GOCHAIN_TESTNET, FLAME_GODWOKEN, FLAME_GODWOKEN_TESTNET, FLAME_GOERLI, FLAME_HAQQ, FLAME_HAQQ_TESTEDGE2, FLAME_HARMONY, FLAME_HARMONY_TESTNET, FLAME_HECO, FLAME_HECO_TESTNET, FLAME_HOLESKY, FLAME_IOTEX, FLAME_IOTEX_TESTNET, FLAME_KARDIACHAIN, FLAME_KARDIACHAIN_TESTNET, FLAME_KAVA, FLAME_KAVA_TESTNET, FLAME_KCC, FLAME_KCC_TESTNET, FLAME_KEKCHAIN, FLAME_KEKCHAIN_TESTNET, FLAME_KLAYTN, FLAME_KLAYTN_BAOBAB, FLAME_LINEA, FLAME_LINEA_TESTNET, FLAME_MAINNET, FLAME_METADIUM, FLAME_METADIUM_TESTNET, FLAME_METER, FLAME_METER_TESTNET, FLAME_METIS, FLAME_METIS_GOERLI, FLAME_MOONBASE_ALPHA, FLAME_MOONBEAM, FLAME_MOONRIVER, FLAME_MUUCHAIN, FLAME_MUUCHAIN_TESTNET, FLAME_OASIS_EMERALD, FLAME_OASIS_TESTNET, FLAME_OKXCHAIN, FLAME_OKXCHAIN_TESTNET, FLAME_OPTIMISM, FLAME_OPTIMISM_GOERLI, FLAME_OP_BNB, FLAME_OP_BNB_TESTNET, FLAME_PALM, FLAME_PALM_TESTNET, FLAME_POLIS, FLAME_POLIS_TESTNET, FLAME_POLYGON, FLAME_POLYGON_ZKEVM, FLAME_POLYGON_ZKEVM_TESTNET, FLAME_PULSECHAIN, FLAME_PULSECHAIN_TESTNET, FLAME_REI, FLAME_REI_TESTNET, FLAME_RINIA, FLAME_RSK, FLAME_RSK_TESTNET, FLAME_SCROLL, FLAME_SCROLL_SEPOLIA, FLAME_SEPOLIA, FLAME_SHIBACHAIN, FLAME_SHIBARIUM, FLAME_SHIBARIUM_TESTNET, FLAME_SHIBUNYA, FLAME_SHIDEN, FLAME_SMART_BCH, FLAME_SMART_BCH_TESTNET, FLAME_SONGBIRD_CANARY, FLAME_STEP, FLAME_STEP_TESTNET, FLAME_SYSCOIN, FLAME_SYSCOIN_TANENBAUM, FLAME_TARAXA, FLAME_TARAXA_TESTNET, FLAME_TELOS, FLAME_TELOS_TESTNET, FLAME_TESTNET, FLAME_THAICHAIN, FLAME_THETHA, FLAME_THETHA_TESTNET, FLAME_THUNDERCORE, FLAME_THUNDERCORE_TESTNET, FLAME_TOMOCHAIN, FLAME_TOMOCHAIN_TESTNET, FLAME_UBIQ, FLAME_UBIQ_TESTNET, FLAME_ULTRON, FLAME_ULTRON_TESTNET, FLAME_VECHAIN, FLAME_VECHAIN_TESTNET, FLAME_VELAS, FLAME_VELAS_TESTNET, FLAME_VISION, FLAME_VISION_TESTNET, FLAME_WANCHAIN, FLAME_WANCHAIN_TESTNET, FLAME_XEN, FLAME_XEN_DEVNET, FLAME_XINFIN, FLAME_XINFIN_APOTHEM, FLAME_XRPL_DEVNET, FLAME_ZETACHAIN, FLAME_ZETACHAIN_ATHENS, FLAME_ZKSYNC, FLAME_ZKSYNC_TESTNET, FLAME_ZYX, STABLE_COIN, USDC, USDC_BSC, USDC_ETH, USDC_GOERLI, USDC_TESTNET, USDT, USDT_ALFAJORES, USDT_AMOY, USDT_ARBITRUM, USDT_ARBITRUM_GOERLI, USDT_ASTAR, USDT_AURORA, USDT_AURORA_TESTNET, USDT_AVALANCHE, USDT_BASE, USDT_BASE_GOERLI, USDT_BOBA, USDT_BOBA_AVAX, USDT_BOBA_BNB, USDT_BOBA_GOERLI, USDT_BRISECHAIN, USDT_BRISECHAIN_TESTNET, USDT_BRONOS, USDT_BRONOS_TESTNET, USDT_BSC, USDT_BTTCHAIN, USDT_BTTCHAIN_TESTNET, USDT_CALLISTO, USDT_CALLISTO_TESTNET, USDT_CANTO, USDT_CANTO_TESTNET, USDT_CELO, USDT_CLOVER, USDT_CLOVER_TESTNET, USDT_CMP, USDT_CMP_TESTNET, USDT_COINEX, USDT_COINEX_TESTNET, USDT_CONFLUX, USDT_CONFLUX_TESTNET, USDT_CORE, USDT_CORE_TESTNET, USDT_CRO, USDT_CRO_TESTNET, USDT_CUBECHAIN, USDT_CUBECHAIN_TESTNET, USDT_DARWINIA_CRAB, USDT_DARWINIA_PANGOLIN, USDT_DEFICHAIN, USDT_DEFICHAIN_TESTNET, USDT_DIODE_PRETNET, USDT_DIODE_TESTNET, USDT_DOGECHAIN, USDT_DOGECHAIN_TESTNET, USDT_ELASTOS, USDT_ELASTOS_TESTNET, USDT_ENERGY_VOLTA, USDT_ENERGY_WEB_CHAIN, USDT_ENGRAM_TESTNET, USDT_ETH, USDT_ETHEREUM_CLASSIC, USDT_ETHEREUM_CLASSIC_TESTNET, USDT_EVMOS, USDT_EVMOS_TESTNET, USDT_FANTOM_OPERA, USDT_FANTOM_TESTNET, USDT_FILECOIN, USDT_FILECOIN_CALIBRATION, USDT_FIRECHAIN, USDT_FIRECHAIN_ZKEVM, USDT_FIRECHAIN_ZKEVM_GHOSTRIDER, USDT_FLARE, USDT_FLARE_TESTNET, USDT_FUJI, USDT_FUSE, USDT_FUSE_SPARKNET, USDT_FUSION, USDT_FUSION_TESTNET, USDT_GNOSIS, USDT_GNOSIS_CHIADO, USDT_GOCHAIN, USDT_GOCHAIN_TESTNET, USDT_GODWOKEN, USDT_GODWOKEN_TESTNET, USDT_HAQQ, USDT_HAQQ_TESTEDGE2, USDT_HARMONY, USDT_HARMONY_TESTNET, USDT_HECO, USDT_HECO_TESTNET, USDT_HOLESKY, USDT_IOTEX, USDT_IOTEX_TESTNET, USDT_KARDIACHAIN, USDT_KARDIACHAIN_TESTNET, USDT_KAVA, USDT_KAVA_TESTNET, USDT_KCC, USDT_KCC_TESTNET, USDT_KEKCHAIN, USDT_KEKCHAIN_TESTNET, USDT_KLAYTN, USDT_KLAYTN_BAOBAB, USDT_LINEA, USDT_LINEA_TESTNET, USDT_METADIUM, USDT_METADIUM_TESTNET, USDT_METER, USDT_METER_TESTNET, USDT_METIS, USDT_METIS_GOERLI, USDT_MOONBASE_ALPHA, USDT_MOONBEAM, USDT_MOONRIVER, USDT_MUUCHAIN, USDT_MUUCHAIN_TESTNET, USDT_OASIS_EMERALD, USDT_OASIS_TESTNET, USDT_OKXCHAIN, USDT_OKXCHAIN_TESTNET, USDT_OPTIMISM, USDT_OPTIMISM_GOERLI, USDT_OP_BNB, USDT_OP_BNB_TESTNET, USDT_PALM, USDT_PALM_TESTNET, USDT_POLIS, USDT_POLIS_TESTNET, USDT_POLYGON, USDT_POLYGON_ZKEVM, USDT_POLYGON_ZKEVM_TESTNET, USDT_PULSECHAIN, USDT_PULSECHAIN_TESTNET, USDT_REI, USDT_REI_TESTNET, USDT_RINIA, USDT_RSK, USDT_RSK_TESTNET, USDT_SCROLL, USDT_SCROLL_SEPOLIA, USDT_SEPOLIA, USDT_SHIBACHAIN, USDT_SHIBARIUM, USDT_SHIBARIUM_TESTNET, USDT_SHIBUNYA, USDT_SHIDEN, USDT_SMART_BCH, USDT_SMART_BCH_TESTNET, USDT_SONGBIRD_CANARY, USDT_STEP, USDT_STEP_TESTNET, USDT_SYSCOIN, USDT_SYSCOIN_TANENBAUM, USDT_TARAXA, USDT_TARAXA_TESTNET, USDT_TELOS, USDT_TELOS_TESTNET, USDT_THAICHAIN, USDT_THETHA, USDT_THETHA_TESTNET, USDT_THUNDERCORE, USDT_THUNDERCORE_TESTNET, USDT_TOMOCHAIN, USDT_TOMOCHAIN_TESTNET, USDT_UBIQ, USDT_UBIQ_TESTNET, USDT_ULTRON, USDT_ULTRON_TESTNET, USDT_VECHAIN, USDT_VECHAIN_TESTNET, USDT_VELAS, USDT_VELAS_TESTNET, USDT_VISION, USDT_VISION_TESTNET, USDT_WANCHAIN, USDT_WANCHAIN_TESTNET, USDT_XEN, USDT_XEN_DEVNET, USDT_XINFIN, USDT_XINFIN_APOTHEM, USDT_XRPL_DEVNET, USDT_ZETACHAIN, USDT_ZETACHAIN_ATHENS, USDT_ZKSYNC, USDT_ZKSYNC_TESTNET, USDT_ZYX, WBTC_ETH, arbitrumGoerliTokens, arbitrumTokens, astarTokens, auroraTestnetTokens, auroraTokens, avalancheFujiTokens, avalancheTokens, baseGoerliTokens, baseTokens, bobaAvaxTokens, bobaBnbTokens, bobaGoerliTokens, bobaTokens, brisechainTestnetTokens, brisechainTokens, bronosTestnetTokens, bronosTokens, bscTestnetTokens, bscTokens, bttchainTestnetTokens, bttchainTokens, callistoTestnetTokens, callistoTokens, cantoTestnetTokens, cantoTokens, celoAlfajoresTokens, celoTokens, cloverTestnetTokens, cloverTokens, cmpTestnetTokens, cmpTokens, coinExTestnetTokens, coinExTokens, confluxTestnetTokens, confluxTokens, coreTestnetTokens, coreTokens, cronosTestnetTokens, cronosTokens, cubechainTestnetTokens, cubechainTokens, darwiniaCrabTokens, darwiniaPangolinTokens, defichainTestnetTokens, defichainTokens, diodePretnetTokens, diodeTestnetTokens, dogechainTestnetTokens, dogechainTokens, elastosTestnetTokens, elastosTokens, energyVoltaTokens, energyWebchainTokens, engramTestnetTokens, etcTestnetTokens, etcTokens, ethereumTokens, evmosTestnetTokens, evmosTokens, fantomOperaTokens, fantomTestnetTokens, filecoinCalibrationTokens, filecoinTokens, firechainTokens, firechainZkevmGhostriderTokens, firechainZkevmTokens, flareTestnetTokens, flareTokens, fuseSparknetTokens, fuseTokens, fusionTestnetTokens, fusionTokens, gnosisChiadoTokens, gnosisTokens, gochainTestnetTokens, gochainTokens, godwokenTestnetTokens, godwokenTokens, goerliTestnetTokens, haqqTestedgeTokens, haqqTokens, harmonyTestnetTokens, harmonyTokens, hecoTestnetTokens, hecoTokens, holeskyTokens, iotexTestnetTokens, iotexTokens, kardiachainTestnetTokens, kardiachainTokens, kavaTestnetTokens, kavaTokens, kccTestnetTokens, kccTokens, kekchainTestnetTokens, kekchainTokens, klaytnBaobabTokens, klaytnCypressTokens, lineaTestnetTokens, lineaTokens, metadiumTestnetTokens, metadiumTokens, meterTestnetTokens, meterTokens, metisGoerliTokens, metisTokens, moonbaseAlphaTokens, moonbeamTokens, moonriverTokens, muuchainTestnetTokens, muuchainTokens, oasisEmeraldTokens, oasisTestnetTokens, okxChainTestnetTokens, okxChainTokens, opBnbTestnetTokens, opBnbTokens, optimismGoerliTokens, optimismTokens, palmTestnetTokens, palmTokens, polisTestnetTokens, polisTokens, polygonAmoyTokens, polygonTokens, polygonZkEvmTestnetTokens, polygonZkEvmTokens, pulsechainTestnetTokens, pulsechainTokens, reiTestnetTokens, reiTokens, riniaTokens, rskTestnetTokens, rskTokens, scrollSepoliaTokens, scrollTokens, sepoliaTokens, serializeTokens, shibachainTokens, shibariumTestnetTokens, shibariumTokens, shibunyaTokens, shidenTokens, smartBchTestnetTokens, smartBchTokens, songbirdCanaryTokens, stepTestnetTokens, stepTokens, syscoinTanenbaumTokens, syscoinTokens, taraxaTestnetTokens, taraxaTokens, telosTestnetTokens, telosTokens, thaichainTokens, thetaTestnetTokens, thetaTokens, thundercoreTestnetTokens, thundercoreTokens, tomochainTestnetTokens, tomochainTokens, ubiqTestnetTokens, ubiqTokens, ultronTestnetTokens, ultronTokens, vechainTestnetTokens, vechainTokens, velasTestnetTokens, velasTokens, visionTestnetTokens, visionTokens, wanchainTestnetTokens, wanchainTokens, xenDevnetTokens, xenTokens, xinfinApothemTokens, xinfinTokens, xrplDevnetTokens, zetachainAthensTokens, zetachainTokens, zkSyncTestnetTokens, zksyncTokens, zyxTokens };
